//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AutoPilotClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    queueProcessingAIRequest$(body: MultiProcessingStepBody | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/auto-pilot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueueProcessingAIRequest$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueueProcessingAIRequest$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQueueProcessingAIRequest$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IndexClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param caseGuid (optional) 
     * @return OK
     */
    synchronizeCaseIndex$(caseGuid: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/index/synchronize?";
        if (caseGuid === null)
            throw new Error("The parameter 'caseGuid' cannot be null.");
        else if (caseGuid !== undefined)
            url_ += "caseGuid=" + encodeURIComponent("" + caseGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeCaseIndex$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeCaseIndex$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynchronizeCaseIndex$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PilotClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param caseGuid (optional) 
     * @return OK
     */
    synchronizeKnowledgeBase$(caseGuid: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/pilot/synchronize?";
        if (caseGuid === null)
            throw new Error("The parameter 'caseGuid' cannot be null.");
        else if (caseGuid !== undefined)
            url_ += "caseGuid=" + encodeURIComponent("" + caseGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeKnowledgeBase$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeKnowledgeBase$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynchronizeKnowledgeBase$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generatePilotResponse$(body: PilotRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/pilot/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePilotResponse$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePilotResponse$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGeneratePilotResponse$(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPilotResponse$(body: PilotRequestStreamingRequest | undefined): Observable<PilotRequestStreamingResponse> {
        let url_ = this.baseUrl + "/api/v3/pilot/response";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPilotResponse$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPilotResponse$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PilotRequestStreamingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PilotRequestStreamingResponse>;
        }));
    }

    protected processGetPilotResponse$(response: HttpResponseBase): Observable<PilotRequestStreamingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PilotRequestStreamingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PilotRequestStreamingResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlatformClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getPlatformVersion$(): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/platform/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlatformVersion$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatformVersion$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPlatformVersion$(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCloudFront$(body: UpdateCloudFrontRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/platform/update-cloud-front";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCloudFront$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCloudFront$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCloudFront$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProcessingImage$(body: RequestProcessingImageCreationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/platform/request-processing-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProcessingImage$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProcessingImage$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProcessingImage$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    manageMessageHandling$(body: MessagingManagementRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/platform/manage-messaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManageMessageHandling$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManageMessageHandling$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processManageMessageHandling$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setServiceDesiredCount$(body: AdjustServiceCountRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/platform/set-service-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetServiceDesiredCount$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetServiceDesiredCount$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetServiceDesiredCount$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refreshService$(body: ServiceIdentifier | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/platform/refresh-service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshService$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshService$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshService$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RedactionAnnotationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    deleteNativeRedaction$(docId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/redaction-annotations/native/{docId}";
        if (docId === undefined || docId === null)
            throw new Error("The parameter 'docId' must be defined.");
        url_ = url_.replace("{docId}", encodeURIComponent("" + docId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNativeRedaction$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNativeRedaction$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNativeRedaction$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UploadBatchesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param uploadBatchId (optional) 
     * @return OK
     */
    deNISTUploadBatch$(uploadBatchId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/upload-batches/denist?";
        if (uploadBatchId === null)
            throw new Error("The parameter 'uploadBatchId' cannot be null.");
        else if (uploadBatchId !== undefined)
            url_ += "uploadBatchId=" + encodeURIComponent("" + uploadBatchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeNISTUploadBatch$(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeNISTUploadBatch$(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeNISTUploadBatch$(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AIRequestStreamingRequest implements IAIRequestStreamingRequest {
    workflowKey?: string | undefined;

    constructor(data?: IAIRequestStreamingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowKey = _data["workflowKey"];
        }
    }

    static fromJS(data: any): AIRequestStreamingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AIRequestStreamingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowKey"] = this.workflowKey;
        return data;
    }
}

export interface IAIRequestStreamingRequest {
    workflowKey?: string | undefined;
}

export class Account implements IAccount {
    accountId?: string;
    accountName?: string | undefined;
    accountComments?: string | undefined;
    accountLogoFilename?: string | undefined;
    message?: string | undefined;
    crmUrl?: string | undefined;
    type?: string | undefined;
    lifeCycle?: number;
    docSize?: number;
    indexSize?: number;
    productionJobSize?: number;
    downloadSize?: number;
    archiveJobSize?: number;
    isHibernated?: boolean;
    users?: User[] | undefined;
    cases?: Case[] | undefined;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.accountComments = _data["accountComments"];
            this.accountLogoFilename = _data["accountLogoFilename"];
            this.message = _data["message"];
            this.crmUrl = _data["crmUrl"];
            this.type = _data["type"];
            this.lifeCycle = _data["lifeCycle"];
            this.docSize = _data["docSize"];
            this.indexSize = _data["indexSize"];
            this.productionJobSize = _data["productionJobSize"];
            this.downloadSize = _data["downloadSize"];
            this.archiveJobSize = _data["archiveJobSize"];
            this.isHibernated = _data["isHibernated"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(Case.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["accountComments"] = this.accountComments;
        data["accountLogoFilename"] = this.accountLogoFilename;
        data["message"] = this.message;
        data["crmUrl"] = this.crmUrl;
        data["type"] = this.type;
        data["lifeCycle"] = this.lifeCycle;
        data["docSize"] = this.docSize;
        data["indexSize"] = this.indexSize;
        data["productionJobSize"] = this.productionJobSize;
        data["downloadSize"] = this.downloadSize;
        data["archiveJobSize"] = this.archiveJobSize;
        data["isHibernated"] = this.isHibernated;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccount {
    accountId?: string;
    accountName?: string | undefined;
    accountComments?: string | undefined;
    accountLogoFilename?: string | undefined;
    message?: string | undefined;
    crmUrl?: string | undefined;
    type?: string | undefined;
    lifeCycle?: number;
    docSize?: number;
    indexSize?: number;
    productionJobSize?: number;
    downloadSize?: number;
    archiveJobSize?: number;
    isHibernated?: boolean;
    users?: User[] | undefined;
    cases?: Case[] | undefined;
}

export class AccountConfig implements IAccountConfig {
    id?: string;
    value?: string | undefined;
    accountId?: string;
    accountConfigTypeId?: string;
    accountConfigType?: AccountConfigType;

    constructor(data?: IAccountConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.accountId = _data["accountId"];
            this.accountConfigTypeId = _data["accountConfigTypeId"];
            this.accountConfigType = _data["accountConfigType"] ? AccountConfigType.fromJS(_data["accountConfigType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AccountConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["accountId"] = this.accountId;
        data["accountConfigTypeId"] = this.accountConfigTypeId;
        data["accountConfigType"] = this.accountConfigType ? this.accountConfigType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountConfig {
    id?: string;
    value?: string | undefined;
    accountId?: string;
    accountConfigTypeId?: string;
    accountConfigType?: AccountConfigType;
}

export class AccountConfigType implements IAccountConfigType {
    id?: string;
    name?: string | undefined;
    dataType?: ConfigDataType;
    defaultValue?: string | undefined;

    constructor(data?: IAccountConfigType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): AccountConfigType {
        data = typeof data === 'object' ? data : {};
        let result = new AccountConfigType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IAccountConfigType {
    id?: string;
    name?: string | undefined;
    dataType?: ConfigDataType;
    defaultValue?: string | undefined;
}

export class AccountExportCommand implements IAccountExportCommand {
    accountId?: string;

    constructor(data?: IAccountExportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): AccountExportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AccountExportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IAccountExportCommand {
    accountId?: string;
}

export class AccountUsage implements IAccountUsage {
    logMonthString?: string | undefined;
    accountId?: string;
    caseId?: string | undefined;
    caseName?: string | undefined;
    docSize?: string | undefined;
    indexSize?: string | undefined;
    downloadSize?: string | undefined;
    productionJobSize?: string | undefined;
    archiveJobSize?: string | undefined;
    totalCaseSize?: string | undefined;

    constructor(data?: IAccountUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logMonthString = _data["logMonthString"];
            this.accountId = _data["accountId"];
            this.caseId = _data["caseId"];
            this.caseName = _data["caseName"];
            this.docSize = _data["docSize"];
            this.indexSize = _data["indexSize"];
            this.downloadSize = _data["downloadSize"];
            this.productionJobSize = _data["productionJobSize"];
            this.archiveJobSize = _data["archiveJobSize"];
            this.totalCaseSize = _data["totalCaseSize"];
        }
    }

    static fromJS(data: any): AccountUsage {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logMonthString"] = this.logMonthString;
        data["accountId"] = this.accountId;
        data["caseId"] = this.caseId;
        data["caseName"] = this.caseName;
        data["docSize"] = this.docSize;
        data["indexSize"] = this.indexSize;
        data["downloadSize"] = this.downloadSize;
        data["productionJobSize"] = this.productionJobSize;
        data["archiveJobSize"] = this.archiveJobSize;
        data["totalCaseSize"] = this.totalCaseSize;
        return data;
    }
}

export interface IAccountUsage {
    logMonthString?: string | undefined;
    accountId?: string;
    caseId?: string | undefined;
    caseName?: string | undefined;
    docSize?: string | undefined;
    indexSize?: string | undefined;
    downloadSize?: string | undefined;
    productionJobSize?: string | undefined;
    archiveJobSize?: string | undefined;
    totalCaseSize?: string | undefined;
}

export class AccountUser implements IAccountUser {
    userId?: string;
    userName?: string | undefined;
    accountName?: string | undefined;
    userType?: string;
    twoFactorEnabled?: boolean;
    message?: string | undefined;
    caseIds?: string[] | undefined;
    customFieldIds?: string[] | undefined;

    constructor(data?: IAccountUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.accountName = _data["accountName"];
            this.userType = _data["userType"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.message = _data["message"];
            if (Array.isArray(_data["caseIds"])) {
                this.caseIds = [] as any;
                for (let item of _data["caseIds"])
                    this.caseIds!.push(item);
            }
            if (Array.isArray(_data["customFieldIds"])) {
                this.customFieldIds = [] as any;
                for (let item of _data["customFieldIds"])
                    this.customFieldIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AccountUser {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["accountName"] = this.accountName;
        data["userType"] = this.userType;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["message"] = this.message;
        if (Array.isArray(this.caseIds)) {
            data["caseIds"] = [];
            for (let item of this.caseIds)
                data["caseIds"].push(item);
        }
        if (Array.isArray(this.customFieldIds)) {
            data["customFieldIds"] = [];
            for (let item of this.customFieldIds)
                data["customFieldIds"].push(item);
        }
        return data;
    }
}

export interface IAccountUser {
    userId?: string;
    userName?: string | undefined;
    accountName?: string | undefined;
    userType?: string;
    twoFactorEnabled?: boolean;
    message?: string | undefined;
    caseIds?: string[] | undefined;
    customFieldIds?: string[] | undefined;
}

export class AdjustServiceCountRequest implements IAdjustServiceCountRequest {
    identifier?: ServiceIdentifier;
    desiredCount?: number;

    constructor(data?: IAdjustServiceCountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"] ? ServiceIdentifier.fromJS(_data["identifier"]) : <any>undefined;
            this.desiredCount = _data["desiredCount"];
        }
    }

    static fromJS(data: any): AdjustServiceCountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustServiceCountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier ? this.identifier.toJSON() : <any>undefined;
        data["desiredCount"] = this.desiredCount;
        return data;
    }
}

export interface IAdjustServiceCountRequest {
    identifier?: ServiceIdentifier;
    desiredCount?: number;
}

export class AdminDownloadDocInfo implements IAdminDownloadDocInfo {
    docId?: string;
    docTitle?: string | undefined;
    caseId?: string;
    caseName?: string | undefined;
    accountId?: string;
    accountName?: string | undefined;
    docFiles?: AdminDownloadFileInfo[] | undefined;

    constructor(data?: IAdminDownloadDocInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.docTitle = _data["docTitle"];
            this.caseId = _data["caseId"];
            this.caseName = _data["caseName"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            if (Array.isArray(_data["docFiles"])) {
                this.docFiles = [] as any;
                for (let item of _data["docFiles"])
                    this.docFiles!.push(AdminDownloadFileInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminDownloadDocInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDownloadDocInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["docTitle"] = this.docTitle;
        data["caseId"] = this.caseId;
        data["caseName"] = this.caseName;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        if (Array.isArray(this.docFiles)) {
            data["docFiles"] = [];
            for (let item of this.docFiles)
                data["docFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdminDownloadDocInfo {
    docId?: string;
    docTitle?: string | undefined;
    caseId?: string;
    caseName?: string | undefined;
    accountId?: string;
    accountName?: string | undefined;
    docFiles?: AdminDownloadFileInfo[] | undefined;
}

export class AdminDownloadFileInfo implements IAdminDownloadFileInfo {
    fileId?: string;
    fileType?: number;
    lifecycle?: number;
    fileSize?: number;

    constructor(data?: IAdminDownloadFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileType = _data["fileType"];
            this.lifecycle = _data["lifecycle"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): AdminDownloadFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDownloadFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileType"] = this.fileType;
        data["lifecycle"] = this.lifecycle;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IAdminDownloadFileInfo {
    fileId?: string;
    fileType?: number;
    lifecycle?: number;
    fileSize?: number;
}

export enum AnnotationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _60 = 60,
}

export class ArchiveJob implements IArchiveJob {
    archiveJobId?: string;
    caseId?: string;
    createdById?: string;
    runById?: string | undefined;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    archiveBaseNumberStart?: number;
    archiveBaseNumberDigits?: number;
    isCreateTiff?: boolean;
    docSizeArchived?: number;
    lifeCycle?: number;
    status?: ArchiveJobStatus;
    totalDocCount?: number;
    archiveJobDocs?: ArchiveJobDoc[] | undefined;
    createdBy?: User;
    runBy?: User;

    constructor(data?: IArchiveJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archiveJobId = _data["archiveJobId"];
            this.caseId = _data["caseId"];
            this.createdById = _data["createdById"];
            this.runById = _data["runById"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeRun = _data["dateTimeRun"] ? new Date(_data["dateTimeRun"].toString()) : <any>undefined;
            this.archiveBaseNumberStart = _data["archiveBaseNumberStart"];
            this.archiveBaseNumberDigits = _data["archiveBaseNumberDigits"];
            this.isCreateTiff = _data["isCreateTiff"];
            this.docSizeArchived = _data["docSizeArchived"];
            this.lifeCycle = _data["lifeCycle"];
            this.status = _data["status"];
            this.totalDocCount = _data["totalDocCount"];
            if (Array.isArray(_data["archiveJobDocs"])) {
                this.archiveJobDocs = [] as any;
                for (let item of _data["archiveJobDocs"])
                    this.archiveJobDocs!.push(ArchiveJobDoc.fromJS(item));
            }
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            this.runBy = _data["runBy"] ? User.fromJS(_data["runBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArchiveJob {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archiveJobId"] = this.archiveJobId;
        data["caseId"] = this.caseId;
        data["createdById"] = this.createdById;
        data["runById"] = this.runById;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeRun"] = this.dateTimeRun ? this.dateTimeRun.toISOString() : <any>undefined;
        data["archiveBaseNumberStart"] = this.archiveBaseNumberStart;
        data["archiveBaseNumberDigits"] = this.archiveBaseNumberDigits;
        data["isCreateTiff"] = this.isCreateTiff;
        data["docSizeArchived"] = this.docSizeArchived;
        data["lifeCycle"] = this.lifeCycle;
        data["status"] = this.status;
        data["totalDocCount"] = this.totalDocCount;
        if (Array.isArray(this.archiveJobDocs)) {
            data["archiveJobDocs"] = [];
            for (let item of this.archiveJobDocs)
                data["archiveJobDocs"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["runBy"] = this.runBy ? this.runBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArchiveJob {
    archiveJobId?: string;
    caseId?: string;
    createdById?: string;
    runById?: string | undefined;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    archiveBaseNumberStart?: number;
    archiveBaseNumberDigits?: number;
    isCreateTiff?: boolean;
    docSizeArchived?: number;
    lifeCycle?: number;
    status?: ArchiveJobStatus;
    totalDocCount?: number;
    archiveJobDocs?: ArchiveJobDoc[] | undefined;
    createdBy?: User;
    runBy?: User;
}

export class ArchiveJobDoc implements IArchiveJobDoc {
    id?: string;
    caseId?: string;
    archiveJobId?: string;
    docId?: string;
    archiveNumberStart?: number;
    archiveNumberDigits?: number;
    archiveJob?: ArchiveJob;

    constructor(data?: IArchiveJobDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.archiveJobId = _data["archiveJobId"];
            this.docId = _data["docId"];
            this.archiveNumberStart = _data["archiveNumberStart"];
            this.archiveNumberDigits = _data["archiveNumberDigits"];
            this.archiveJob = _data["archiveJob"] ? ArchiveJob.fromJS(_data["archiveJob"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArchiveJobDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveJobDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["archiveJobId"] = this.archiveJobId;
        data["docId"] = this.docId;
        data["archiveNumberStart"] = this.archiveNumberStart;
        data["archiveNumberDigits"] = this.archiveNumberDigits;
        data["archiveJob"] = this.archiveJob ? this.archiveJob.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArchiveJobDoc {
    id?: string;
    caseId?: string;
    archiveJobId?: string;
    docId?: string;
    archiveNumberStart?: number;
    archiveNumberDigits?: number;
    archiveJob?: ArchiveJob;
}

export enum ArchiveJobStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Assembly implements IAssembly {
    readonly definedTypes?: TypeInfo[] | undefined;
    readonly exportedTypes?: Type[] | undefined;
    readonly codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    readonly fullName?: string | undefined;
    readonly imageRuntimeVersion?: string | undefined;
    readonly isDynamic?: boolean;
    readonly location?: string | undefined;
    readonly reflectionOnly?: boolean;
    readonly isCollectible?: boolean;
    readonly isFullyTrusted?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    readonly modules?: Module[] | undefined;
    readonly globalAssemblyCache?: boolean;
    readonly hostContext?: number;
    securityRuleSet?: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item.toJSON());
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes?: TypeInfo[] | undefined;
    exportedTypes?: Type[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic?: boolean;
    location?: string | undefined;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    modules?: Module[] | undefined;
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export class AuditState implements IAuditState {
    caseId?: string;
    docId?: string;
    userId?: string | undefined;
    userName?: string | undefined;
    auditDate?: Date;
    details?: string | undefined;
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IAuditState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.docId = _data["docId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.auditDate = _data["auditDate"] ? new Date(_data["auditDate"].toString()) : <any>undefined;
            this.details = _data["details"];
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): AuditState {
        data = typeof data === 'object' ? data : {};
        let result = new AuditState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["docId"] = this.docId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : <any>undefined;
        data["details"] = this.details;
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IAuditState {
    caseId?: string;
    docId?: string;
    userId?: string | undefined;
    userName?: string | undefined;
    auditDate?: Date;
    details?: string | undefined;
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class AuthorizationCodeModel implements IAuthorizationCodeModel {
    code?: string | undefined;

    constructor(data?: IAuthorizationCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AuthorizationCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IAuthorizationCodeModel {
    code?: string | undefined;
}

export class AuthorizationUrlModel implements IAuthorizationUrlModel {
    url?: string | undefined;

    constructor(data?: IAuthorizationUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AuthorizationUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IAuthorizationUrlModel {
    url?: string | undefined;
}

export class AutoRedactionJob implements IAutoRedactionJob {
    id?: string;
    caseId?: string;
    title?: string | undefined;
    createdById?: string;
    filterId?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    runStatus?: RunStatus;
    isDeleted?: boolean;
    processingDocCount?: number | undefined;
    redactedDocCount?: number | undefined;
    lastModified?: Date;
    autoRedactionRules?: AutoRedactionRule[] | undefined;
    case?: Case;

    constructor(data?: IAutoRedactionJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.createdById = _data["createdById"];
            this.filterId = _data["filterId"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeRun = _data["dateTimeRun"] ? new Date(_data["dateTimeRun"].toString()) : <any>undefined;
            this.runStatus = _data["runStatus"];
            this.isDeleted = _data["isDeleted"];
            this.processingDocCount = _data["processingDocCount"];
            this.redactedDocCount = _data["redactedDocCount"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            if (Array.isArray(_data["autoRedactionRules"])) {
                this.autoRedactionRules = [] as any;
                for (let item of _data["autoRedactionRules"])
                    this.autoRedactionRules!.push(AutoRedactionRule.fromJS(item));
            }
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AutoRedactionJob {
        data = typeof data === 'object' ? data : {};
        let result = new AutoRedactionJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["createdById"] = this.createdById;
        data["filterId"] = this.filterId;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeRun"] = this.dateTimeRun ? this.dateTimeRun.toISOString() : <any>undefined;
        data["runStatus"] = this.runStatus;
        data["isDeleted"] = this.isDeleted;
        data["processingDocCount"] = this.processingDocCount;
        data["redactedDocCount"] = this.redactedDocCount;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        if (Array.isArray(this.autoRedactionRules)) {
            data["autoRedactionRules"] = [];
            for (let item of this.autoRedactionRules)
                data["autoRedactionRules"].push(item.toJSON());
        }
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAutoRedactionJob {
    id?: string;
    caseId?: string;
    title?: string | undefined;
    createdById?: string;
    filterId?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    runStatus?: RunStatus;
    isDeleted?: boolean;
    processingDocCount?: number | undefined;
    redactedDocCount?: number | undefined;
    lastModified?: Date;
    autoRedactionRules?: AutoRedactionRule[] | undefined;
    case?: Case;
}

export class AutoRedactionRule implements IAutoRedactionRule {
    id?: string;
    autoRedactionJobId?: string;
    ruleTitle?: string | undefined;
    rulePattern?: string | undefined;
    redactionLabel?: string | undefined;
    presetType?: PresetType;
    redactionColorId?: string;
    isDeleted?: boolean;
    redactionCount?: number;
    docCount?: number;
    autoRedactionJob?: AutoRedactionJob;
    redactions?: Redaction[] | undefined;

    constructor(data?: IAutoRedactionRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.autoRedactionJobId = _data["autoRedactionJobId"];
            this.ruleTitle = _data["ruleTitle"];
            this.rulePattern = _data["rulePattern"];
            this.redactionLabel = _data["redactionLabel"];
            this.presetType = _data["presetType"];
            this.redactionColorId = _data["redactionColorId"];
            this.isDeleted = _data["isDeleted"];
            this.redactionCount = _data["redactionCount"];
            this.docCount = _data["docCount"];
            this.autoRedactionJob = _data["autoRedactionJob"] ? AutoRedactionJob.fromJS(_data["autoRedactionJob"]) : <any>undefined;
            if (Array.isArray(_data["redactions"])) {
                this.redactions = [] as any;
                for (let item of _data["redactions"])
                    this.redactions!.push(Redaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoRedactionRule {
        data = typeof data === 'object' ? data : {};
        let result = new AutoRedactionRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["autoRedactionJobId"] = this.autoRedactionJobId;
        data["ruleTitle"] = this.ruleTitle;
        data["rulePattern"] = this.rulePattern;
        data["redactionLabel"] = this.redactionLabel;
        data["presetType"] = this.presetType;
        data["redactionColorId"] = this.redactionColorId;
        data["isDeleted"] = this.isDeleted;
        data["redactionCount"] = this.redactionCount;
        data["docCount"] = this.docCount;
        data["autoRedactionJob"] = this.autoRedactionJob ? this.autoRedactionJob.toJSON() : <any>undefined;
        if (Array.isArray(this.redactions)) {
            data["redactions"] = [];
            for (let item of this.redactions)
                data["redactions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAutoRedactionRule {
    id?: string;
    autoRedactionJobId?: string;
    ruleTitle?: string | undefined;
    rulePattern?: string | undefined;
    redactionLabel?: string | undefined;
    presetType?: PresetType;
    redactionColorId?: string;
    isDeleted?: boolean;
    redactionCount?: number;
    docCount?: number;
    autoRedactionJob?: AutoRedactionJob;
    redactions?: Redaction[] | undefined;
}

export class AutoRedactionRuleViewModel implements IAutoRedactionRuleViewModel {
    id?: string;
    autoRedactionJobId?: string;
    ruleTitle?: string | undefined;
    rulePattern?: string | undefined;
    redactionLabel?: string | undefined;
    presetType?: PresetType;
    redactionColorId?: string;
    isDeleted?: boolean;
    redactionCount?: number;
    docCount?: number;

    constructor(data?: IAutoRedactionRuleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.autoRedactionJobId = _data["autoRedactionJobId"];
            this.ruleTitle = _data["ruleTitle"];
            this.rulePattern = _data["rulePattern"];
            this.redactionLabel = _data["redactionLabel"];
            this.presetType = _data["presetType"];
            this.redactionColorId = _data["redactionColorId"];
            this.isDeleted = _data["isDeleted"];
            this.redactionCount = _data["redactionCount"];
            this.docCount = _data["docCount"];
        }
    }

    static fromJS(data: any): AutoRedactionRuleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AutoRedactionRuleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["autoRedactionJobId"] = this.autoRedactionJobId;
        data["ruleTitle"] = this.ruleTitle;
        data["rulePattern"] = this.rulePattern;
        data["redactionLabel"] = this.redactionLabel;
        data["presetType"] = this.presetType;
        data["redactionColorId"] = this.redactionColorId;
        data["isDeleted"] = this.isDeleted;
        data["redactionCount"] = this.redactionCount;
        data["docCount"] = this.docCount;
        return data;
    }
}

export interface IAutoRedactionRuleViewModel {
    id?: string;
    autoRedactionJobId?: string;
    ruleTitle?: string | undefined;
    rulePattern?: string | undefined;
    redactionLabel?: string | undefined;
    presetType?: PresetType;
    redactionColorId?: string;
    isDeleted?: boolean;
    redactionCount?: number;
    docCount?: number;
}

export class BriefcaseJob implements IBriefcaseJob {
    briefcaseJobId?: string;
    caseId?: string;
    createdById?: string;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    customDesignation?: string | undefined;
    isControlNumberStampPages?: boolean;
    isBatesStampPages?: boolean;
    isDocIdStampPages?: boolean;
    titleType?: number;
    briefcaseSize?: number;
    lifeCycle?: LifeCycle;
    status?: number;
    controlNumberBasePrefix?: string | undefined;
    includeMergedPdfs?: boolean | undefined;
    shouldShareBriefcase?: boolean;
    createdBy?: User;
    briefcaseJobDocs?: BriefcaseJobDoc[] | undefined;
    briefcaseJobFiles?: BriefcaseJobFile[] | undefined;
    briefcaseJobShared?: BriefcaseJobShared[] | undefined;

    constructor(data?: IBriefcaseJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.briefcaseJobId = _data["briefcaseJobId"];
            this.caseId = _data["caseId"];
            this.createdById = _data["createdById"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.customDesignation = _data["customDesignation"];
            this.isControlNumberStampPages = _data["isControlNumberStampPages"];
            this.isBatesStampPages = _data["isBatesStampPages"];
            this.isDocIdStampPages = _data["isDocIdStampPages"];
            this.titleType = _data["titleType"];
            this.briefcaseSize = _data["briefcaseSize"];
            this.lifeCycle = _data["lifeCycle"];
            this.status = _data["status"];
            this.controlNumberBasePrefix = _data["controlNumberBasePrefix"];
            this.includeMergedPdfs = _data["includeMergedPdfs"];
            this.shouldShareBriefcase = _data["shouldShareBriefcase"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            if (Array.isArray(_data["briefcaseJobDocs"])) {
                this.briefcaseJobDocs = [] as any;
                for (let item of _data["briefcaseJobDocs"])
                    this.briefcaseJobDocs!.push(BriefcaseJobDoc.fromJS(item));
            }
            if (Array.isArray(_data["briefcaseJobFiles"])) {
                this.briefcaseJobFiles = [] as any;
                for (let item of _data["briefcaseJobFiles"])
                    this.briefcaseJobFiles!.push(BriefcaseJobFile.fromJS(item));
            }
            if (Array.isArray(_data["briefcaseJobShared"])) {
                this.briefcaseJobShared = [] as any;
                for (let item of _data["briefcaseJobShared"])
                    this.briefcaseJobShared!.push(BriefcaseJobShared.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BriefcaseJob {
        data = typeof data === 'object' ? data : {};
        let result = new BriefcaseJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["briefcaseJobId"] = this.briefcaseJobId;
        data["caseId"] = this.caseId;
        data["createdById"] = this.createdById;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["customDesignation"] = this.customDesignation;
        data["isControlNumberStampPages"] = this.isControlNumberStampPages;
        data["isBatesStampPages"] = this.isBatesStampPages;
        data["isDocIdStampPages"] = this.isDocIdStampPages;
        data["titleType"] = this.titleType;
        data["briefcaseSize"] = this.briefcaseSize;
        data["lifeCycle"] = this.lifeCycle;
        data["status"] = this.status;
        data["controlNumberBasePrefix"] = this.controlNumberBasePrefix;
        data["includeMergedPdfs"] = this.includeMergedPdfs;
        data["shouldShareBriefcase"] = this.shouldShareBriefcase;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        if (Array.isArray(this.briefcaseJobDocs)) {
            data["briefcaseJobDocs"] = [];
            for (let item of this.briefcaseJobDocs)
                data["briefcaseJobDocs"].push(item.toJSON());
        }
        if (Array.isArray(this.briefcaseJobFiles)) {
            data["briefcaseJobFiles"] = [];
            for (let item of this.briefcaseJobFiles)
                data["briefcaseJobFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.briefcaseJobShared)) {
            data["briefcaseJobShared"] = [];
            for (let item of this.briefcaseJobShared)
                data["briefcaseJobShared"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBriefcaseJob {
    briefcaseJobId?: string;
    caseId?: string;
    createdById?: string;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    customDesignation?: string | undefined;
    isControlNumberStampPages?: boolean;
    isBatesStampPages?: boolean;
    isDocIdStampPages?: boolean;
    titleType?: number;
    briefcaseSize?: number;
    lifeCycle?: LifeCycle;
    status?: number;
    controlNumberBasePrefix?: string | undefined;
    includeMergedPdfs?: boolean | undefined;
    shouldShareBriefcase?: boolean;
    createdBy?: User;
    briefcaseJobDocs?: BriefcaseJobDoc[] | undefined;
    briefcaseJobFiles?: BriefcaseJobFile[] | undefined;
    briefcaseJobShared?: BriefcaseJobShared[] | undefined;
}

export class BriefcaseJobDoc implements IBriefcaseJobDoc {
    briefcaseJobId?: string;
    docId?: string;
    caseId?: string;
    docIndex?: number;
    briefcaseDocTitle?: string | undefined;
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
    confidential?: boolean;
    useCustomDesignation?: boolean;

    constructor(data?: IBriefcaseJobDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.briefcaseJobId = _data["briefcaseJobId"];
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.docIndex = _data["docIndex"];
            this.briefcaseDocTitle = _data["briefcaseDocTitle"];
            this.batesPrefix = _data["batesPrefix"];
            this.batesNumberStart = _data["batesNumberStart"];
            this.batesNumberDigits = _data["batesNumberDigits"];
            this.confidential = _data["confidential"];
            this.useCustomDesignation = _data["useCustomDesignation"];
        }
    }

    static fromJS(data: any): BriefcaseJobDoc {
        data = typeof data === 'object' ? data : {};
        let result = new BriefcaseJobDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["briefcaseJobId"] = this.briefcaseJobId;
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["docIndex"] = this.docIndex;
        data["briefcaseDocTitle"] = this.briefcaseDocTitle;
        data["batesPrefix"] = this.batesPrefix;
        data["batesNumberStart"] = this.batesNumberStart;
        data["batesNumberDigits"] = this.batesNumberDigits;
        data["confidential"] = this.confidential;
        data["useCustomDesignation"] = this.useCustomDesignation;
        return data;
    }
}

export interface IBriefcaseJobDoc {
    briefcaseJobId?: string;
    docId?: string;
    caseId?: string;
    docIndex?: number;
    briefcaseDocTitle?: string | undefined;
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
    confidential?: boolean;
    useCustomDesignation?: boolean;
}

export class BriefcaseJobFile implements IBriefcaseJobFile {
    briefcaseJobId?: string;
    fileId?: string;
    fileType?: number | undefined;
    file?: FileLexbe;
    briefcaseJob?: BriefcaseJob;

    constructor(data?: IBriefcaseJobFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.briefcaseJobId = _data["briefcaseJobId"];
            this.fileId = _data["fileId"];
            this.fileType = _data["fileType"];
            this.file = _data["file"] ? FileLexbe.fromJS(_data["file"]) : <any>undefined;
            this.briefcaseJob = _data["briefcaseJob"] ? BriefcaseJob.fromJS(_data["briefcaseJob"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BriefcaseJobFile {
        data = typeof data === 'object' ? data : {};
        let result = new BriefcaseJobFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["briefcaseJobId"] = this.briefcaseJobId;
        data["fileId"] = this.fileId;
        data["fileType"] = this.fileType;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["briefcaseJob"] = this.briefcaseJob ? this.briefcaseJob.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBriefcaseJobFile {
    briefcaseJobId?: string;
    fileId?: string;
    fileType?: number | undefined;
    file?: FileLexbe;
    briefcaseJob?: BriefcaseJob;
}

export class BriefcaseJobShared implements IBriefcaseJobShared {
    sharedId?: string;
    briefcaseJobId?: string;
    downloadPassword?: string | undefined;
    expires?: Date | undefined;
    briefcaseJob?: BriefcaseJob;

    constructor(data?: IBriefcaseJobShared) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedId = _data["sharedId"];
            this.briefcaseJobId = _data["briefcaseJobId"];
            this.downloadPassword = _data["downloadPassword"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.briefcaseJob = _data["briefcaseJob"] ? BriefcaseJob.fromJS(_data["briefcaseJob"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BriefcaseJobShared {
        data = typeof data === 'object' ? data : {};
        let result = new BriefcaseJobShared();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedId"] = this.sharedId;
        data["briefcaseJobId"] = this.briefcaseJobId;
        data["downloadPassword"] = this.downloadPassword;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["briefcaseJob"] = this.briefcaseJob ? this.briefcaseJob.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBriefcaseJobShared {
    sharedId?: string;
    briefcaseJobId?: string;
    downloadPassword?: string | undefined;
    expires?: Date | undefined;
    briefcaseJob?: BriefcaseJob;
}

export class BuiltInDocField implements IBuiltInDocField {
    fieldId?: string;
    rank?: number;
    type?: number;
    displayTitle?: string | undefined;
    databaseTitle?: string | undefined;
    isPartOfDisplay?: boolean;
    isPartOfMultiDocEdit?: boolean;
    isPartOfCaseAssessment?: boolean;
    isPartOfLoadFile?: boolean;
    isLoadFileDefault?: boolean;
    path?: string | undefined;
    width?: number | undefined;
    displayType?: DisplayType;
    isDatMapOption?: boolean;
    isProductionSortOption?: boolean;

    constructor(data?: IBuiltInDocField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.rank = _data["rank"];
            this.type = _data["type"];
            this.displayTitle = _data["displayTitle"];
            this.databaseTitle = _data["databaseTitle"];
            this.isPartOfDisplay = _data["isPartOfDisplay"];
            this.isPartOfMultiDocEdit = _data["isPartOfMultiDocEdit"];
            this.isPartOfCaseAssessment = _data["isPartOfCaseAssessment"];
            this.isPartOfLoadFile = _data["isPartOfLoadFile"];
            this.isLoadFileDefault = _data["isLoadFileDefault"];
            this.path = _data["path"];
            this.width = _data["width"];
            this.displayType = _data["displayType"];
            this.isDatMapOption = _data["isDatMapOption"];
            this.isProductionSortOption = _data["isProductionSortOption"];
        }
    }

    static fromJS(data: any): BuiltInDocField {
        data = typeof data === 'object' ? data : {};
        let result = new BuiltInDocField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["rank"] = this.rank;
        data["type"] = this.type;
        data["displayTitle"] = this.displayTitle;
        data["databaseTitle"] = this.databaseTitle;
        data["isPartOfDisplay"] = this.isPartOfDisplay;
        data["isPartOfMultiDocEdit"] = this.isPartOfMultiDocEdit;
        data["isPartOfCaseAssessment"] = this.isPartOfCaseAssessment;
        data["isPartOfLoadFile"] = this.isPartOfLoadFile;
        data["isLoadFileDefault"] = this.isLoadFileDefault;
        data["path"] = this.path;
        data["width"] = this.width;
        data["displayType"] = this.displayType;
        data["isDatMapOption"] = this.isDatMapOption;
        data["isProductionSortOption"] = this.isProductionSortOption;
        return data;
    }
}

export interface IBuiltInDocField {
    fieldId?: string;
    rank?: number;
    type?: number;
    displayTitle?: string | undefined;
    databaseTitle?: string | undefined;
    isPartOfDisplay?: boolean;
    isPartOfMultiDocEdit?: boolean;
    isPartOfCaseAssessment?: boolean;
    isPartOfLoadFile?: boolean;
    isLoadFileDefault?: boolean;
    path?: string | undefined;
    width?: number | undefined;
    displayType?: DisplayType;
    isDatMapOption?: boolean;
    isProductionSortOption?: boolean;
}

export class BuiltInDocFieldPagingResponse implements IBuiltInDocFieldPagingResponse {
    value?: BuiltInDocField[] | undefined;
    count?: number | undefined;

    constructor(data?: IBuiltInDocFieldPagingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(BuiltInDocField.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): BuiltInDocFieldPagingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BuiltInDocFieldPagingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IBuiltInDocFieldPagingResponse {
    value?: BuiltInDocField[] | undefined;
    count?: number | undefined;
}

export class BulkDocAddRequest implements IBulkDocAddRequest {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    searchParameter?: SearchParameter;

    constructor(data?: IBulkDocAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.filterId = _data["filterId"];
            this.selectAll = _data["selectAll"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkDocAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkDocAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["filterId"] = this.filterId;
        data["selectAll"] = this.selectAll;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBulkDocAddRequest {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    searchParameter?: SearchParameter;
}

export class BulkDocDeleteRequest implements IBulkDocDeleteRequest {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    expandEmailFamily?: boolean;
    searchParameter?: SearchParameter;

    constructor(data?: IBulkDocDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.filterId = _data["filterId"];
            this.selectAll = _data["selectAll"];
            this.expandEmailFamily = _data["expandEmailFamily"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkDocDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkDocDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["filterId"] = this.filterId;
        data["selectAll"] = this.selectAll;
        data["expandEmailFamily"] = this.expandEmailFamily;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBulkDocDeleteRequest {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    expandEmailFamily?: boolean;
    searchParameter?: SearchParameter;
}

export class BulkExpandDocAddRequest implements IBulkExpandDocAddRequest {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    searchParameter?: SearchParameter;
    expandEmailFamily?: boolean;

    constructor(data?: IBulkExpandDocAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.filterId = _data["filterId"];
            this.selectAll = _data["selectAll"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
            this.expandEmailFamily = _data["expandEmailFamily"];
        }
    }

    static fromJS(data: any): BulkExpandDocAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkExpandDocAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["filterId"] = this.filterId;
        data["selectAll"] = this.selectAll;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        data["expandEmailFamily"] = this.expandEmailFamily;
        return data;
    }
}

export interface IBulkExpandDocAddRequest {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    searchParameter?: SearchParameter;
    expandEmailFamily?: boolean;
}

export class Calendar implements ICalendar {
    readonly minSupportedDateTime?: Date;
    readonly maxSupportedDateTime?: Date;
    algorithmType?: CalendarAlgorithmType;
    readonly isReadOnly?: boolean;
    readonly eras?: number[] | undefined;
    twoDigitYearMax?: number;

    constructor(data?: ICalendar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).minSupportedDateTime = _data["minSupportedDateTime"] ? new Date(_data["minSupportedDateTime"].toString()) : <any>undefined;
            (<any>this).maxSupportedDateTime = _data["maxSupportedDateTime"] ? new Date(_data["maxSupportedDateTime"].toString()) : <any>undefined;
            this.algorithmType = _data["algorithmType"];
            (<any>this).isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["eras"])) {
                (<any>this).eras = [] as any;
                for (let item of _data["eras"])
                    (<any>this).eras!.push(item);
            }
            this.twoDigitYearMax = _data["twoDigitYearMax"];
        }
    }

    static fromJS(data: any): Calendar {
        data = typeof data === 'object' ? data : {};
        let result = new Calendar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minSupportedDateTime"] = this.minSupportedDateTime ? this.minSupportedDateTime.toISOString() : <any>undefined;
        data["maxSupportedDateTime"] = this.maxSupportedDateTime ? this.maxSupportedDateTime.toISOString() : <any>undefined;
        data["algorithmType"] = this.algorithmType;
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.eras)) {
            data["eras"] = [];
            for (let item of this.eras)
                data["eras"].push(item);
        }
        data["twoDigitYearMax"] = this.twoDigitYearMax;
        return data;
    }
}

export interface ICalendar {
    minSupportedDateTime?: Date;
    maxSupportedDateTime?: Date;
    algorithmType?: CalendarAlgorithmType;
    isReadOnly?: boolean;
    eras?: number[] | undefined;
    twoDigitYearMax?: number;
}

export enum CalendarAlgorithmType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CalendarWeekRule {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CallingConventions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _32 = 32,
    _64 = 64,
}

export class Case implements ICase {
    caseId?: string;
    simpleCaseId?: string | undefined;
    caseName?: string | undefined;
    caseNumber?: string | undefined;
    caseType?: string | undefined;
    caseVenue?: string | undefined;
    leadAttorney?: string | undefined;
    trierOfFact?: string | undefined;
    caseComments?: string | undefined;
    customDesignation?: string | undefined;
    caseDocCount?: number;
    indexDocCount?: number;
    kbDocCount?: number;
    docSize?: number;
    productionJobSize?: number;
    archiveJobSize?: number;
    downloadSize?: number;
    indexSize?: number;
    accountId?: string;
    lifecycle?: number;
    createdById?: string;
    dateTimeCreated?: Date;
    fieldLayouts?: FieldLayout[] | undefined;
    facts?: Fact[] | undefined;
    issues?: Issue[] | undefined;
    docsInFacts?: DocsInFact[] | undefined;
    custodians?: Custodian[] | undefined;
    users?: User[] | undefined;
    docs?: Doc[] | undefined;
    caseConfigs?: CaseConfig[] | undefined;
    account?: Account;
    createdBy?: User;

    constructor(data?: ICase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.simpleCaseId = _data["simpleCaseId"];
            this.caseName = _data["caseName"];
            this.caseNumber = _data["caseNumber"];
            this.caseType = _data["caseType"];
            this.caseVenue = _data["caseVenue"];
            this.leadAttorney = _data["leadAttorney"];
            this.trierOfFact = _data["trierOfFact"];
            this.caseComments = _data["caseComments"];
            this.customDesignation = _data["customDesignation"];
            this.caseDocCount = _data["caseDocCount"];
            this.indexDocCount = _data["indexDocCount"];
            this.kbDocCount = _data["kbDocCount"];
            this.docSize = _data["docSize"];
            this.productionJobSize = _data["productionJobSize"];
            this.archiveJobSize = _data["archiveJobSize"];
            this.downloadSize = _data["downloadSize"];
            this.indexSize = _data["indexSize"];
            this.accountId = _data["accountId"];
            this.lifecycle = _data["lifecycle"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["fieldLayouts"])) {
                this.fieldLayouts = [] as any;
                for (let item of _data["fieldLayouts"])
                    this.fieldLayouts!.push(FieldLayout.fromJS(item));
            }
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(Fact.fromJS(item));
            }
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(Issue.fromJS(item));
            }
            if (Array.isArray(_data["docsInFacts"])) {
                this.docsInFacts = [] as any;
                for (let item of _data["docsInFacts"])
                    this.docsInFacts!.push(DocsInFact.fromJS(item));
            }
            if (Array.isArray(_data["custodians"])) {
                this.custodians = [] as any;
                for (let item of _data["custodians"])
                    this.custodians!.push(Custodian.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["docs"])) {
                this.docs = [] as any;
                for (let item of _data["docs"])
                    this.docs!.push(Doc.fromJS(item));
            }
            if (Array.isArray(_data["caseConfigs"])) {
                this.caseConfigs = [] as any;
                for (let item of _data["caseConfigs"])
                    this.caseConfigs!.push(CaseConfig.fromJS(item));
            }
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Case {
        data = typeof data === 'object' ? data : {};
        let result = new Case();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["simpleCaseId"] = this.simpleCaseId;
        data["caseName"] = this.caseName;
        data["caseNumber"] = this.caseNumber;
        data["caseType"] = this.caseType;
        data["caseVenue"] = this.caseVenue;
        data["leadAttorney"] = this.leadAttorney;
        data["trierOfFact"] = this.trierOfFact;
        data["caseComments"] = this.caseComments;
        data["customDesignation"] = this.customDesignation;
        data["caseDocCount"] = this.caseDocCount;
        data["indexDocCount"] = this.indexDocCount;
        data["kbDocCount"] = this.kbDocCount;
        data["docSize"] = this.docSize;
        data["productionJobSize"] = this.productionJobSize;
        data["archiveJobSize"] = this.archiveJobSize;
        data["downloadSize"] = this.downloadSize;
        data["indexSize"] = this.indexSize;
        data["accountId"] = this.accountId;
        data["lifecycle"] = this.lifecycle;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        if (Array.isArray(this.fieldLayouts)) {
            data["fieldLayouts"] = [];
            for (let item of this.fieldLayouts)
                data["fieldLayouts"].push(item.toJSON());
        }
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item.toJSON());
        }
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        if (Array.isArray(this.docsInFacts)) {
            data["docsInFacts"] = [];
            for (let item of this.docsInFacts)
                data["docsInFacts"].push(item.toJSON());
        }
        if (Array.isArray(this.custodians)) {
            data["custodians"] = [];
            for (let item of this.custodians)
                data["custodians"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.docs)) {
            data["docs"] = [];
            for (let item of this.docs)
                data["docs"].push(item.toJSON());
        }
        if (Array.isArray(this.caseConfigs)) {
            data["caseConfigs"] = [];
            for (let item of this.caseConfigs)
                data["caseConfigs"].push(item.toJSON());
        }
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICase {
    caseId?: string;
    simpleCaseId?: string | undefined;
    caseName?: string | undefined;
    caseNumber?: string | undefined;
    caseType?: string | undefined;
    caseVenue?: string | undefined;
    leadAttorney?: string | undefined;
    trierOfFact?: string | undefined;
    caseComments?: string | undefined;
    customDesignation?: string | undefined;
    caseDocCount?: number;
    indexDocCount?: number;
    kbDocCount?: number;
    docSize?: number;
    productionJobSize?: number;
    archiveJobSize?: number;
    downloadSize?: number;
    indexSize?: number;
    accountId?: string;
    lifecycle?: number;
    createdById?: string;
    dateTimeCreated?: Date;
    fieldLayouts?: FieldLayout[] | undefined;
    facts?: Fact[] | undefined;
    issues?: Issue[] | undefined;
    docsInFacts?: DocsInFact[] | undefined;
    custodians?: Custodian[] | undefined;
    users?: User[] | undefined;
    docs?: Doc[] | undefined;
    caseConfigs?: CaseConfig[] | undefined;
    account?: Account;
    createdBy?: User;
}

export class CaseAnalyticsState implements ICaseAnalyticsState {
    caseId?: string;
    userFirstName?: string | undefined;
    uploadBatchState?: UploadBatchState;
    reviewSetState?: ReviewSetState;
    productionJobState?: ProductionJobState;

    constructor(data?: ICaseAnalyticsState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userFirstName = _data["userFirstName"];
            this.uploadBatchState = _data["uploadBatchState"] ? UploadBatchState.fromJS(_data["uploadBatchState"]) : <any>undefined;
            this.reviewSetState = _data["reviewSetState"] ? ReviewSetState.fromJS(_data["reviewSetState"]) : <any>undefined;
            this.productionJobState = _data["productionJobState"] ? ProductionJobState.fromJS(_data["productionJobState"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseAnalyticsState {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAnalyticsState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userFirstName"] = this.userFirstName;
        data["uploadBatchState"] = this.uploadBatchState ? this.uploadBatchState.toJSON() : <any>undefined;
        data["reviewSetState"] = this.reviewSetState ? this.reviewSetState.toJSON() : <any>undefined;
        data["productionJobState"] = this.productionJobState ? this.productionJobState.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseAnalyticsState {
    caseId?: string;
    userFirstName?: string | undefined;
    uploadBatchState?: UploadBatchState;
    reviewSetState?: ReviewSetState;
    productionJobState?: ProductionJobState;
}

export class CaseConfig implements ICaseConfig {
    id?: string;
    value?: string | undefined;
    caseId?: string;
    configTypeId?: string;
    type?: ConfigType;
    case?: Case;

    constructor(data?: ICaseConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.caseId = _data["caseId"];
            this.configTypeId = _data["configTypeId"];
            this.type = _data["type"] ? ConfigType.fromJS(_data["type"]) : <any>undefined;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseConfig {
        data = typeof data === 'object' ? data : {};
        let result = new CaseConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["caseId"] = this.caseId;
        data["configTypeId"] = this.configTypeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseConfig {
    id?: string;
    value?: string | undefined;
    caseId?: string;
    configTypeId?: string;
    type?: ConfigType;
    case?: Case;
}

export class CaseContact implements ICaseContact {
    contactId?: string;
    accountId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;

    constructor(data?: ICaseContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.accountId = _data["accountId"];
            this.caseId = _data["caseId"];
            this.isOrganization = _data["isOrganization"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.memo = _data["memo"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.cell = _data["cell"];
            this.email = _data["email"];
            this.affiliation = _data["affiliation"];
        }
    }

    static fromJS(data: any): CaseContact {
        data = typeof data === 'object' ? data : {};
        let result = new CaseContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["accountId"] = this.accountId;
        data["caseId"] = this.caseId;
        data["isOrganization"] = this.isOrganization;
        data["name"] = this.name;
        data["title"] = this.title;
        data["memo"] = this.memo;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["cell"] = this.cell;
        data["email"] = this.email;
        data["affiliation"] = this.affiliation;
        return data;
    }
}

export interface ICaseContact {
    contactId?: string;
    accountId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
}

export class CaseContactPagingResponse implements ICaseContactPagingResponse {
    value?: CaseContact[] | undefined;
    count?: number | undefined;

    constructor(data?: ICaseContactPagingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(CaseContact.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CaseContactPagingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaseContactPagingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface ICaseContactPagingResponse {
    value?: CaseContact[] | undefined;
    count?: number | undefined;
}

export class CaseDashboardRequest implements ICaseDashboardRequest {
    year?: Date;

    constructor(data?: ICaseDashboardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] ? new Date(_data["year"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseDashboardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDashboardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year ? this.year.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaseDashboardRequest {
    year?: Date;
}

export class CaseField implements ICaseField {
    fieldId?: string;
    parentFieldId?: string;
    accountId?: string;
    type?: number;
    rank?: number;
    title?: string | undefined;
    account?: Account;

    constructor(data?: ICaseField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.parentFieldId = _data["parentFieldId"];
            this.accountId = _data["accountId"];
            this.type = _data["type"];
            this.rank = _data["rank"];
            this.title = _data["title"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseField {
        data = typeof data === 'object' ? data : {};
        let result = new CaseField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["parentFieldId"] = this.parentFieldId;
        data["accountId"] = this.accountId;
        data["type"] = this.type;
        data["rank"] = this.rank;
        data["title"] = this.title;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseField {
    fieldId?: string;
    parentFieldId?: string;
    accountId?: string;
    type?: number;
    rank?: number;
    title?: string | undefined;
    account?: Account;
}

export class CasePriority implements ICasePriority {
    caseId?: string;
    caseName?: string | undefined;
    accountName?: string | undefined;
    priority?: number;

    constructor(data?: ICasePriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.caseName = _data["caseName"];
            this.accountName = _data["accountName"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): CasePriority {
        data = typeof data === 'object' ? data : {};
        let result = new CasePriority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["caseName"] = this.caseName;
        data["accountName"] = this.accountName;
        data["priority"] = this.priority;
        return data;
    }
}

export interface ICasePriority {
    caseId?: string;
    caseName?: string | undefined;
    accountName?: string | undefined;
    priority?: number;
}

export class CaseShards implements ICaseShards {
    caseId?: string;
    primaryShardCount?: number;

    constructor(data?: ICaseShards) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.primaryShardCount = _data["primaryShardCount"];
        }
    }

    static fromJS(data: any): CaseShards {
        data = typeof data === 'object' ? data : {};
        let result = new CaseShards();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["primaryShardCount"] = this.primaryShardCount;
        return data;
    }
}

export interface ICaseShards {
    caseId?: string;
    primaryShardCount?: number;
}

export class CaseShardsViewModel implements ICaseShardsViewModel {
    caseId?: string | undefined;
    shards?: ShardViewModel[] | undefined;

    constructor(data?: ICaseShardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["shards"])) {
                this.shards = [] as any;
                for (let item of _data["shards"])
                    this.shards!.push(ShardViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseShardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseShardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.shards)) {
            data["shards"] = [];
            for (let item of this.shards)
                data["shards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaseShardsViewModel {
    caseId?: string | undefined;
    shards?: ShardViewModel[] | undefined;
}

export class ClioMattersModel implements IClioMattersModel {
    meta?: MetaModel;
    data?: MatterDataModel[] | undefined;

    constructor(data?: IClioMattersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meta = _data["meta"] ? MetaModel.fromJS(_data["meta"]) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MatterDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClioMattersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClioMattersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClioMattersModel {
    meta?: MetaModel;
    data?: MatterDataModel[] | undefined;
}

export class CodingCheckbox implements ICodingCheckbox {
    fieldId?: string;
    docId?: string;
    field?: CodingField;

    constructor(data?: ICodingCheckbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.docId = _data["docId"];
            this.field = _data["field"] ? CodingField.fromJS(_data["field"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CodingCheckbox {
        data = typeof data === 'object' ? data : {};
        let result = new CodingCheckbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["docId"] = this.docId;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICodingCheckbox {
    fieldId?: string;
    docId?: string;
    field?: CodingField;
}

export class CodingDateTime implements ICodingDateTime {
    fieldId?: string;
    docId?: string;
    dateTimeValue?: Date;
    field?: CodingField;

    constructor(data?: ICodingDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.docId = _data["docId"];
            this.dateTimeValue = _data["dateTimeValue"] ? new Date(_data["dateTimeValue"].toString()) : <any>undefined;
            this.field = _data["field"] ? CodingField.fromJS(_data["field"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CodingDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new CodingDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["docId"] = this.docId;
        data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toISOString() : <any>undefined;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICodingDateTime {
    fieldId?: string;
    docId?: string;
    dateTimeValue?: Date;
    field?: CodingField;
}

export class CodingDropDownListItem implements ICodingDropDownListItem {
    itemId?: string;
    fieldId?: string;
    title?: string | undefined;
    rank?: number;
    field?: CodingField;
    codingDropDownListItemSelecteds?: CodingDropDownListItemSelected[] | undefined;

    constructor(data?: ICodingDropDownListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.fieldId = _data["fieldId"];
            this.title = _data["title"];
            this.rank = _data["rank"];
            this.field = _data["field"] ? CodingField.fromJS(_data["field"]) : <any>undefined;
            if (Array.isArray(_data["codingDropDownListItemSelecteds"])) {
                this.codingDropDownListItemSelecteds = [] as any;
                for (let item of _data["codingDropDownListItemSelecteds"])
                    this.codingDropDownListItemSelecteds!.push(CodingDropDownListItemSelected.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CodingDropDownListItem {
        data = typeof data === 'object' ? data : {};
        let result = new CodingDropDownListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["fieldId"] = this.fieldId;
        data["title"] = this.title;
        data["rank"] = this.rank;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        if (Array.isArray(this.codingDropDownListItemSelecteds)) {
            data["codingDropDownListItemSelecteds"] = [];
            for (let item of this.codingDropDownListItemSelecteds)
                data["codingDropDownListItemSelecteds"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICodingDropDownListItem {
    itemId?: string;
    fieldId?: string;
    title?: string | undefined;
    rank?: number;
    field?: CodingField;
    codingDropDownListItemSelecteds?: CodingDropDownListItemSelected[] | undefined;
}

export class CodingDropDownListItemSelected implements ICodingDropDownListItemSelected {
    fieldId?: string;
    docId?: string;
    itemId?: string;
    field?: CodingField;
    item?: CodingDropDownListItem;

    constructor(data?: ICodingDropDownListItemSelected) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.docId = _data["docId"];
            this.itemId = _data["itemId"];
            this.field = _data["field"] ? CodingField.fromJS(_data["field"]) : <any>undefined;
            this.item = _data["item"] ? CodingDropDownListItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CodingDropDownListItemSelected {
        data = typeof data === 'object' ? data : {};
        let result = new CodingDropDownListItemSelected();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["docId"] = this.docId;
        data["itemId"] = this.itemId;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICodingDropDownListItemSelected {
    fieldId?: string;
    docId?: string;
    itemId?: string;
    field?: CodingField;
    item?: CodingDropDownListItem;
}

export class CodingField implements ICodingField {
    fieldId?: string;
    rank?: number;
    type?: number;
    parentFieldId?: string;
    caseId?: string;
    displayTitle?: string | undefined;
    codingCheckboxes?: CodingCheckbox[] | undefined;
    codingDateTimes?: CodingDateTime[] | undefined;
    codingDropDownListItems?: CodingDropDownListItem[] | undefined;
    codingIntegers?: CodingInteger[] | undefined;
    codingTextboxes?: CodingTextbox[] | undefined;

    constructor(data?: ICodingField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.rank = _data["rank"];
            this.type = _data["type"];
            this.parentFieldId = _data["parentFieldId"];
            this.caseId = _data["caseId"];
            this.displayTitle = _data["displayTitle"];
            if (Array.isArray(_data["codingCheckboxes"])) {
                this.codingCheckboxes = [] as any;
                for (let item of _data["codingCheckboxes"])
                    this.codingCheckboxes!.push(CodingCheckbox.fromJS(item));
            }
            if (Array.isArray(_data["codingDateTimes"])) {
                this.codingDateTimes = [] as any;
                for (let item of _data["codingDateTimes"])
                    this.codingDateTimes!.push(CodingDateTime.fromJS(item));
            }
            if (Array.isArray(_data["codingDropDownListItems"])) {
                this.codingDropDownListItems = [] as any;
                for (let item of _data["codingDropDownListItems"])
                    this.codingDropDownListItems!.push(CodingDropDownListItem.fromJS(item));
            }
            if (Array.isArray(_data["codingIntegers"])) {
                this.codingIntegers = [] as any;
                for (let item of _data["codingIntegers"])
                    this.codingIntegers!.push(CodingInteger.fromJS(item));
            }
            if (Array.isArray(_data["codingTextboxes"])) {
                this.codingTextboxes = [] as any;
                for (let item of _data["codingTextboxes"])
                    this.codingTextboxes!.push(CodingTextbox.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CodingField {
        data = typeof data === 'object' ? data : {};
        let result = new CodingField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["rank"] = this.rank;
        data["type"] = this.type;
        data["parentFieldId"] = this.parentFieldId;
        data["caseId"] = this.caseId;
        data["displayTitle"] = this.displayTitle;
        if (Array.isArray(this.codingCheckboxes)) {
            data["codingCheckboxes"] = [];
            for (let item of this.codingCheckboxes)
                data["codingCheckboxes"].push(item.toJSON());
        }
        if (Array.isArray(this.codingDateTimes)) {
            data["codingDateTimes"] = [];
            for (let item of this.codingDateTimes)
                data["codingDateTimes"].push(item.toJSON());
        }
        if (Array.isArray(this.codingDropDownListItems)) {
            data["codingDropDownListItems"] = [];
            for (let item of this.codingDropDownListItems)
                data["codingDropDownListItems"].push(item.toJSON());
        }
        if (Array.isArray(this.codingIntegers)) {
            data["codingIntegers"] = [];
            for (let item of this.codingIntegers)
                data["codingIntegers"].push(item.toJSON());
        }
        if (Array.isArray(this.codingTextboxes)) {
            data["codingTextboxes"] = [];
            for (let item of this.codingTextboxes)
                data["codingTextboxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICodingField {
    fieldId?: string;
    rank?: number;
    type?: number;
    parentFieldId?: string;
    caseId?: string;
    displayTitle?: string | undefined;
    codingCheckboxes?: CodingCheckbox[] | undefined;
    codingDateTimes?: CodingDateTime[] | undefined;
    codingDropDownListItems?: CodingDropDownListItem[] | undefined;
    codingIntegers?: CodingInteger[] | undefined;
    codingTextboxes?: CodingTextbox[] | undefined;
}

export class CodingFieldState implements ICodingFieldState {
    fieldId?: string;
    rank?: number;
    type?: number;
    parentFieldId?: string;
    caseId?: string;
    displayTitle?: string | undefined;

    constructor(data?: ICodingFieldState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.rank = _data["rank"];
            this.type = _data["type"];
            this.parentFieldId = _data["parentFieldId"];
            this.caseId = _data["caseId"];
            this.displayTitle = _data["displayTitle"];
        }
    }

    static fromJS(data: any): CodingFieldState {
        data = typeof data === 'object' ? data : {};
        let result = new CodingFieldState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["rank"] = this.rank;
        data["type"] = this.type;
        data["parentFieldId"] = this.parentFieldId;
        data["caseId"] = this.caseId;
        data["displayTitle"] = this.displayTitle;
        return data;
    }
}

export interface ICodingFieldState {
    fieldId?: string;
    rank?: number;
    type?: number;
    parentFieldId?: string;
    caseId?: string;
    displayTitle?: string | undefined;
}

export class CodingInteger implements ICodingInteger {
    fieldId?: string;
    docId?: string;
    value?: number;
    field?: CodingField;

    constructor(data?: ICodingInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.docId = _data["docId"];
            this.value = _data["value"];
            this.field = _data["field"] ? CodingField.fromJS(_data["field"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CodingInteger {
        data = typeof data === 'object' ? data : {};
        let result = new CodingInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["docId"] = this.docId;
        data["value"] = this.value;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICodingInteger {
    fieldId?: string;
    docId?: string;
    value?: number;
    field?: CodingField;
}

export class CodingTextbox implements ICodingTextbox {
    fieldId?: string;
    docId?: string;
    text?: string | undefined;
    codingField?: CodingField;

    constructor(data?: ICodingTextbox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.docId = _data["docId"];
            this.text = _data["text"];
            this.codingField = _data["codingField"] ? CodingField.fromJS(_data["codingField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CodingTextbox {
        data = typeof data === 'object' ? data : {};
        let result = new CodingTextbox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["docId"] = this.docId;
        data["text"] = this.text;
        data["codingField"] = this.codingField ? this.codingField.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICodingTextbox {
    fieldId?: string;
    docId?: string;
    text?: string | undefined;
    codingField?: CodingField;
}

export class CompareInfo implements ICompareInfo {
    readonly name?: string | undefined;
    version?: SortVersion;
    readonly lcid?: number;

    constructor(data?: ICompareInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.version = _data["version"] ? SortVersion.fromJS(_data["version"]) : <any>undefined;
            (<any>this).lcid = _data["lcid"];
        }
    }

    static fromJS(data: any): CompareInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CompareInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["lcid"] = this.lcid;
        return data;
    }
}

export interface ICompareInfo {
    name?: string | undefined;
    version?: SortVersion;
    lcid?: number;
}

export class CompleteFileUploadRequestPackage implements ICompleteFileUploadRequestPackage {
    completedUploads?: CompleteUploadRequest[] | undefined;
    currentCaseId?: string;

    constructor(data?: ICompleteFileUploadRequestPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["completedUploads"])) {
                this.completedUploads = [] as any;
                for (let item of _data["completedUploads"])
                    this.completedUploads!.push(CompleteUploadRequest.fromJS(item));
            }
            this.currentCaseId = _data["currentCaseId"];
        }
    }

    static fromJS(data: any): CompleteFileUploadRequestPackage {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteFileUploadRequestPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.completedUploads)) {
            data["completedUploads"] = [];
            for (let item of this.completedUploads)
                data["completedUploads"].push(item.toJSON());
        }
        data["currentCaseId"] = this.currentCaseId;
        return data;
    }
}

export interface ICompleteFileUploadRequestPackage {
    completedUploads?: CompleteUploadRequest[] | undefined;
    currentCaseId?: string;
}

export class CompleteUploadRequest implements ICompleteUploadRequest {
    documentId?: string;
    originalFileId?: string | undefined;
    partETags?: PartETag[] | undefined;
    fileName?: string | undefined;
    uploadId?: string | undefined;
    lexbeUploadBatchId?: string;

    constructor(data?: ICompleteUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.originalFileId = _data["originalFileId"];
            if (Array.isArray(_data["partETags"])) {
                this.partETags = [] as any;
                for (let item of _data["partETags"])
                    this.partETags!.push(PartETag.fromJS(item));
            }
            this.fileName = _data["fileName"];
            this.uploadId = _data["uploadId"];
            this.lexbeUploadBatchId = _data["lexbeUploadBatchId"];
        }
    }

    static fromJS(data: any): CompleteUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["originalFileId"] = this.originalFileId;
        if (Array.isArray(this.partETags)) {
            data["partETags"] = [];
            for (let item of this.partETags)
                data["partETags"].push(item.toJSON());
        }
        data["fileName"] = this.fileName;
        data["uploadId"] = this.uploadId;
        data["lexbeUploadBatchId"] = this.lexbeUploadBatchId;
        return data;
    }
}

export interface ICompleteUploadRequest {
    documentId?: string;
    originalFileId?: string | undefined;
    partETags?: PartETag[] | undefined;
    fileName?: string | undefined;
    uploadId?: string | undefined;
    lexbeUploadBatchId?: string;
}

export enum ConfigDataType {
    _0 = 0,
    _1 = 1,
}

export class ConfigType implements IConfigType {
    value?: string;
    displayName?: string | undefined;
    dataType?: ConfigDataType;

    constructor(data?: IConfigType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayName = _data["displayName"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): ConfigType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IConfigType {
    value?: string;
    displayName?: string | undefined;
    dataType?: ConfigDataType;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }
}

export interface IConstructorInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
}

export class CreatePdfRequest implements ICreatePdfRequest {
    briefcaseJobId?: string;
    fileType?: number;

    constructor(data?: ICreatePdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.briefcaseJobId = _data["briefcaseJobId"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): CreatePdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["briefcaseJobId"] = this.briefcaseJobId;
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface ICreatePdfRequest {
    briefcaseJobId?: string;
    fileType?: number;
}

export class CultureInfo implements ICultureInfo {
    parent?: CultureInfo;
    readonly lcid?: number;
    readonly keyboardLayoutId?: number;
    name?: string | undefined;
    readonly ietfLanguageTag?: string | undefined;
    readonly displayName?: string | undefined;
    readonly nativeName?: string | undefined;
    readonly englishName?: string | undefined;
    readonly twoLetterISOLanguageName?: string | undefined;
    readonly threeLetterISOLanguageName?: string | undefined;
    readonly threeLetterWindowsLanguageName?: string | undefined;
    compareInfo?: CompareInfo;
    textInfo?: TextInfo;
    readonly isNeutralCulture?: boolean;
    cultureTypes?: CultureTypes;
    numberFormat?: NumberFormatInfo;
    dateTimeFormat?: DateTimeFormatInfo;
    calendar?: Calendar;
    readonly optionalCalendars?: Calendar[] | undefined;
    readonly useUserOverride?: boolean;
    readonly isReadOnly?: boolean;

    constructor(data?: ICultureInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"] ? CultureInfo.fromJS(_data["parent"]) : <any>undefined;
            (<any>this).lcid = _data["lcid"];
            (<any>this).keyboardLayoutId = _data["keyboardLayoutId"];
            this.name = _data["name"];
            (<any>this).ietfLanguageTag = _data["ietfLanguageTag"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).nativeName = _data["nativeName"];
            (<any>this).englishName = _data["englishName"];
            (<any>this).twoLetterISOLanguageName = _data["twoLetterISOLanguageName"];
            (<any>this).threeLetterISOLanguageName = _data["threeLetterISOLanguageName"];
            (<any>this).threeLetterWindowsLanguageName = _data["threeLetterWindowsLanguageName"];
            this.compareInfo = _data["compareInfo"] ? CompareInfo.fromJS(_data["compareInfo"]) : <any>undefined;
            this.textInfo = _data["textInfo"] ? TextInfo.fromJS(_data["textInfo"]) : <any>undefined;
            (<any>this).isNeutralCulture = _data["isNeutralCulture"];
            this.cultureTypes = _data["cultureTypes"];
            this.numberFormat = _data["numberFormat"] ? NumberFormatInfo.fromJS(_data["numberFormat"]) : <any>undefined;
            this.dateTimeFormat = _data["dateTimeFormat"] ? DateTimeFormatInfo.fromJS(_data["dateTimeFormat"]) : <any>undefined;
            this.calendar = _data["calendar"] ? Calendar.fromJS(_data["calendar"]) : <any>undefined;
            if (Array.isArray(_data["optionalCalendars"])) {
                (<any>this).optionalCalendars = [] as any;
                for (let item of _data["optionalCalendars"])
                    (<any>this).optionalCalendars!.push(Calendar.fromJS(item));
            }
            (<any>this).useUserOverride = _data["useUserOverride"];
            (<any>this).isReadOnly = _data["isReadOnly"];
        }
    }

    static fromJS(data: any): CultureInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CultureInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["lcid"] = this.lcid;
        data["keyboardLayoutId"] = this.keyboardLayoutId;
        data["name"] = this.name;
        data["ietfLanguageTag"] = this.ietfLanguageTag;
        data["displayName"] = this.displayName;
        data["nativeName"] = this.nativeName;
        data["englishName"] = this.englishName;
        data["twoLetterISOLanguageName"] = this.twoLetterISOLanguageName;
        data["threeLetterISOLanguageName"] = this.threeLetterISOLanguageName;
        data["threeLetterWindowsLanguageName"] = this.threeLetterWindowsLanguageName;
        data["compareInfo"] = this.compareInfo ? this.compareInfo.toJSON() : <any>undefined;
        data["textInfo"] = this.textInfo ? this.textInfo.toJSON() : <any>undefined;
        data["isNeutralCulture"] = this.isNeutralCulture;
        data["cultureTypes"] = this.cultureTypes;
        data["numberFormat"] = this.numberFormat ? this.numberFormat.toJSON() : <any>undefined;
        data["dateTimeFormat"] = this.dateTimeFormat ? this.dateTimeFormat.toJSON() : <any>undefined;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (Array.isArray(this.optionalCalendars)) {
            data["optionalCalendars"] = [];
            for (let item of this.optionalCalendars)
                data["optionalCalendars"].push(item.toJSON());
        }
        data["useUserOverride"] = this.useUserOverride;
        data["isReadOnly"] = this.isReadOnly;
        return data;
    }
}

export interface ICultureInfo {
    parent?: CultureInfo;
    lcid?: number;
    keyboardLayoutId?: number;
    name?: string | undefined;
    ietfLanguageTag?: string | undefined;
    displayName?: string | undefined;
    nativeName?: string | undefined;
    englishName?: string | undefined;
    twoLetterISOLanguageName?: string | undefined;
    threeLetterISOLanguageName?: string | undefined;
    threeLetterWindowsLanguageName?: string | undefined;
    compareInfo?: CompareInfo;
    textInfo?: TextInfo;
    isNeutralCulture?: boolean;
    cultureTypes?: CultureTypes;
    numberFormat?: NumberFormatInfo;
    dateTimeFormat?: DateTimeFormatInfo;
    calendar?: Calendar;
    optionalCalendars?: Calendar[] | undefined;
    useUserOverride?: boolean;
    isReadOnly?: boolean;
}

export enum CultureTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
}

export class Custodian implements ICustodian {
    custodianId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    role?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
    customField1?: string | undefined;
    lifeCycle?: LifeCycle;
    case?: Case;
    facts?: Fact[] | undefined;

    constructor(data?: ICustodian) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custodianId = _data["custodianId"];
            this.caseId = _data["caseId"];
            this.isOrganization = _data["isOrganization"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.memo = _data["memo"];
            this.role = _data["role"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.cell = _data["cell"];
            this.email = _data["email"];
            this.affiliation = _data["affiliation"];
            this.customField1 = _data["customField1"];
            this.lifeCycle = _data["lifeCycle"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(Fact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Custodian {
        data = typeof data === 'object' ? data : {};
        let result = new Custodian();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custodianId"] = this.custodianId;
        data["caseId"] = this.caseId;
        data["isOrganization"] = this.isOrganization;
        data["name"] = this.name;
        data["title"] = this.title;
        data["memo"] = this.memo;
        data["role"] = this.role;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["cell"] = this.cell;
        data["email"] = this.email;
        data["affiliation"] = this.affiliation;
        data["customField1"] = this.customField1;
        data["lifeCycle"] = this.lifeCycle;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustodian {
    custodianId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    role?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
    customField1?: string | undefined;
    lifeCycle?: LifeCycle;
    case?: Case;
    facts?: Fact[] | undefined;
}

export class CustodianIdName implements ICustodianIdName {
    custodianId?: string;
    name?: string | undefined;

    constructor(data?: ICustodianIdName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custodianId = _data["custodianId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustodianIdName {
        data = typeof data === 'object' ? data : {};
        let result = new CustodianIdName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custodianId"] = this.custodianId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICustodianIdName {
    custodianId?: string;
    name?: string | undefined;
}

export class CustodianState implements ICustodianState {
    custodianId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    role?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
    customField1?: string | undefined;
    lifeCycle?: LifeCycle;

    constructor(data?: ICustodianState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custodianId = _data["custodianId"];
            this.caseId = _data["caseId"];
            this.isOrganization = _data["isOrganization"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.memo = _data["memo"];
            this.role = _data["role"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.cell = _data["cell"];
            this.email = _data["email"];
            this.affiliation = _data["affiliation"];
            this.customField1 = _data["customField1"];
            this.lifeCycle = _data["lifeCycle"];
        }
    }

    static fromJS(data: any): CustodianState {
        data = typeof data === 'object' ? data : {};
        let result = new CustodianState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custodianId"] = this.custodianId;
        data["caseId"] = this.caseId;
        data["isOrganization"] = this.isOrganization;
        data["name"] = this.name;
        data["title"] = this.title;
        data["memo"] = this.memo;
        data["role"] = this.role;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["cell"] = this.cell;
        data["email"] = this.email;
        data["affiliation"] = this.affiliation;
        data["customField1"] = this.customField1;
        data["lifeCycle"] = this.lifeCycle;
        return data;
    }
}

export interface ICustodianState {
    custodianId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    role?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
    customField1?: string | undefined;
    lifeCycle?: LifeCycle;
}

export class CustodianViewModel implements ICustodianViewModel {
    custodianId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    role?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
    customField1?: string | undefined;
    lifeCycle?: LifeCycle;

    constructor(data?: ICustodianViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custodianId = _data["custodianId"];
            this.caseId = _data["caseId"];
            this.isOrganization = _data["isOrganization"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.memo = _data["memo"];
            this.role = _data["role"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.cell = _data["cell"];
            this.email = _data["email"];
            this.affiliation = _data["affiliation"];
            this.customField1 = _data["customField1"];
            this.lifeCycle = _data["lifeCycle"];
        }
    }

    static fromJS(data: any): CustodianViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustodianViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custodianId"] = this.custodianId;
        data["caseId"] = this.caseId;
        data["isOrganization"] = this.isOrganization;
        data["name"] = this.name;
        data["title"] = this.title;
        data["memo"] = this.memo;
        data["role"] = this.role;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["cell"] = this.cell;
        data["email"] = this.email;
        data["affiliation"] = this.affiliation;
        data["customField1"] = this.customField1;
        data["lifeCycle"] = this.lifeCycle;
        return data;
    }
}

export interface ICustodianViewModel {
    custodianId?: string;
    caseId?: string;
    isOrganization?: boolean;
    name?: string | undefined;
    title?: string | undefined;
    memo?: string | undefined;
    role?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    affiliation?: string | undefined;
    customField1?: string | undefined;
    lifeCycle?: LifeCycle;
}

export class CustodianViewModelPagingResponse implements ICustodianViewModelPagingResponse {
    value?: CustodianViewModel[] | undefined;
    count?: number | undefined;

    constructor(data?: ICustodianViewModelPagingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(CustodianViewModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CustodianViewModelPagingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustodianViewModelPagingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface ICustodianViewModelPagingResponse {
    value?: CustodianViewModel[] | undefined;
    count?: number | undefined;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    readonly constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments?: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : <any>undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    readonly memberName?: string | undefined;
    readonly isField?: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string | undefined;
    isField?: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;
}

export class CustomCaseField implements ICustomCaseField {
    fieldId?: string;
    parentFieldId?: string;
    accountId?: string;
    type?: number;
    rank?: number;
    title?: string | undefined;

    constructor(data?: ICustomCaseField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.parentFieldId = _data["parentFieldId"];
            this.accountId = _data["accountId"];
            this.type = _data["type"];
            this.rank = _data["rank"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CustomCaseField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCaseField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["parentFieldId"] = this.parentFieldId;
        data["accountId"] = this.accountId;
        data["type"] = this.type;
        data["rank"] = this.rank;
        data["title"] = this.title;
        return data;
    }
}

export interface ICustomCaseField {
    fieldId?: string;
    parentFieldId?: string;
    accountId?: string;
    type?: number;
    rank?: number;
    title?: string | undefined;
}

export class CustomCaseFieldValue implements ICustomCaseFieldValue {
    fieldId?: string;
    accountId?: string;
    caseId?: string;
    type?: number;
    title?: string | undefined;
    text?: string | undefined;
    checked?: boolean;

    constructor(data?: ICustomCaseFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.accountId = _data["accountId"];
            this.caseId = _data["caseId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): CustomCaseFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCaseFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["accountId"] = this.accountId;
        data["caseId"] = this.caseId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["text"] = this.text;
        data["checked"] = this.checked;
        return data;
    }
}

export interface ICustomCaseFieldValue {
    fieldId?: string;
    accountId?: string;
    caseId?: string;
    type?: number;
    title?: string | undefined;
    text?: string | undefined;
    checked?: boolean;
}

export class CustomReportFields implements ICustomReportFields {
    reportSumUnitType?: ReportSumUnitType;
    reportDateUnitType?: ReportDateUnitType;
    primaryDocField?: string;
    optionalDocField?: string;

    constructor(data?: ICustomReportFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportSumUnitType = _data["reportSumUnitType"];
            this.reportDateUnitType = _data["reportDateUnitType"];
            this.primaryDocField = _data["primaryDocField"];
            this.optionalDocField = _data["optionalDocField"];
        }
    }

    static fromJS(data: any): CustomReportFields {
        data = typeof data === 'object' ? data : {};
        let result = new CustomReportFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSumUnitType"] = this.reportSumUnitType;
        data["reportDateUnitType"] = this.reportDateUnitType;
        data["primaryDocField"] = this.primaryDocField;
        data["optionalDocField"] = this.optionalDocField;
        return data;
    }
}

export interface ICustomReportFields {
    reportSumUnitType?: ReportSumUnitType;
    reportDateUnitType?: ReportDateUnitType;
    primaryDocField?: string;
    optionalDocField?: string;
}

export class DatColumnMetadata implements IDatColumnMetadata {
    datColumn?: string | undefined;
    sampleData?: string[] | undefined;

    constructor(data?: IDatColumnMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datColumn = _data["datColumn"];
            if (Array.isArray(_data["sampleData"])) {
                this.sampleData = [] as any;
                for (let item of _data["sampleData"])
                    this.sampleData!.push(item);
            }
        }
    }

    static fromJS(data: any): DatColumnMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new DatColumnMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datColumn"] = this.datColumn;
        if (Array.isArray(this.sampleData)) {
            data["sampleData"] = [];
            for (let item of this.sampleData)
                data["sampleData"].push(item);
        }
        return data;
    }
}

export interface IDatColumnMetadata {
    datColumn?: string | undefined;
    sampleData?: string[] | undefined;
}

export class DatMapFieldLookup implements IDatMapFieldLookup {
    lexbeFields?: LexbeField[] | undefined;
    datColumns?: DatColumnMetadata[] | undefined;

    constructor(data?: IDatMapFieldLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lexbeFields"])) {
                this.lexbeFields = [] as any;
                for (let item of _data["lexbeFields"])
                    this.lexbeFields!.push(LexbeField.fromJS(item));
            }
            if (Array.isArray(_data["datColumns"])) {
                this.datColumns = [] as any;
                for (let item of _data["datColumns"])
                    this.datColumns!.push(DatColumnMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatMapFieldLookup {
        data = typeof data === 'object' ? data : {};
        let result = new DatMapFieldLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lexbeFields)) {
            data["lexbeFields"] = [];
            for (let item of this.lexbeFields)
                data["lexbeFields"].push(item.toJSON());
        }
        if (Array.isArray(this.datColumns)) {
            data["datColumns"] = [];
            for (let item of this.datColumns)
                data["datColumns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatMapFieldLookup {
    lexbeFields?: LexbeField[] | undefined;
    datColumns?: DatColumnMetadata[] | undefined;
}

export class DatMapMetadata implements IDatMapMetadata {
    uploadBatchId?: string;
    metadata?: string | undefined;
    lastRunReport?: string | undefined;
    uploadBatch?: UploadBatch;

    constructor(data?: IDatMapMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadBatchId = _data["uploadBatchId"];
            this.metadata = _data["metadata"];
            this.lastRunReport = _data["lastRunReport"];
            this.uploadBatch = _data["uploadBatch"] ? UploadBatch.fromJS(_data["uploadBatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatMapMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new DatMapMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadBatchId"] = this.uploadBatchId;
        data["metadata"] = this.metadata;
        data["lastRunReport"] = this.lastRunReport;
        data["uploadBatch"] = this.uploadBatch ? this.uploadBatch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatMapMetadata {
    uploadBatchId?: string;
    metadata?: string | undefined;
    lastRunReport?: string | undefined;
    uploadBatch?: UploadBatch;
}

export class DatMapMetadataContext implements IDatMapMetadataContext {
    caseId?: string;
    uploadBatchId?: string;
    uploadBatchTitle?: string | undefined;
    lookupTables?: DatMapFieldLookup;
    defaultMappings?: DatMapMetadataItem[] | undefined;
    actualMappings?: DatMapMetadataItem[] | undefined;

    constructor(data?: IDatMapMetadataContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.uploadBatchId = _data["uploadBatchId"];
            this.uploadBatchTitle = _data["uploadBatchTitle"];
            this.lookupTables = _data["lookupTables"] ? DatMapFieldLookup.fromJS(_data["lookupTables"]) : <any>undefined;
            if (Array.isArray(_data["defaultMappings"])) {
                this.defaultMappings = [] as any;
                for (let item of _data["defaultMappings"])
                    this.defaultMappings!.push(DatMapMetadataItem.fromJS(item));
            }
            if (Array.isArray(_data["actualMappings"])) {
                this.actualMappings = [] as any;
                for (let item of _data["actualMappings"])
                    this.actualMappings!.push(DatMapMetadataItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatMapMetadataContext {
        data = typeof data === 'object' ? data : {};
        let result = new DatMapMetadataContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["uploadBatchId"] = this.uploadBatchId;
        data["uploadBatchTitle"] = this.uploadBatchTitle;
        data["lookupTables"] = this.lookupTables ? this.lookupTables.toJSON() : <any>undefined;
        if (Array.isArray(this.defaultMappings)) {
            data["defaultMappings"] = [];
            for (let item of this.defaultMappings)
                data["defaultMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.actualMappings)) {
            data["actualMappings"] = [];
            for (let item of this.actualMappings)
                data["actualMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatMapMetadataContext {
    caseId?: string;
    uploadBatchId?: string;
    uploadBatchTitle?: string | undefined;
    lookupTables?: DatMapFieldLookup;
    defaultMappings?: DatMapMetadataItem[] | undefined;
    actualMappings?: DatMapMetadataItem[] | undefined;
}

export class DatMapMetadataItem implements IDatMapMetadataItem {
    lexbeField?: LexbeField;
    datMapColumns?: string[] | undefined;

    constructor(data?: IDatMapMetadataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lexbeField = _data["lexbeField"] ? LexbeField.fromJS(_data["lexbeField"]) : <any>undefined;
            if (Array.isArray(_data["datMapColumns"])) {
                this.datMapColumns = [] as any;
                for (let item of _data["datMapColumns"])
                    this.datMapColumns!.push(item);
            }
        }
    }

    static fromJS(data: any): DatMapMetadataItem {
        data = typeof data === 'object' ? data : {};
        let result = new DatMapMetadataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lexbeField"] = this.lexbeField ? this.lexbeField.toJSON() : <any>undefined;
        if (Array.isArray(this.datMapColumns)) {
            data["datMapColumns"] = [];
            for (let item of this.datMapColumns)
                data["datMapColumns"].push(item);
        }
        return data;
    }
}

export interface IDatMapMetadataItem {
    lexbeField?: LexbeField;
    datMapColumns?: string[] | undefined;
}

export class DataColumn implements IDataColumn {
    site?: ISite;
    container?: IContainer;
    readonly designMode?: boolean;
    allowDBNull?: boolean;
    autoIncrement?: boolean;
    autoIncrementSeed?: number;
    autoIncrementStep?: number;
    caption?: string | undefined;
    columnName?: string | undefined;
    prefix?: string | undefined;
    dataType?: Type;
    dateTimeMode?: DataSetDateTime;
    defaultValue?: any | undefined;
    expression?: string | undefined;
    readonly extendedProperties?: { [key: string]: any; } | undefined;
    maxLength?: number;
    namespace?: string | undefined;
    readonly ordinal?: number;
    readOnly?: boolean;
    table?: DataTable;
    unique?: boolean;
    columnMapping?: MappingType;

    constructor(data?: IDataColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowDBNull = true;
            this.autoIncrement = false;
            this.autoIncrementSeed = 0;
            this.autoIncrementStep = 1;
            this.columnName = "";
            this.prefix = "";
            this.expression = "";
            this.maxLength = -1;
            this.readOnly = false;
            this.unique = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] ? ISite.fromJS(_data["site"]) : <any>undefined;
            this.container = _data["container"] ? IContainer.fromJS(_data["container"]) : <any>undefined;
            (<any>this).designMode = _data["designMode"];
            this.allowDBNull = _data["allowDBNull"] !== undefined ? _data["allowDBNull"] : true;
            this.autoIncrement = _data["autoIncrement"] !== undefined ? _data["autoIncrement"] : false;
            this.autoIncrementSeed = _data["autoIncrementSeed"] !== undefined ? _data["autoIncrementSeed"] : 0;
            this.autoIncrementStep = _data["autoIncrementStep"] !== undefined ? _data["autoIncrementStep"] : 1;
            this.caption = _data["caption"];
            this.columnName = _data["columnName"] !== undefined ? _data["columnName"] : "";
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : "";
            this.dataType = _data["dataType"] ? Type.fromJS(_data["dataType"]) : <any>undefined;
            this.dateTimeMode = _data["dateTimeMode"];
            this.defaultValue = _data["defaultValue"];
            this.expression = _data["expression"] !== undefined ? _data["expression"] : "";
            if (_data["extendedProperties"]) {
                (<any>this).extendedProperties = {} as any;
                for (let key in _data["extendedProperties"]) {
                    if (_data["extendedProperties"].hasOwnProperty(key))
                        (<any>(<any>this).extendedProperties)![key] = _data["extendedProperties"][key];
                }
            }
            this.maxLength = _data["maxLength"] !== undefined ? _data["maxLength"] : -1;
            this.namespace = _data["namespace"];
            (<any>this).ordinal = _data["ordinal"];
            this.readOnly = _data["readOnly"] !== undefined ? _data["readOnly"] : false;
            this.table = _data["table"] ? DataTable.fromJS(_data["table"]) : <any>undefined;
            this.unique = _data["unique"] !== undefined ? _data["unique"] : false;
            this.columnMapping = _data["columnMapping"];
        }
    }

    static fromJS(data: any): DataColumn {
        data = typeof data === 'object' ? data : {};
        let result = new DataColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["designMode"] = this.designMode;
        data["allowDBNull"] = this.allowDBNull;
        data["autoIncrement"] = this.autoIncrement;
        data["autoIncrementSeed"] = this.autoIncrementSeed;
        data["autoIncrementStep"] = this.autoIncrementStep;
        data["caption"] = this.caption;
        data["columnName"] = this.columnName;
        data["prefix"] = this.prefix;
        data["dataType"] = this.dataType ? this.dataType.toJSON() : <any>undefined;
        data["dateTimeMode"] = this.dateTimeMode;
        data["defaultValue"] = this.defaultValue;
        data["expression"] = this.expression;
        if (this.extendedProperties) {
            data["extendedProperties"] = {};
            for (let key in this.extendedProperties) {
                if (this.extendedProperties.hasOwnProperty(key))
                    (<any>data["extendedProperties"])[key] = (<any>this.extendedProperties)[key];
            }
        }
        data["maxLength"] = this.maxLength;
        data["namespace"] = this.namespace;
        data["ordinal"] = this.ordinal;
        data["readOnly"] = this.readOnly;
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        data["unique"] = this.unique;
        data["columnMapping"] = this.columnMapping;
        return data;
    }
}

export interface IDataColumn {
    site?: ISite;
    container?: IContainer;
    designMode?: boolean;
    allowDBNull?: boolean;
    autoIncrement?: boolean;
    autoIncrementSeed?: number;
    autoIncrementStep?: number;
    caption?: string | undefined;
    columnName?: string | undefined;
    prefix?: string | undefined;
    dataType?: Type;
    dateTimeMode?: DataSetDateTime;
    defaultValue?: any | undefined;
    expression?: string | undefined;
    extendedProperties?: { [key: string]: any; } | undefined;
    maxLength?: number;
    namespace?: string | undefined;
    ordinal?: number;
    readOnly?: boolean;
    table?: DataTable;
    unique?: boolean;
    columnMapping?: MappingType;
}

export class DataSet implements IDataSet {
    container?: IContainer;
    readonly designMode?: boolean;
    remotingFormat?: SerializationFormat;
    schemaSerializationMode?: SchemaSerializationMode;
    caseSensitive?: boolean;
    readonly defaultViewManager?: any[] | undefined;
    enforceConstraints?: boolean;
    dataSetName?: string | undefined;
    namespace?: string | undefined;
    prefix?: string | undefined;
    readonly extendedProperties?: { [key: string]: any; } | undefined;
    readonly hasErrors?: boolean;
    readonly isInitialized?: boolean;
    locale?: CultureInfo;
    site?: ISite;
    readonly relations?: any[] | undefined;
    readonly tables?: any[] | undefined;

    constructor(data?: IDataSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.caseSensitive = false;
            this.enforceConstraints = true;
            this.dataSetName = "";
            this.namespace = "";
            this.prefix = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"] ? IContainer.fromJS(_data["container"]) : <any>undefined;
            (<any>this).designMode = _data["designMode"];
            this.remotingFormat = _data["remotingFormat"];
            this.schemaSerializationMode = _data["schemaSerializationMode"];
            this.caseSensitive = _data["caseSensitive"] !== undefined ? _data["caseSensitive"] : false;
            if (Array.isArray(_data["defaultViewManager"])) {
                (<any>this).defaultViewManager = [] as any;
                for (let item of _data["defaultViewManager"])
                    (<any>this).defaultViewManager!.push(item);
            }
            this.enforceConstraints = _data["enforceConstraints"] !== undefined ? _data["enforceConstraints"] : true;
            this.dataSetName = _data["dataSetName"] !== undefined ? _data["dataSetName"] : "";
            this.namespace = _data["namespace"] !== undefined ? _data["namespace"] : "";
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : "";
            if (_data["extendedProperties"]) {
                (<any>this).extendedProperties = {} as any;
                for (let key in _data["extendedProperties"]) {
                    if (_data["extendedProperties"].hasOwnProperty(key))
                        (<any>(<any>this).extendedProperties)![key] = _data["extendedProperties"][key];
                }
            }
            (<any>this).hasErrors = _data["hasErrors"];
            (<any>this).isInitialized = _data["isInitialized"];
            this.locale = _data["locale"] ? CultureInfo.fromJS(_data["locale"]) : <any>undefined;
            this.site = _data["site"] ? ISite.fromJS(_data["site"]) : <any>undefined;
            if (Array.isArray(_data["relations"])) {
                (<any>this).relations = [] as any;
                for (let item of _data["relations"])
                    (<any>this).relations!.push(item);
            }
            if (Array.isArray(_data["tables"])) {
                (<any>this).tables = [] as any;
                for (let item of _data["tables"])
                    (<any>this).tables!.push(item);
            }
        }
    }

    static fromJS(data: any): DataSet {
        data = typeof data === 'object' ? data : {};
        let result = new DataSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["designMode"] = this.designMode;
        data["remotingFormat"] = this.remotingFormat;
        data["schemaSerializationMode"] = this.schemaSerializationMode;
        data["caseSensitive"] = this.caseSensitive;
        if (Array.isArray(this.defaultViewManager)) {
            data["defaultViewManager"] = [];
            for (let item of this.defaultViewManager)
                data["defaultViewManager"].push(item);
        }
        data["enforceConstraints"] = this.enforceConstraints;
        data["dataSetName"] = this.dataSetName;
        data["namespace"] = this.namespace;
        data["prefix"] = this.prefix;
        if (this.extendedProperties) {
            data["extendedProperties"] = {};
            for (let key in this.extendedProperties) {
                if (this.extendedProperties.hasOwnProperty(key))
                    (<any>data["extendedProperties"])[key] = (<any>this.extendedProperties)[key];
            }
        }
        data["hasErrors"] = this.hasErrors;
        data["isInitialized"] = this.isInitialized;
        data["locale"] = this.locale ? this.locale.toJSON() : <any>undefined;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item);
        }
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item);
        }
        return data;
    }
}

export interface IDataSet {
    container?: IContainer;
    designMode?: boolean;
    remotingFormat?: SerializationFormat;
    schemaSerializationMode?: SchemaSerializationMode;
    caseSensitive?: boolean;
    defaultViewManager?: any[] | undefined;
    enforceConstraints?: boolean;
    dataSetName?: string | undefined;
    namespace?: string | undefined;
    prefix?: string | undefined;
    extendedProperties?: { [key: string]: any; } | undefined;
    hasErrors?: boolean;
    isInitialized?: boolean;
    locale?: CultureInfo;
    site?: ISite;
    relations?: any[] | undefined;
    tables?: any[] | undefined;
}

export enum DataSetDateTime {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class DataTable implements IDataTable {
    container?: IContainer;
    readonly designMode?: boolean;
    caseSensitive?: boolean;
    readonly isInitialized?: boolean;
    remotingFormat?: SerializationFormat;
    readonly childRelations?: any[] | undefined;
    readonly columns?: any[] | undefined;
    readonly constraints?: any[] | undefined;
    dataSet?: DataSet;
    readonly defaultView?: any[] | undefined;
    displayExpression?: string | undefined;
    readonly extendedProperties?: { [key: string]: any; } | undefined;
    readonly hasErrors?: boolean;
    locale?: CultureInfo;
    minimumCapacity?: number;
    readonly parentRelations?: any[] | undefined;
    primaryKey?: DataColumn[] | undefined;
    readonly rows?: any[] | undefined;
    tableName?: string | undefined;
    namespace?: string | undefined;
    prefix?: string | undefined;
    site?: ISite;

    constructor(data?: IDataTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.displayExpression = "";
            this.minimumCapacity = 50;
            this.tableName = "";
            this.prefix = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.container = _data["container"] ? IContainer.fromJS(_data["container"]) : <any>undefined;
            (<any>this).designMode = _data["designMode"];
            this.caseSensitive = _data["caseSensitive"];
            (<any>this).isInitialized = _data["isInitialized"];
            this.remotingFormat = _data["remotingFormat"];
            if (Array.isArray(_data["childRelations"])) {
                (<any>this).childRelations = [] as any;
                for (let item of _data["childRelations"])
                    (<any>this).childRelations!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                (<any>this).columns = [] as any;
                for (let item of _data["columns"])
                    (<any>this).columns!.push(item);
            }
            if (Array.isArray(_data["constraints"])) {
                (<any>this).constraints = [] as any;
                for (let item of _data["constraints"])
                    (<any>this).constraints!.push(item);
            }
            this.dataSet = _data["dataSet"] ? DataSet.fromJS(_data["dataSet"]) : <any>undefined;
            if (Array.isArray(_data["defaultView"])) {
                (<any>this).defaultView = [] as any;
                for (let item of _data["defaultView"])
                    (<any>this).defaultView!.push(item);
            }
            this.displayExpression = _data["displayExpression"] !== undefined ? _data["displayExpression"] : "";
            if (_data["extendedProperties"]) {
                (<any>this).extendedProperties = {} as any;
                for (let key in _data["extendedProperties"]) {
                    if (_data["extendedProperties"].hasOwnProperty(key))
                        (<any>(<any>this).extendedProperties)![key] = _data["extendedProperties"][key];
                }
            }
            (<any>this).hasErrors = _data["hasErrors"];
            this.locale = _data["locale"] ? CultureInfo.fromJS(_data["locale"]) : <any>undefined;
            this.minimumCapacity = _data["minimumCapacity"] !== undefined ? _data["minimumCapacity"] : 50;
            if (Array.isArray(_data["parentRelations"])) {
                (<any>this).parentRelations = [] as any;
                for (let item of _data["parentRelations"])
                    (<any>this).parentRelations!.push(item);
            }
            if (Array.isArray(_data["primaryKey"])) {
                this.primaryKey = [] as any;
                for (let item of _data["primaryKey"])
                    this.primaryKey!.push(DataColumn.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                (<any>this).rows = [] as any;
                for (let item of _data["rows"])
                    (<any>this).rows!.push(item);
            }
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : "";
            this.namespace = _data["namespace"];
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : "";
            this.site = _data["site"] ? ISite.fromJS(_data["site"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataTable {
        data = typeof data === 'object' ? data : {};
        let result = new DataTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["designMode"] = this.designMode;
        data["caseSensitive"] = this.caseSensitive;
        data["isInitialized"] = this.isInitialized;
        data["remotingFormat"] = this.remotingFormat;
        if (Array.isArray(this.childRelations)) {
            data["childRelations"] = [];
            for (let item of this.childRelations)
                data["childRelations"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.constraints)) {
            data["constraints"] = [];
            for (let item of this.constraints)
                data["constraints"].push(item);
        }
        data["dataSet"] = this.dataSet ? this.dataSet.toJSON() : <any>undefined;
        if (Array.isArray(this.defaultView)) {
            data["defaultView"] = [];
            for (let item of this.defaultView)
                data["defaultView"].push(item);
        }
        data["displayExpression"] = this.displayExpression;
        if (this.extendedProperties) {
            data["extendedProperties"] = {};
            for (let key in this.extendedProperties) {
                if (this.extendedProperties.hasOwnProperty(key))
                    (<any>data["extendedProperties"])[key] = (<any>this.extendedProperties)[key];
            }
        }
        data["hasErrors"] = this.hasErrors;
        data["locale"] = this.locale ? this.locale.toJSON() : <any>undefined;
        data["minimumCapacity"] = this.minimumCapacity;
        if (Array.isArray(this.parentRelations)) {
            data["parentRelations"] = [];
            for (let item of this.parentRelations)
                data["parentRelations"].push(item);
        }
        if (Array.isArray(this.primaryKey)) {
            data["primaryKey"] = [];
            for (let item of this.primaryKey)
                data["primaryKey"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["tableName"] = this.tableName;
        data["namespace"] = this.namespace;
        data["prefix"] = this.prefix;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataTable {
    container?: IContainer;
    designMode?: boolean;
    caseSensitive?: boolean;
    isInitialized?: boolean;
    remotingFormat?: SerializationFormat;
    childRelations?: any[] | undefined;
    columns?: any[] | undefined;
    constraints?: any[] | undefined;
    dataSet?: DataSet;
    defaultView?: any[] | undefined;
    displayExpression?: string | undefined;
    extendedProperties?: { [key: string]: any; } | undefined;
    hasErrors?: boolean;
    locale?: CultureInfo;
    minimumCapacity?: number;
    parentRelations?: any[] | undefined;
    primaryKey?: DataColumn[] | undefined;
    rows?: any[] | undefined;
    tableName?: string | undefined;
    namespace?: string | undefined;
    prefix?: string | undefined;
    site?: ISite;
}

export class DateTimeFormatInfo implements IDateTimeFormatInfo {
    amDesignator?: string | undefined;
    calendar?: Calendar;
    dateSeparator?: string | undefined;
    firstDayOfWeek?: DayOfWeek;
    calendarWeekRule?: CalendarWeekRule;
    fullDateTimePattern?: string | undefined;
    longDatePattern?: string | undefined;
    longTimePattern?: string | undefined;
    monthDayPattern?: string | undefined;
    pmDesignator?: string | undefined;
    readonly rfC1123Pattern?: string | undefined;
    shortDatePattern?: string | undefined;
    shortTimePattern?: string | undefined;
    readonly sortableDateTimePattern?: string | undefined;
    timeSeparator?: string | undefined;
    readonly universalSortableDateTimePattern?: string | undefined;
    yearMonthPattern?: string | undefined;
    abbreviatedDayNames?: string[] | undefined;
    shortestDayNames?: string[] | undefined;
    dayNames?: string[] | undefined;
    abbreviatedMonthNames?: string[] | undefined;
    monthNames?: string[] | undefined;
    readonly isReadOnly?: boolean;
    readonly nativeCalendarName?: string | undefined;
    abbreviatedMonthGenitiveNames?: string[] | undefined;
    monthGenitiveNames?: string[] | undefined;

    constructor(data?: IDateTimeFormatInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amDesignator = _data["amDesignator"];
            this.calendar = _data["calendar"] ? Calendar.fromJS(_data["calendar"]) : <any>undefined;
            this.dateSeparator = _data["dateSeparator"];
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.calendarWeekRule = _data["calendarWeekRule"];
            this.fullDateTimePattern = _data["fullDateTimePattern"];
            this.longDatePattern = _data["longDatePattern"];
            this.longTimePattern = _data["longTimePattern"];
            this.monthDayPattern = _data["monthDayPattern"];
            this.pmDesignator = _data["pmDesignator"];
            (<any>this).rfC1123Pattern = _data["rfC1123Pattern"];
            this.shortDatePattern = _data["shortDatePattern"];
            this.shortTimePattern = _data["shortTimePattern"];
            (<any>this).sortableDateTimePattern = _data["sortableDateTimePattern"];
            this.timeSeparator = _data["timeSeparator"];
            (<any>this).universalSortableDateTimePattern = _data["universalSortableDateTimePattern"];
            this.yearMonthPattern = _data["yearMonthPattern"];
            if (Array.isArray(_data["abbreviatedDayNames"])) {
                this.abbreviatedDayNames = [] as any;
                for (let item of _data["abbreviatedDayNames"])
                    this.abbreviatedDayNames!.push(item);
            }
            if (Array.isArray(_data["shortestDayNames"])) {
                this.shortestDayNames = [] as any;
                for (let item of _data["shortestDayNames"])
                    this.shortestDayNames!.push(item);
            }
            if (Array.isArray(_data["dayNames"])) {
                this.dayNames = [] as any;
                for (let item of _data["dayNames"])
                    this.dayNames!.push(item);
            }
            if (Array.isArray(_data["abbreviatedMonthNames"])) {
                this.abbreviatedMonthNames = [] as any;
                for (let item of _data["abbreviatedMonthNames"])
                    this.abbreviatedMonthNames!.push(item);
            }
            if (Array.isArray(_data["monthNames"])) {
                this.monthNames = [] as any;
                for (let item of _data["monthNames"])
                    this.monthNames!.push(item);
            }
            (<any>this).isReadOnly = _data["isReadOnly"];
            (<any>this).nativeCalendarName = _data["nativeCalendarName"];
            if (Array.isArray(_data["abbreviatedMonthGenitiveNames"])) {
                this.abbreviatedMonthGenitiveNames = [] as any;
                for (let item of _data["abbreviatedMonthGenitiveNames"])
                    this.abbreviatedMonthGenitiveNames!.push(item);
            }
            if (Array.isArray(_data["monthGenitiveNames"])) {
                this.monthGenitiveNames = [] as any;
                for (let item of _data["monthGenitiveNames"])
                    this.monthGenitiveNames!.push(item);
            }
        }
    }

    static fromJS(data: any): DateTimeFormatInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormatInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amDesignator"] = this.amDesignator;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        data["dateSeparator"] = this.dateSeparator;
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["calendarWeekRule"] = this.calendarWeekRule;
        data["fullDateTimePattern"] = this.fullDateTimePattern;
        data["longDatePattern"] = this.longDatePattern;
        data["longTimePattern"] = this.longTimePattern;
        data["monthDayPattern"] = this.monthDayPattern;
        data["pmDesignator"] = this.pmDesignator;
        data["rfC1123Pattern"] = this.rfC1123Pattern;
        data["shortDatePattern"] = this.shortDatePattern;
        data["shortTimePattern"] = this.shortTimePattern;
        data["sortableDateTimePattern"] = this.sortableDateTimePattern;
        data["timeSeparator"] = this.timeSeparator;
        data["universalSortableDateTimePattern"] = this.universalSortableDateTimePattern;
        data["yearMonthPattern"] = this.yearMonthPattern;
        if (Array.isArray(this.abbreviatedDayNames)) {
            data["abbreviatedDayNames"] = [];
            for (let item of this.abbreviatedDayNames)
                data["abbreviatedDayNames"].push(item);
        }
        if (Array.isArray(this.shortestDayNames)) {
            data["shortestDayNames"] = [];
            for (let item of this.shortestDayNames)
                data["shortestDayNames"].push(item);
        }
        if (Array.isArray(this.dayNames)) {
            data["dayNames"] = [];
            for (let item of this.dayNames)
                data["dayNames"].push(item);
        }
        if (Array.isArray(this.abbreviatedMonthNames)) {
            data["abbreviatedMonthNames"] = [];
            for (let item of this.abbreviatedMonthNames)
                data["abbreviatedMonthNames"].push(item);
        }
        if (Array.isArray(this.monthNames)) {
            data["monthNames"] = [];
            for (let item of this.monthNames)
                data["monthNames"].push(item);
        }
        data["isReadOnly"] = this.isReadOnly;
        data["nativeCalendarName"] = this.nativeCalendarName;
        if (Array.isArray(this.abbreviatedMonthGenitiveNames)) {
            data["abbreviatedMonthGenitiveNames"] = [];
            for (let item of this.abbreviatedMonthGenitiveNames)
                data["abbreviatedMonthGenitiveNames"].push(item);
        }
        if (Array.isArray(this.monthGenitiveNames)) {
            data["monthGenitiveNames"] = [];
            for (let item of this.monthGenitiveNames)
                data["monthGenitiveNames"].push(item);
        }
        return data;
    }
}

export interface IDateTimeFormatInfo {
    amDesignator?: string | undefined;
    calendar?: Calendar;
    dateSeparator?: string | undefined;
    firstDayOfWeek?: DayOfWeek;
    calendarWeekRule?: CalendarWeekRule;
    fullDateTimePattern?: string | undefined;
    longDatePattern?: string | undefined;
    longTimePattern?: string | undefined;
    monthDayPattern?: string | undefined;
    pmDesignator?: string | undefined;
    rfC1123Pattern?: string | undefined;
    shortDatePattern?: string | undefined;
    shortTimePattern?: string | undefined;
    sortableDateTimePattern?: string | undefined;
    timeSeparator?: string | undefined;
    universalSortableDateTimePattern?: string | undefined;
    yearMonthPattern?: string | undefined;
    abbreviatedDayNames?: string[] | undefined;
    shortestDayNames?: string[] | undefined;
    dayNames?: string[] | undefined;
    abbreviatedMonthNames?: string[] | undefined;
    monthNames?: string[] | undefined;
    isReadOnly?: boolean;
    nativeCalendarName?: string | undefined;
    abbreviatedMonthGenitiveNames?: string[] | undefined;
    monthGenitiveNames?: string[] | undefined;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum DigitShapes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class DirectoryFileModel implements IDirectoryFileModel {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    filePath?: string | undefined;

    constructor(data?: IDirectoryFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): DirectoryFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IDirectoryFileModel {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    filePath?: string | undefined;
}

export class DirectoryFolderModel implements IDirectoryFolderModel {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    filePath?: string | undefined;
    parent?: ParentModel;
    children?: DirectoryFileModel[] | undefined;

    constructor(data?: IDirectoryFolderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.filePath = _data["filePath"];
            this.parent = _data["parent"] ? ParentModel.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(DirectoryFileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DirectoryFolderModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryFolderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["filePath"] = this.filePath;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDirectoryFolderModel {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    filePath?: string | undefined;
    parent?: ParentModel;
    children?: DirectoryFileModel[] | undefined;
}

export class DirectoryFolderModelPagingResponse implements IDirectoryFolderModelPagingResponse {
    value?: DirectoryFolderModel[] | undefined;
    count?: number | undefined;

    constructor(data?: IDirectoryFolderModelPagingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(DirectoryFolderModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DirectoryFolderModelPagingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryFolderModelPagingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IDirectoryFolderModelPagingResponse {
    value?: DirectoryFolderModel[] | undefined;
    count?: number | undefined;
}

export enum DisplayType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class Doc implements IDoc {
    docId?: string;
    caseId?: string;
    uploadBatchId?: string;
    privilege?: boolean;
    workProduct?: boolean;
    redactForPrivilege?: boolean | undefined;
    redactForPi?: boolean | undefined;
    confidential?: boolean;
    responsive?: number;
    emailFamilyId?: string;
    emailTypeId?: string;
    lifeCycle?: number;
    docSource?: string | undefined;
    docType?: string | undefined;
    createdById?: string;
    pageCount?: number;
    parentDocId?: string;
    docSize?: number;
    docTitle?: string | undefined;
    docOriginalTitle?: string | undefined;
    docExtension?: string | undefined;
    docOriginalExtension?: string | undefined;
    isDuplicate?: boolean;
    textGroupId?: number;
    dedupFamilyId?: string;
    dedupHash?: string | undefined;
    hasNotes?: boolean;
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
    controlNumber?: number;
    custodianId?: string;
    isKey?: boolean;
    docDate?: Date | undefined;
    dateTimeUploaded?: Date;
    dateSent?: Date | undefined;
    dateReceived?: Date | undefined;
    dateCreated?: Date | undefined;
    masterDate?: Date | undefined;
    dateLastModified?: Date | undefined;
    customDesignation?: boolean;
    hasBeenReviewed?: boolean;
    fromField?: string | undefined;
    toField?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subjectMatter?: string | undefined;
    author?: string | undefined;
    lastModifiedBy?: string | undefined;
    description?: string | undefined;
    sourceFilePath?: string | undefined;
    folderId?: string;
    case?: Case;
    uploadBatch?: UploadBatch;
    docNotes?: DocNotes[] | undefined;
    files?: FileLexbe[] | undefined;
    docsInFacts?: DocsInFact[] | undefined;

    constructor(data?: IDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.uploadBatchId = _data["uploadBatchId"];
            this.privilege = _data["privilege"];
            this.workProduct = _data["workProduct"];
            this.redactForPrivilege = _data["redactForPrivilege"];
            this.redactForPi = _data["redactForPi"];
            this.confidential = _data["confidential"];
            this.responsive = _data["responsive"];
            this.emailFamilyId = _data["emailFamilyId"];
            this.emailTypeId = _data["emailTypeId"];
            this.lifeCycle = _data["lifeCycle"];
            this.docSource = _data["docSource"];
            this.docType = _data["docType"];
            this.createdById = _data["createdById"];
            this.pageCount = _data["pageCount"];
            this.parentDocId = _data["parentDocId"];
            this.docSize = _data["docSize"];
            this.docTitle = _data["docTitle"];
            this.docOriginalTitle = _data["docOriginalTitle"];
            this.docExtension = _data["docExtension"];
            this.docOriginalExtension = _data["docOriginalExtension"];
            this.isDuplicate = _data["isDuplicate"];
            this.textGroupId = _data["textGroupId"];
            this.dedupFamilyId = _data["dedupFamilyId"];
            this.dedupHash = _data["dedupHash"];
            this.hasNotes = _data["hasNotes"];
            this.batesPrefix = _data["batesPrefix"];
            this.batesNumberStart = _data["batesNumberStart"];
            this.batesNumberDigits = _data["batesNumberDigits"];
            this.controlNumber = _data["controlNumber"];
            this.custodianId = _data["custodianId"];
            this.isKey = _data["isKey"];
            this.docDate = _data["docDate"] ? new Date(_data["docDate"].toString()) : <any>undefined;
            this.dateTimeUploaded = _data["dateTimeUploaded"] ? new Date(_data["dateTimeUploaded"].toString()) : <any>undefined;
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.masterDate = _data["masterDate"] ? new Date(_data["masterDate"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
            this.customDesignation = _data["customDesignation"];
            this.hasBeenReviewed = _data["hasBeenReviewed"];
            this.fromField = _data["fromField"];
            this.toField = _data["toField"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.subjectMatter = _data["subjectMatter"];
            this.author = _data["author"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.description = _data["description"];
            this.sourceFilePath = _data["sourceFilePath"];
            this.folderId = _data["folderId"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.uploadBatch = _data["uploadBatch"] ? UploadBatch.fromJS(_data["uploadBatch"]) : <any>undefined;
            if (Array.isArray(_data["docNotes"])) {
                this.docNotes = [] as any;
                for (let item of _data["docNotes"])
                    this.docNotes!.push(DocNotes.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileLexbe.fromJS(item));
            }
            if (Array.isArray(_data["docsInFacts"])) {
                this.docsInFacts = [] as any;
                for (let item of _data["docsInFacts"])
                    this.docsInFacts!.push(DocsInFact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Doc {
        data = typeof data === 'object' ? data : {};
        let result = new Doc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["uploadBatchId"] = this.uploadBatchId;
        data["privilege"] = this.privilege;
        data["workProduct"] = this.workProduct;
        data["redactForPrivilege"] = this.redactForPrivilege;
        data["redactForPi"] = this.redactForPi;
        data["confidential"] = this.confidential;
        data["responsive"] = this.responsive;
        data["emailFamilyId"] = this.emailFamilyId;
        data["emailTypeId"] = this.emailTypeId;
        data["lifeCycle"] = this.lifeCycle;
        data["docSource"] = this.docSource;
        data["docType"] = this.docType;
        data["createdById"] = this.createdById;
        data["pageCount"] = this.pageCount;
        data["parentDocId"] = this.parentDocId;
        data["docSize"] = this.docSize;
        data["docTitle"] = this.docTitle;
        data["docOriginalTitle"] = this.docOriginalTitle;
        data["docExtension"] = this.docExtension;
        data["docOriginalExtension"] = this.docOriginalExtension;
        data["isDuplicate"] = this.isDuplicate;
        data["textGroupId"] = this.textGroupId;
        data["dedupFamilyId"] = this.dedupFamilyId;
        data["dedupHash"] = this.dedupHash;
        data["hasNotes"] = this.hasNotes;
        data["batesPrefix"] = this.batesPrefix;
        data["batesNumberStart"] = this.batesNumberStart;
        data["batesNumberDigits"] = this.batesNumberDigits;
        data["controlNumber"] = this.controlNumber;
        data["custodianId"] = this.custodianId;
        data["isKey"] = this.isKey;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["dateTimeUploaded"] = this.dateTimeUploaded ? this.dateTimeUploaded.toISOString() : <any>undefined;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["masterDate"] = this.masterDate ? this.masterDate.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        data["customDesignation"] = this.customDesignation;
        data["hasBeenReviewed"] = this.hasBeenReviewed;
        data["fromField"] = this.fromField;
        data["toField"] = this.toField;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["subjectMatter"] = this.subjectMatter;
        data["author"] = this.author;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["description"] = this.description;
        data["sourceFilePath"] = this.sourceFilePath;
        data["folderId"] = this.folderId;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["uploadBatch"] = this.uploadBatch ? this.uploadBatch.toJSON() : <any>undefined;
        if (Array.isArray(this.docNotes)) {
            data["docNotes"] = [];
            for (let item of this.docNotes)
                data["docNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.docsInFacts)) {
            data["docsInFacts"] = [];
            for (let item of this.docsInFacts)
                data["docsInFacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoc {
    docId?: string;
    caseId?: string;
    uploadBatchId?: string;
    privilege?: boolean;
    workProduct?: boolean;
    redactForPrivilege?: boolean | undefined;
    redactForPi?: boolean | undefined;
    confidential?: boolean;
    responsive?: number;
    emailFamilyId?: string;
    emailTypeId?: string;
    lifeCycle?: number;
    docSource?: string | undefined;
    docType?: string | undefined;
    createdById?: string;
    pageCount?: number;
    parentDocId?: string;
    docSize?: number;
    docTitle?: string | undefined;
    docOriginalTitle?: string | undefined;
    docExtension?: string | undefined;
    docOriginalExtension?: string | undefined;
    isDuplicate?: boolean;
    textGroupId?: number;
    dedupFamilyId?: string;
    dedupHash?: string | undefined;
    hasNotes?: boolean;
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
    controlNumber?: number;
    custodianId?: string;
    isKey?: boolean;
    docDate?: Date | undefined;
    dateTimeUploaded?: Date;
    dateSent?: Date | undefined;
    dateReceived?: Date | undefined;
    dateCreated?: Date | undefined;
    masterDate?: Date | undefined;
    dateLastModified?: Date | undefined;
    customDesignation?: boolean;
    hasBeenReviewed?: boolean;
    fromField?: string | undefined;
    toField?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subjectMatter?: string | undefined;
    author?: string | undefined;
    lastModifiedBy?: string | undefined;
    description?: string | undefined;
    sourceFilePath?: string | undefined;
    folderId?: string;
    case?: Case;
    uploadBatch?: UploadBatch;
    docNotes?: DocNotes[] | undefined;
    files?: FileLexbe[] | undefined;
    docsInFacts?: DocsInFact[] | undefined;
}

export class DocChangeSetReference implements IDocChangeSetReference {
    documentId?: string;
    changeSetId?: string;
    documentName?: string | undefined;
    createdAt?: Date;

    constructor(data?: IDocChangeSetReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.changeSetId = _data["changeSetId"];
            this.documentName = _data["documentName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocChangeSetReference {
        data = typeof data === 'object' ? data : {};
        let result = new DocChangeSetReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["changeSetId"] = this.changeSetId;
        data["documentName"] = this.documentName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocChangeSetReference {
    documentId?: string;
    changeSetId?: string;
    documentName?: string | undefined;
    createdAt?: Date;
}

export class DocContent implements IDocContent {
    docId?: string;
    textForDiffing?: string | undefined;

    constructor(data?: IDocContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.textForDiffing = _data["textForDiffing"];
        }
    }

    static fromJS(data: any): DocContent {
        data = typeof data === 'object' ? data : {};
        let result = new DocContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["textForDiffing"] = this.textForDiffing;
        return data;
    }
}

export interface IDocContent {
    docId?: string;
    textForDiffing?: string | undefined;
}

export class DocDupViewModel implements IDocDupViewModel {
    docId?: string;
    docTitle?: string | undefined;
    docExtension?: string | undefined;
    isDuplicate?: boolean;
    textGroupId?: number;
    emailType?: LexbeEmailType;

    constructor(data?: IDocDupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.docTitle = _data["docTitle"];
            this.docExtension = _data["docExtension"];
            this.isDuplicate = _data["isDuplicate"];
            this.textGroupId = _data["textGroupId"];
            this.emailType = _data["emailType"] ? LexbeEmailType.fromJS(_data["emailType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocDupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocDupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["docTitle"] = this.docTitle;
        data["docExtension"] = this.docExtension;
        data["isDuplicate"] = this.isDuplicate;
        data["textGroupId"] = this.textGroupId;
        data["emailType"] = this.emailType ? this.emailType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocDupViewModel {
    docId?: string;
    docTitle?: string | undefined;
    docExtension?: string | undefined;
    isDuplicate?: boolean;
    textGroupId?: number;
    emailType?: LexbeEmailType;
}

export enum DocIssueTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
}

export class DocNotes implements IDocNotes {
    docNoteId?: string | undefined;
    docNoteTitle?: string | undefined;
    docNote?: string | undefined;
    pageNumber?: number;
    isPrivate?: boolean;
    docId?: string;
    createdById?: string;
    dateTimeCreated?: Date;
    doc?: Doc;

    constructor(data?: IDocNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNoteId = _data["docNoteId"];
            this.docNoteTitle = _data["docNoteTitle"];
            this.docNote = _data["docNote"];
            this.pageNumber = _data["pageNumber"];
            this.isPrivate = _data["isPrivate"];
            this.docId = _data["docId"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.doc = _data["doc"] ? Doc.fromJS(_data["doc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocNotes {
        data = typeof data === 'object' ? data : {};
        let result = new DocNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNoteId"] = this.docNoteId;
        data["docNoteTitle"] = this.docNoteTitle;
        data["docNote"] = this.docNote;
        data["pageNumber"] = this.pageNumber;
        data["isPrivate"] = this.isPrivate;
        data["docId"] = this.docId;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["doc"] = this.doc ? this.doc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocNotes {
    docNoteId?: string | undefined;
    docNoteTitle?: string | undefined;
    docNote?: string | undefined;
    pageNumber?: number;
    isPrivate?: boolean;
    docId?: string;
    createdById?: string;
    dateTimeCreated?: Date;
    doc?: Doc;
}

export class DocViewModel implements IDocViewModel {
    docTitle?: string | undefined;
    docExtension?: string | undefined;

    constructor(data?: IDocViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTitle = _data["docTitle"];
            this.docExtension = _data["docExtension"];
        }
    }

    static fromJS(data: any): DocViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTitle"] = this.docTitle;
        data["docExtension"] = this.docExtension;
        return data;
    }
}

export interface IDocViewModel {
    docTitle?: string | undefined;
    docExtension?: string | undefined;
}

export class DocsInFact implements IDocsInFact {
    factId?: string;
    docId?: string;
    pageNumber?: number;
    caseId?: string;
    fact?: Fact;
    doc?: Doc;
    case?: Case;

    constructor(data?: IDocsInFact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.docId = _data["docId"];
            this.pageNumber = _data["pageNumber"];
            this.caseId = _data["caseId"];
            this.fact = _data["fact"] ? Fact.fromJS(_data["fact"]) : <any>undefined;
            this.doc = _data["doc"] ? Doc.fromJS(_data["doc"]) : <any>undefined;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocsInFact {
        data = typeof data === 'object' ? data : {};
        let result = new DocsInFact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["docId"] = this.docId;
        data["pageNumber"] = this.pageNumber;
        data["caseId"] = this.caseId;
        data["fact"] = this.fact ? this.fact.toJSON() : <any>undefined;
        data["doc"] = this.doc ? this.doc.toJSON() : <any>undefined;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocsInFact {
    factId?: string;
    docId?: string;
    pageNumber?: number;
    caseId?: string;
    fact?: Fact;
    doc?: Doc;
    case?: Case;
}

export class DocsInFactState implements IDocsInFactState {
    factId?: string;
    docId?: string;
    pageNumber?: number;
    caseId?: string;

    constructor(data?: IDocsInFactState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.docId = _data["docId"];
            this.pageNumber = _data["pageNumber"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): DocsInFactState {
        data = typeof data === 'object' ? data : {};
        let result = new DocsInFactState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["docId"] = this.docId;
        data["pageNumber"] = this.pageNumber;
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface IDocsInFactState {
    factId?: string;
    docId?: string;
    pageNumber?: number;
    caseId?: string;
}

export class DocsInFactViewModel implements IDocsInFactViewModel {
    factId?: string;
    docId?: string;
    caseId?: string;
    pageNumber?: number;
    doc?: DocViewModel;

    constructor(data?: IDocsInFactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.pageNumber = _data["pageNumber"];
            this.doc = _data["doc"] ? DocViewModel.fromJS(_data["doc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocsInFactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocsInFactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["pageNumber"] = this.pageNumber;
        data["doc"] = this.doc ? this.doc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocsInFactViewModel {
    factId?: string;
    docId?: string;
    caseId?: string;
    pageNumber?: number;
    doc?: DocViewModel;
}

export class DocumentReviewState implements IDocumentReviewState {
    documentId?: string;
    userId?: string;
    caseId?: string;
    document?: LexbeDoc;
    codingFieldsState?: CodingFieldState[] | undefined;
    hasProducedFiles?: boolean;
    tabStates?: TabState[] | undefined;
    reviewStatus?: number;
    splitDocs?: SplitDocumentState;
    documentInfo?: AdminDownloadDocInfo;
    facts?: FactState[] | undefined;
    issues?: IssueState[] | undefined;
    notes?: LexbeDocNote[] | undefined;
    custodians?: CustodianState[] | undefined;
    auditHistory?: AuditState[] | undefined;
    folder?: FolderState;
    reviewDocs?: ReviewDocView[] | undefined;
    reviewSetId?: string;
    lastCodingChangeSet?: DocChangeSetReference;
    isProjection?: boolean;
    emailThreadGroupingId?: string | undefined;
    shouldPropagateCoding?: boolean;
    remainingReviewDocCount?: number;
    reviewedByMeCount?: number;

    constructor(data?: IDocumentReviewState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.userId = _data["userId"];
            this.caseId = _data["caseId"];
            this.document = _data["document"] ? LexbeDoc.fromJS(_data["document"]) : <any>undefined;
            if (Array.isArray(_data["codingFieldsState"])) {
                this.codingFieldsState = [] as any;
                for (let item of _data["codingFieldsState"])
                    this.codingFieldsState!.push(CodingFieldState.fromJS(item));
            }
            this.hasProducedFiles = _data["hasProducedFiles"];
            if (Array.isArray(_data["tabStates"])) {
                this.tabStates = [] as any;
                for (let item of _data["tabStates"])
                    this.tabStates!.push(TabState.fromJS(item));
            }
            this.reviewStatus = _data["reviewStatus"];
            this.splitDocs = _data["splitDocs"] ? SplitDocumentState.fromJS(_data["splitDocs"]) : <any>undefined;
            this.documentInfo = _data["documentInfo"] ? AdminDownloadDocInfo.fromJS(_data["documentInfo"]) : <any>undefined;
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(FactState.fromJS(item));
            }
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(IssueState.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(LexbeDocNote.fromJS(item));
            }
            if (Array.isArray(_data["custodians"])) {
                this.custodians = [] as any;
                for (let item of _data["custodians"])
                    this.custodians!.push(CustodianState.fromJS(item));
            }
            if (Array.isArray(_data["auditHistory"])) {
                this.auditHistory = [] as any;
                for (let item of _data["auditHistory"])
                    this.auditHistory!.push(AuditState.fromJS(item));
            }
            this.folder = _data["folder"] ? FolderState.fromJS(_data["folder"]) : <any>undefined;
            if (Array.isArray(_data["reviewDocs"])) {
                this.reviewDocs = [] as any;
                for (let item of _data["reviewDocs"])
                    this.reviewDocs!.push(ReviewDocView.fromJS(item));
            }
            this.reviewSetId = _data["reviewSetId"];
            this.lastCodingChangeSet = _data["lastCodingChangeSet"] ? DocChangeSetReference.fromJS(_data["lastCodingChangeSet"]) : <any>undefined;
            this.isProjection = _data["isProjection"];
            this.emailThreadGroupingId = _data["emailThreadGroupingId"];
            this.shouldPropagateCoding = _data["shouldPropagateCoding"];
            this.remainingReviewDocCount = _data["remainingReviewDocCount"];
            this.reviewedByMeCount = _data["reviewedByMeCount"];
        }
    }

    static fromJS(data: any): DocumentReviewState {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReviewState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["userId"] = this.userId;
        data["caseId"] = this.caseId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        if (Array.isArray(this.codingFieldsState)) {
            data["codingFieldsState"] = [];
            for (let item of this.codingFieldsState)
                data["codingFieldsState"].push(item.toJSON());
        }
        data["hasProducedFiles"] = this.hasProducedFiles;
        if (Array.isArray(this.tabStates)) {
            data["tabStates"] = [];
            for (let item of this.tabStates)
                data["tabStates"].push(item.toJSON());
        }
        data["reviewStatus"] = this.reviewStatus;
        data["splitDocs"] = this.splitDocs ? this.splitDocs.toJSON() : <any>undefined;
        data["documentInfo"] = this.documentInfo ? this.documentInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item.toJSON());
        }
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.custodians)) {
            data["custodians"] = [];
            for (let item of this.custodians)
                data["custodians"].push(item.toJSON());
        }
        if (Array.isArray(this.auditHistory)) {
            data["auditHistory"] = [];
            for (let item of this.auditHistory)
                data["auditHistory"].push(item.toJSON());
        }
        data["folder"] = this.folder ? this.folder.toJSON() : <any>undefined;
        if (Array.isArray(this.reviewDocs)) {
            data["reviewDocs"] = [];
            for (let item of this.reviewDocs)
                data["reviewDocs"].push(item.toJSON());
        }
        data["reviewSetId"] = this.reviewSetId;
        data["lastCodingChangeSet"] = this.lastCodingChangeSet ? this.lastCodingChangeSet.toJSON() : <any>undefined;
        data["isProjection"] = this.isProjection;
        data["emailThreadGroupingId"] = this.emailThreadGroupingId;
        data["shouldPropagateCoding"] = this.shouldPropagateCoding;
        data["remainingReviewDocCount"] = this.remainingReviewDocCount;
        data["reviewedByMeCount"] = this.reviewedByMeCount;
        return data;
    }
}

export interface IDocumentReviewState {
    documentId?: string;
    userId?: string;
    caseId?: string;
    document?: LexbeDoc;
    codingFieldsState?: CodingFieldState[] | undefined;
    hasProducedFiles?: boolean;
    tabStates?: TabState[] | undefined;
    reviewStatus?: number;
    splitDocs?: SplitDocumentState;
    documentInfo?: AdminDownloadDocInfo;
    facts?: FactState[] | undefined;
    issues?: IssueState[] | undefined;
    notes?: LexbeDocNote[] | undefined;
    custodians?: CustodianState[] | undefined;
    auditHistory?: AuditState[] | undefined;
    folder?: FolderState;
    reviewDocs?: ReviewDocView[] | undefined;
    reviewSetId?: string;
    lastCodingChangeSet?: DocChangeSetReference;
    isProjection?: boolean;
    emailThreadGroupingId?: string | undefined;
    shouldPropagateCoding?: boolean;
    remainingReviewDocCount?: number;
    reviewedByMeCount?: number;
}

export class DocumentReviewStateRequest implements IDocumentReviewStateRequest {
    documentId?: string;
    userId?: string;
    caseId?: string;
    projectChangeSets?: DocChangeSetReference[] | undefined;
    reviewSetId?: string;
    accountRoleIds?: string[] | undefined;

    constructor(data?: IDocumentReviewStateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.userId = _data["userId"];
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["projectChangeSets"])) {
                this.projectChangeSets = [] as any;
                for (let item of _data["projectChangeSets"])
                    this.projectChangeSets!.push(DocChangeSetReference.fromJS(item));
            }
            this.reviewSetId = _data["reviewSetId"];
            if (Array.isArray(_data["accountRoleIds"])) {
                this.accountRoleIds = [] as any;
                for (let item of _data["accountRoleIds"])
                    this.accountRoleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentReviewStateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReviewStateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["userId"] = this.userId;
        data["caseId"] = this.caseId;
        if (Array.isArray(this.projectChangeSets)) {
            data["projectChangeSets"] = [];
            for (let item of this.projectChangeSets)
                data["projectChangeSets"].push(item.toJSON());
        }
        data["reviewSetId"] = this.reviewSetId;
        if (Array.isArray(this.accountRoleIds)) {
            data["accountRoleIds"] = [];
            for (let item of this.accountRoleIds)
                data["accountRoleIds"].push(item);
        }
        return data;
    }
}

export interface IDocumentReviewStateRequest {
    documentId?: string;
    userId?: string;
    caseId?: string;
    projectChangeSets?: DocChangeSetReference[] | undefined;
    reviewSetId?: string;
    accountRoleIds?: string[] | undefined;
}

export enum DocumentReviewValidationRuleType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class DownloadBriefcaseFileRequest implements IDownloadBriefcaseFileRequest {
    fileId?: string;

    constructor(data?: IDownloadBriefcaseFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): DownloadBriefcaseFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadBriefcaseFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IDownloadBriefcaseFileRequest {
    fileId?: string;
}

export class DownloadProductionWithheldFileRequest implements IDownloadProductionWithheldFileRequest {
    fileId?: string;
    fileType?: number;

    constructor(data?: IDownloadProductionWithheldFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): DownloadProductionWithheldFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadProductionWithheldFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface IDownloadProductionWithheldFileRequest {
    fileId?: string;
    fileType?: number;
}

export class DownloadResponse implements IDownloadResponse {
    downloadUrls?: string[] | undefined;

    constructor(data?: IDownloadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item);
        }
        return data;
    }
}

export interface IDownloadResponse {
    downloadUrls?: string[] | undefined;
}

export class EmailThread implements IEmailThread {
    id?: string;
    caseId?: string;
    threadGroupingId?: string;
    fieldPath?: string | undefined;
    readonly index?: number;
    parentId?: string | undefined;
    isSupersetOfParent?: boolean;
    isUnique?: boolean;
    primeDocId?: string | undefined;
    primeDoc?: LexbeDoc;
    docIds?: string[] | undefined;

    constructor(data?: IEmailThread) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.threadGroupingId = _data["threadGroupingId"];
            this.fieldPath = _data["fieldPath"];
            (<any>this).index = _data["index"];
            this.parentId = _data["parentId"];
            this.isSupersetOfParent = _data["isSupersetOfParent"];
            this.isUnique = _data["isUnique"];
            this.primeDocId = _data["primeDocId"];
            this.primeDoc = _data["primeDoc"] ? LexbeDoc.fromJS(_data["primeDoc"]) : <any>undefined;
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailThread {
        data = typeof data === 'object' ? data : {};
        let result = new EmailThread();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["threadGroupingId"] = this.threadGroupingId;
        data["fieldPath"] = this.fieldPath;
        data["index"] = this.index;
        data["parentId"] = this.parentId;
        data["isSupersetOfParent"] = this.isSupersetOfParent;
        data["isUnique"] = this.isUnique;
        data["primeDocId"] = this.primeDocId;
        data["primeDoc"] = this.primeDoc ? this.primeDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        return data;
    }
}

export interface IEmailThread {
    id?: string;
    caseId?: string;
    threadGroupingId?: string;
    fieldPath?: string | undefined;
    index?: number;
    parentId?: string | undefined;
    isSupersetOfParent?: boolean;
    isUnique?: boolean;
    primeDocId?: string | undefined;
    primeDoc?: LexbeDoc;
    docIds?: string[] | undefined;
}

export class EmailThreadDoc implements IEmailThreadDoc {
    threadGroupId?: string;
    docId?: string;
    docTitle?: string | undefined;
    docExtension?: string | undefined;
    fieldPath?: string | undefined;

    constructor(data?: IEmailThreadDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadGroupId = _data["threadGroupId"];
            this.docId = _data["docId"];
            this.docTitle = _data["docTitle"];
            this.docExtension = _data["docExtension"];
            this.fieldPath = _data["fieldPath"];
        }
    }

    static fromJS(data: any): EmailThreadDoc {
        data = typeof data === 'object' ? data : {};
        let result = new EmailThreadDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadGroupId"] = this.threadGroupId;
        data["docId"] = this.docId;
        data["docTitle"] = this.docTitle;
        data["docExtension"] = this.docExtension;
        data["fieldPath"] = this.fieldPath;
        return data;
    }
}

export interface IEmailThreadDoc {
    threadGroupId?: string;
    docId?: string;
    docTitle?: string | undefined;
    docExtension?: string | undefined;
    fieldPath?: string | undefined;
}

export class EmailThreadGrouping implements IEmailThreadGrouping {
    threadGroupingId?: string;
    docCount?: number;
    groupTitle?: string | undefined;
    threads?: EmailThread[] | undefined;

    constructor(data?: IEmailThreadGrouping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadGroupingId = _data["threadGroupingId"];
            this.docCount = _data["docCount"];
            this.groupTitle = _data["groupTitle"];
            if (Array.isArray(_data["threads"])) {
                this.threads = [] as any;
                for (let item of _data["threads"])
                    this.threads!.push(EmailThread.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailThreadGrouping {
        data = typeof data === 'object' ? data : {};
        let result = new EmailThreadGrouping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadGroupingId"] = this.threadGroupingId;
        data["docCount"] = this.docCount;
        data["groupTitle"] = this.groupTitle;
        if (Array.isArray(this.threads)) {
            data["threads"] = [];
            for (let item of this.threads)
                data["threads"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailThreadGrouping {
    threadGroupingId?: string;
    docCount?: number;
    groupTitle?: string | undefined;
    threads?: EmailThread[] | undefined;
}

export class EmailThreadSummary implements IEmailThreadSummary {
    caseId?: string;
    threadGroupingCount?: number;

    constructor(data?: IEmailThreadSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.threadGroupingCount = _data["threadGroupingCount"];
        }
    }

    static fromJS(data: any): EmailThreadSummary {
        data = typeof data === 'object' ? data : {};
        let result = new EmailThreadSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["threadGroupingCount"] = this.threadGroupingCount;
        return data;
    }
}

export interface IEmailThreadSummary {
    caseId?: string;
    threadGroupingCount?: number;
}

export enum EventAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
}

export class EventInfo implements IEventInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    readonly isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    readonly isMulticast?: boolean;
    eventHandlerType?: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            (<any>this).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    isMulticast?: boolean;
    eventHandlerType?: Type;
}

export class ExportLog implements IExportLog {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    searchParameter?: SearchParameter;
    expandToEmailFamily?: boolean;

    constructor(data?: IExportLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.filterId = _data["filterId"];
            this.selectAll = _data["selectAll"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
            this.expandToEmailFamily = _data["expandToEmailFamily"];
        }
    }

    static fromJS(data: any): ExportLog {
        data = typeof data === 'object' ? data : {};
        let result = new ExportLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["filterId"] = this.filterId;
        data["selectAll"] = this.selectAll;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        data["expandToEmailFamily"] = this.expandToEmailFamily;
        return data;
    }
}

export interface IExportLog {
    docIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    searchParameter?: SearchParameter;
    expandToEmailFamily?: boolean;
}

export class ExportResponse implements IExportResponse {
    downloadUrl?: string | undefined;
    exportId?: string;

    constructor(data?: IExportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"];
            this.exportId = _data["exportId"];
        }
    }

    static fromJS(data: any): ExportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl;
        data["exportId"] = this.exportId;
        return data;
    }
}

export interface IExportResponse {
    downloadUrl?: string | undefined;
    exportId?: string;
}

export class Fact implements IFact {
    factId?: string;
    caseId?: string;
    factTitle?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    contested?: number;
    material?: number;
    case?: Case;
    issues?: Issue[] | undefined;
    custodians?: Custodian[] | undefined;
    docsInFacts?: DocsInFact[] | undefined;

    constructor(data?: IFact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.caseId = _data["caseId"];
            this.factTitle = _data["factTitle"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.contested = _data["contested"];
            this.material = _data["material"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(Issue.fromJS(item));
            }
            if (Array.isArray(_data["custodians"])) {
                this.custodians = [] as any;
                for (let item of _data["custodians"])
                    this.custodians!.push(Custodian.fromJS(item));
            }
            if (Array.isArray(_data["docsInFacts"])) {
                this.docsInFacts = [] as any;
                for (let item of _data["docsInFacts"])
                    this.docsInFacts!.push(DocsInFact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Fact {
        data = typeof data === 'object' ? data : {};
        let result = new Fact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["caseId"] = this.caseId;
        data["factTitle"] = this.factTitle;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["contested"] = this.contested;
        data["material"] = this.material;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        if (Array.isArray(this.custodians)) {
            data["custodians"] = [];
            for (let item of this.custodians)
                data["custodians"].push(item.toJSON());
        }
        if (Array.isArray(this.docsInFacts)) {
            data["docsInFacts"] = [];
            for (let item of this.docsInFacts)
                data["docsInFacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFact {
    factId?: string;
    caseId?: string;
    factTitle?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    contested?: number;
    material?: number;
    case?: Case;
    issues?: Issue[] | undefined;
    custodians?: Custodian[] | undefined;
    docsInFacts?: DocsInFact[] | undefined;
}

export class FactState implements IFactState {
    factId?: string;
    caseId?: string;
    factTitle?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    contested?: number;
    material?: number;
    issues?: IssueState[] | undefined;
    custodians?: CustodianState[] | undefined;
    docsInFacts?: DocsInFactState[] | undefined;

    constructor(data?: IFactState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.caseId = _data["caseId"];
            this.factTitle = _data["factTitle"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.contested = _data["contested"];
            this.material = _data["material"];
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(IssueState.fromJS(item));
            }
            if (Array.isArray(_data["custodians"])) {
                this.custodians = [] as any;
                for (let item of _data["custodians"])
                    this.custodians!.push(CustodianState.fromJS(item));
            }
            if (Array.isArray(_data["docsInFacts"])) {
                this.docsInFacts = [] as any;
                for (let item of _data["docsInFacts"])
                    this.docsInFacts!.push(DocsInFactState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FactState {
        data = typeof data === 'object' ? data : {};
        let result = new FactState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["caseId"] = this.caseId;
        data["factTitle"] = this.factTitle;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["contested"] = this.contested;
        data["material"] = this.material;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        if (Array.isArray(this.custodians)) {
            data["custodians"] = [];
            for (let item of this.custodians)
                data["custodians"].push(item.toJSON());
        }
        if (Array.isArray(this.docsInFacts)) {
            data["docsInFacts"] = [];
            for (let item of this.docsInFacts)
                data["docsInFacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFactState {
    factId?: string;
    caseId?: string;
    factTitle?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    contested?: number;
    material?: number;
    issues?: IssueState[] | undefined;
    custodians?: CustodianState[] | undefined;
    docsInFacts?: DocsInFactState[] | undefined;
}

export class FactViewModel implements IFactViewModel {
    factId?: string;
    caseId?: string;
    factTitle?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    contested?: number;
    material?: number;
    issues?: IssueViewModel[] | undefined;
    custodians?: CustodianIdName[] | undefined;
    docsInFacts?: DocsInFactViewModel[] | undefined;

    constructor(data?: IFactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.caseId = _data["caseId"];
            this.factTitle = _data["factTitle"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.contested = _data["contested"];
            this.material = _data["material"];
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(IssueViewModel.fromJS(item));
            }
            if (Array.isArray(_data["custodians"])) {
                this.custodians = [] as any;
                for (let item of _data["custodians"])
                    this.custodians!.push(CustodianIdName.fromJS(item));
            }
            if (Array.isArray(_data["docsInFacts"])) {
                this.docsInFacts = [] as any;
                for (let item of _data["docsInFacts"])
                    this.docsInFacts!.push(DocsInFactViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["caseId"] = this.caseId;
        data["factTitle"] = this.factTitle;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["contested"] = this.contested;
        data["material"] = this.material;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        if (Array.isArray(this.custodians)) {
            data["custodians"] = [];
            for (let item of this.custodians)
                data["custodians"].push(item.toJSON());
        }
        if (Array.isArray(this.docsInFacts)) {
            data["docsInFacts"] = [];
            for (let item of this.docsInFacts)
                data["docsInFacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFactViewModel {
    factId?: string;
    caseId?: string;
    factTitle?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    contested?: number;
    material?: number;
    issues?: IssueViewModel[] | undefined;
    custodians?: CustodianIdName[] | undefined;
    docsInFacts?: DocsInFactViewModel[] | undefined;
}

export enum FieldAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _32768 = 32768,
    _38144 = 38144,
}

export class FieldInfo implements IFieldInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    readonly isInitOnly?: boolean;
    readonly isLiteral?: boolean;
    readonly isNotSerialized?: boolean;
    readonly isPinvokeImpl?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : <any>undefined;
            (<any>this).isInitOnly = _data["isInitOnly"];
            (<any>this).isLiteral = _data["isLiteral"];
            (<any>this).isNotSerialized = _data["isNotSerialized"];
            (<any>this).isPinvokeImpl = _data["isPinvokeImpl"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    isInitOnly?: boolean;
    isLiteral?: boolean;
    isNotSerialized?: boolean;
    isPinvokeImpl?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;
}

export class FieldLayout implements IFieldLayout {
    fieldLayoutId?: string;
    caseId?: string;
    displayTitle?: string | undefined;
    modifiedByUserId?: string;
    modifiedDateTime?: Date;
    isPinned?: boolean;
    isShared?: boolean;
    case?: Case;
    fieldLayoutUsers?: FieldLayoutUser[] | undefined;
    fieldLayoutFields?: FieldLayoutField[] | undefined;
    fieldLayoutDefaults?: FieldLayoutDefault[] | undefined;

    constructor(data?: IFieldLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.caseId = _data["caseId"];
            this.displayTitle = _data["displayTitle"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedDateTime = _data["modifiedDateTime"] ? new Date(_data["modifiedDateTime"].toString()) : <any>undefined;
            this.isPinned = _data["isPinned"];
            this.isShared = _data["isShared"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            if (Array.isArray(_data["fieldLayoutUsers"])) {
                this.fieldLayoutUsers = [] as any;
                for (let item of _data["fieldLayoutUsers"])
                    this.fieldLayoutUsers!.push(FieldLayoutUser.fromJS(item));
            }
            if (Array.isArray(_data["fieldLayoutFields"])) {
                this.fieldLayoutFields = [] as any;
                for (let item of _data["fieldLayoutFields"])
                    this.fieldLayoutFields!.push(FieldLayoutField.fromJS(item));
            }
            if (Array.isArray(_data["fieldLayoutDefaults"])) {
                this.fieldLayoutDefaults = [] as any;
                for (let item of _data["fieldLayoutDefaults"])
                    this.fieldLayoutDefaults!.push(FieldLayoutDefault.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldLayout {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["caseId"] = this.caseId;
        data["displayTitle"] = this.displayTitle;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedDateTime"] = this.modifiedDateTime ? this.modifiedDateTime.toISOString() : <any>undefined;
        data["isPinned"] = this.isPinned;
        data["isShared"] = this.isShared;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        if (Array.isArray(this.fieldLayoutUsers)) {
            data["fieldLayoutUsers"] = [];
            for (let item of this.fieldLayoutUsers)
                data["fieldLayoutUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldLayoutFields)) {
            data["fieldLayoutFields"] = [];
            for (let item of this.fieldLayoutFields)
                data["fieldLayoutFields"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldLayoutDefaults)) {
            data["fieldLayoutDefaults"] = [];
            for (let item of this.fieldLayoutDefaults)
                data["fieldLayoutDefaults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldLayout {
    fieldLayoutId?: string;
    caseId?: string;
    displayTitle?: string | undefined;
    modifiedByUserId?: string;
    modifiedDateTime?: Date;
    isPinned?: boolean;
    isShared?: boolean;
    case?: Case;
    fieldLayoutUsers?: FieldLayoutUser[] | undefined;
    fieldLayoutFields?: FieldLayoutField[] | undefined;
    fieldLayoutDefaults?: FieldLayoutDefault[] | undefined;
}

export class FieldLayoutDefault implements IFieldLayoutDefault {
    fieldLayoutDefaultId?: string;
    fieldLayoutId?: string;
    accountRoleId?: string;
    defaultType?: number;
    fieldLayout?: FieldLayout;

    constructor(data?: IFieldLayoutDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutDefaultId = _data["fieldLayoutDefaultId"];
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.accountRoleId = _data["accountRoleId"];
            this.defaultType = _data["defaultType"];
            this.fieldLayout = _data["fieldLayout"] ? FieldLayout.fromJS(_data["fieldLayout"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldLayoutDefault {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLayoutDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutDefaultId"] = this.fieldLayoutDefaultId;
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["accountRoleId"] = this.accountRoleId;
        data["defaultType"] = this.defaultType;
        data["fieldLayout"] = this.fieldLayout ? this.fieldLayout.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldLayoutDefault {
    fieldLayoutDefaultId?: string;
    fieldLayoutId?: string;
    accountRoleId?: string;
    defaultType?: number;
    fieldLayout?: FieldLayout;
}

export class FieldLayoutDefaultViewModel implements IFieldLayoutDefaultViewModel {
    fieldLayoutDefaultId?: string;
    fieldLayoutId?: string;
    accountRoleId?: string;
    defaultType?: number;

    constructor(data?: IFieldLayoutDefaultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutDefaultId = _data["fieldLayoutDefaultId"];
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.accountRoleId = _data["accountRoleId"];
            this.defaultType = _data["defaultType"];
        }
    }

    static fromJS(data: any): FieldLayoutDefaultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLayoutDefaultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutDefaultId"] = this.fieldLayoutDefaultId;
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["accountRoleId"] = this.accountRoleId;
        data["defaultType"] = this.defaultType;
        return data;
    }
}

export interface IFieldLayoutDefaultViewModel {
    fieldLayoutDefaultId?: string;
    fieldLayoutId?: string;
    accountRoleId?: string;
    defaultType?: number;
}

export class FieldLayoutField implements IFieldLayoutField {
    fieldLayoutId?: string;
    fieldId?: string;
    rank?: number;
    width?: number;
    fieldLayout?: FieldLayout;

    constructor(data?: IFieldLayoutField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.fieldId = _data["fieldId"];
            this.rank = _data["rank"];
            this.width = _data["width"];
            this.fieldLayout = _data["fieldLayout"] ? FieldLayout.fromJS(_data["fieldLayout"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldLayoutField {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLayoutField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["fieldId"] = this.fieldId;
        data["rank"] = this.rank;
        data["width"] = this.width;
        data["fieldLayout"] = this.fieldLayout ? this.fieldLayout.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldLayoutField {
    fieldLayoutId?: string;
    fieldId?: string;
    rank?: number;
    width?: number;
    fieldLayout?: FieldLayout;
}

export class FieldLayoutUser implements IFieldLayoutUser {
    fieldLayoutId?: string;
    userId?: string;
    fieldLayout?: FieldLayout;

    constructor(data?: IFieldLayoutUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.userId = _data["userId"];
            this.fieldLayout = _data["fieldLayout"] ? FieldLayout.fromJS(_data["fieldLayout"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldLayoutUser {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLayoutUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["userId"] = this.userId;
        data["fieldLayout"] = this.fieldLayout ? this.fieldLayout.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldLayoutUser {
    fieldLayoutId?: string;
    userId?: string;
    fieldLayout?: FieldLayout;
}

export class FieldLayoutViewModel implements IFieldLayoutViewModel {
    fieldLayoutId?: string;
    displayTitle?: string | undefined;
    modifiedByUserId?: string;
    modifiedDateTime?: Date;
    isPinned?: boolean;
    isShared?: boolean;
    fields?: FieldViewModel[] | undefined;

    constructor(data?: IFieldLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.displayTitle = _data["displayTitle"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedDateTime = _data["modifiedDateTime"] ? new Date(_data["modifiedDateTime"].toString()) : <any>undefined;
            this.isPinned = _data["isPinned"];
            this.isShared = _data["isShared"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FieldViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["displayTitle"] = this.displayTitle;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedDateTime"] = this.modifiedDateTime ? this.modifiedDateTime.toISOString() : <any>undefined;
        data["isPinned"] = this.isPinned;
        data["isShared"] = this.isShared;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldLayoutViewModel {
    fieldLayoutId?: string;
    displayTitle?: string | undefined;
    modifiedByUserId?: string;
    modifiedDateTime?: Date;
    isPinned?: boolean;
    isShared?: boolean;
    fields?: FieldViewModel[] | undefined;
}

export enum FieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    __7 = -7,
    __6 = -6,
    __5 = -5,
    __4 = -4,
    __3 = -3,
    __2 = -2,
    __1 = -1,
}

export class FieldViewModel implements IFieldViewModel {
    fieldLayoutId?: string;
    fieldId?: string;
    parentFieldId?: string | undefined;
    rank?: number;
    fieldType?: FieldType;
    displayTitle?: string | undefined;
    databaseTitle?: string | undefined;
    path?: string | undefined;
    width?: number;
    displayType?: DisplayType;
    isPartOfLoadFile?: boolean;
    isLoadFileDefault?: boolean;

    constructor(data?: IFieldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.fieldId = _data["fieldId"];
            this.parentFieldId = _data["parentFieldId"];
            this.rank = _data["rank"];
            this.fieldType = _data["fieldType"];
            this.displayTitle = _data["displayTitle"];
            this.databaseTitle = _data["databaseTitle"];
            this.path = _data["path"];
            this.width = _data["width"];
            this.displayType = _data["displayType"];
            this.isPartOfLoadFile = _data["isPartOfLoadFile"];
            this.isLoadFileDefault = _data["isLoadFileDefault"];
        }
    }

    static fromJS(data: any): FieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["fieldId"] = this.fieldId;
        data["parentFieldId"] = this.parentFieldId;
        data["rank"] = this.rank;
        data["fieldType"] = this.fieldType;
        data["displayTitle"] = this.displayTitle;
        data["databaseTitle"] = this.databaseTitle;
        data["path"] = this.path;
        data["width"] = this.width;
        data["displayType"] = this.displayType;
        data["isPartOfLoadFile"] = this.isPartOfLoadFile;
        data["isLoadFileDefault"] = this.isLoadFileDefault;
        return data;
    }
}

export interface IFieldViewModel {
    fieldLayoutId?: string;
    fieldId?: string;
    parentFieldId?: string | undefined;
    rank?: number;
    fieldType?: FieldType;
    displayTitle?: string | undefined;
    databaseTitle?: string | undefined;
    path?: string | undefined;
    width?: number;
    displayType?: DisplayType;
    isPartOfLoadFile?: boolean;
    isLoadFileDefault?: boolean;
}

export class FileDownloadRequest implements IFileDownloadRequest {
    docId?: string;
    fileId?: string;
    fileType?: number;

    constructor(data?: IFileDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.fileId = _data["fileId"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): FileDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["fileId"] = this.fileId;
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface IFileDownloadRequest {
    docId?: string;
    fileId?: string;
    fileType?: number;
}

export class FileLexbe implements IFileLexbe {
    fileId?: string;
    docId?: string | undefined;
    caseId?: string;
    type?: number;
    rank?: number;
    extension?: string | undefined;
    fileSize?: number;
    mD5?: string | undefined;
    lifecycle?: number;
    readonly awsKey?: string | undefined;
    doc?: Doc;

    constructor(data?: IFileLexbe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.type = _data["type"];
            this.rank = _data["rank"];
            this.extension = _data["extension"];
            this.fileSize = _data["fileSize"];
            this.mD5 = _data["mD5"];
            this.lifecycle = _data["lifecycle"];
            (<any>this).awsKey = _data["awsKey"];
            this.doc = _data["doc"] ? Doc.fromJS(_data["doc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileLexbe {
        data = typeof data === 'object' ? data : {};
        let result = new FileLexbe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["type"] = this.type;
        data["rank"] = this.rank;
        data["extension"] = this.extension;
        data["fileSize"] = this.fileSize;
        data["mD5"] = this.mD5;
        data["lifecycle"] = this.lifecycle;
        data["awsKey"] = this.awsKey;
        data["doc"] = this.doc ? this.doc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileLexbe {
    fileId?: string;
    docId?: string | undefined;
    caseId?: string;
    type?: number;
    rank?: number;
    extension?: string | undefined;
    fileSize?: number;
    mD5?: string | undefined;
    lifecycle?: number;
    awsKey?: string | undefined;
    doc?: Doc;
}

export class FileUploadRequest implements IFileUploadRequest {
    fileName?: string | undefined;
    fileSize?: number;
    contentType?: string | undefined;
    filePath?: string | undefined;

    constructor(data?: IFileUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.contentType = _data["contentType"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): FileUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["contentType"] = this.contentType;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IFileUploadRequest {
    fileName?: string | undefined;
    fileSize?: number;
    contentType?: string | undefined;
    filePath?: string | undefined;
}

export class FileUploadRequestPackage implements IFileUploadRequestPackage {
    requests?: FileUploadRequest[] | undefined;
    currentCaseId?: string;
    uploadBatchId?: string;
    uploadBatch?: UploadBatch;

    constructor(data?: IFileUploadRequestPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(FileUploadRequest.fromJS(item));
            }
            this.currentCaseId = _data["currentCaseId"];
            this.uploadBatchId = _data["uploadBatchId"];
            this.uploadBatch = _data["uploadBatch"] ? UploadBatch.fromJS(_data["uploadBatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileUploadRequestPackage {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadRequestPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        data["currentCaseId"] = this.currentCaseId;
        data["uploadBatchId"] = this.uploadBatchId;
        data["uploadBatch"] = this.uploadBatch ? this.uploadBatch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileUploadRequestPackage {
    requests?: FileUploadRequest[] | undefined;
    currentCaseId?: string;
    uploadBatchId?: string;
    uploadBatch?: UploadBatch;
}

export class Filter implements IFilter {
    savedFilterId?: string;
    caseId?: string;
    createdById?: string;
    title?: string | undefined;
    dateTimeCreated?: Date;
    isPinned?: boolean;
    isShared?: boolean;
    lifeCycle?: number;
    filterXml?: string | undefined;
    filterJson?: string | undefined;
    filterJsonOld?: string | undefined;
    filterText?: string | undefined;
    error?: boolean;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.savedFilterId = _data["savedFilterId"];
            this.caseId = _data["caseId"];
            this.createdById = _data["createdById"];
            this.title = _data["title"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.isPinned = _data["isPinned"];
            this.isShared = _data["isShared"];
            this.lifeCycle = _data["lifeCycle"];
            this.filterXml = _data["filterXml"];
            this.filterJson = _data["filterJson"];
            this.filterJsonOld = _data["filterJsonOld"];
            this.filterText = _data["filterText"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["savedFilterId"] = this.savedFilterId;
        data["caseId"] = this.caseId;
        data["createdById"] = this.createdById;
        data["title"] = this.title;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["isPinned"] = this.isPinned;
        data["isShared"] = this.isShared;
        data["lifeCycle"] = this.lifeCycle;
        data["filterXml"] = this.filterXml;
        data["filterJson"] = this.filterJson;
        data["filterJsonOld"] = this.filterJsonOld;
        data["filterText"] = this.filterText;
        data["error"] = this.error;
        return data;
    }
}

export interface IFilter {
    savedFilterId?: string;
    caseId?: string;
    createdById?: string;
    title?: string | undefined;
    dateTimeCreated?: Date;
    isPinned?: boolean;
    isShared?: boolean;
    lifeCycle?: number;
    filterXml?: string | undefined;
    filterJson?: string | undefined;
    filterJsonOld?: string | undefined;
    filterText?: string | undefined;
    error?: boolean;
}

export enum FilterDisplayType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export class FilterField implements IFilterField {
    fieldId?: string;
    displayName?: string | undefined;
    displayType?: FilterDisplayType;
    transportName?: string | undefined;
    comparers?: FilterFieldComparer[] | undefined;

    constructor(data?: IFilterField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.displayName = _data["displayName"];
            this.displayType = _data["displayType"];
            this.transportName = _data["transportName"];
            if (Array.isArray(_data["comparers"])) {
                this.comparers = [] as any;
                for (let item of _data["comparers"])
                    this.comparers!.push(FilterFieldComparer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterField {
        data = typeof data === 'object' ? data : {};
        let result = new FilterField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["displayName"] = this.displayName;
        data["displayType"] = this.displayType;
        data["transportName"] = this.transportName;
        if (Array.isArray(this.comparers)) {
            data["comparers"] = [];
            for (let item of this.comparers)
                data["comparers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterField {
    fieldId?: string;
    displayName?: string | undefined;
    displayType?: FilterDisplayType;
    transportName?: string | undefined;
    comparers?: FilterFieldComparer[] | undefined;
}

export class FilterFieldComparer implements IFilterFieldComparer {
    value?: string;
    displayName?: string | undefined;

    constructor(data?: IFilterFieldComparer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FilterFieldComparer {
        data = typeof data === 'object' ? data : {};
        let result = new FilterFieldComparer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFilterFieldComparer {
    value?: string;
    displayName?: string | undefined;
}

export class FilterFieldGroup implements IFilterFieldGroup {
    groupName?: string | undefined;
    fields?: FilterField[] | undefined;

    constructor(data?: IFilterFieldGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FilterField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterFieldGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FilterFieldGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterFieldGroup {
    groupName?: string | undefined;
    fields?: FilterField[] | undefined;
}

export class Folder implements IFolder {
    folderId?: string;
    caseId?: string;
    parentFolderId?: string;
    folderName?: string | undefined;
    left?: number;
    right?: number;
    isDefaultType?: boolean;
    isCaseRootNode?: boolean;

    constructor(data?: IFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderId = _data["folderId"];
            this.caseId = _data["caseId"];
            this.parentFolderId = _data["parentFolderId"];
            this.folderName = _data["folderName"];
            this.left = _data["left"];
            this.right = _data["right"];
            this.isDefaultType = _data["isDefaultType"];
            this.isCaseRootNode = _data["isCaseRootNode"];
        }
    }

    static fromJS(data: any): Folder {
        data = typeof data === 'object' ? data : {};
        let result = new Folder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderId"] = this.folderId;
        data["caseId"] = this.caseId;
        data["parentFolderId"] = this.parentFolderId;
        data["folderName"] = this.folderName;
        data["left"] = this.left;
        data["right"] = this.right;
        data["isDefaultType"] = this.isDefaultType;
        data["isCaseRootNode"] = this.isCaseRootNode;
        return data;
    }
}

export interface IFolder {
    folderId?: string;
    caseId?: string;
    parentFolderId?: string;
    folderName?: string | undefined;
    left?: number;
    right?: number;
    isDefaultType?: boolean;
    isCaseRootNode?: boolean;
}

export class FolderImportRequest implements IFolderImportRequest {
    fromCaseId?: string;

    constructor(data?: IFolderImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromCaseId = _data["fromCaseId"];
        }
    }

    static fromJS(data: any): FolderImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FolderImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromCaseId"] = this.fromCaseId;
        return data;
    }
}

export interface IFolderImportRequest {
    fromCaseId?: string;
}

export class FolderState implements IFolderState {
    caseId?: string;
    folderId?: string;
    parentFolderId?: string;
    folderName?: string | undefined;
    left?: number;
    right?: number;
    isDefaultType?: boolean;
    isCaseRootNode?: boolean;

    constructor(data?: IFolderState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.folderId = _data["folderId"];
            this.parentFolderId = _data["parentFolderId"];
            this.folderName = _data["folderName"];
            this.left = _data["left"];
            this.right = _data["right"];
            this.isDefaultType = _data["isDefaultType"];
            this.isCaseRootNode = _data["isCaseRootNode"];
        }
    }

    static fromJS(data: any): FolderState {
        data = typeof data === 'object' ? data : {};
        let result = new FolderState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["folderId"] = this.folderId;
        data["parentFolderId"] = this.parentFolderId;
        data["folderName"] = this.folderName;
        data["left"] = this.left;
        data["right"] = this.right;
        data["isDefaultType"] = this.isDefaultType;
        data["isCaseRootNode"] = this.isCaseRootNode;
        return data;
    }
}

export interface IFolderState {
    caseId?: string;
    folderId?: string;
    parentFolderId?: string;
    folderName?: string | undefined;
    left?: number;
    right?: number;
    isDefaultType?: boolean;
    isCaseRootNode?: boolean;
}

export class GenerateMfaRequest implements IGenerateMfaRequest {
    provider?: string | undefined;

    constructor(data?: IGenerateMfaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): GenerateMfaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateMfaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        return data;
    }
}

export interface IGenerateMfaRequest {
    provider?: string | undefined;
}

export enum GenericParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _28 = 28,
}

export class HighlightColor implements IHighlightColor {
    highlightColorId?: string;
    colorValue?: string | undefined;

    constructor(data?: IHighlightColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.highlightColorId = _data["highlightColorId"];
            this.colorValue = _data["colorValue"];
        }
    }

    static fromJS(data: any): HighlightColor {
        data = typeof data === 'object' ? data : {};
        let result = new HighlightColor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["highlightColorId"] = this.highlightColorId;
        data["colorValue"] = this.colorValue;
        return data;
    }
}

export interface IHighlightColor {
    highlightColorId?: string;
    colorValue?: string | undefined;
}

export class IComponent implements IIComponent {
    site?: ISite;

    constructor(data?: IIComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] ? ISite.fromJS(_data["site"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IComponent {
        data = typeof data === 'object' ? data : {};
        let result = new IComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIComponent {
    site?: ISite;
}

export class IContainer implements IIContainer {
    readonly components?: any[] | undefined;

    constructor(data?: IIContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["components"])) {
                (<any>this).components = [] as any;
                for (let item of _data["components"])
                    (<any>this).components!.push(item);
            }
        }
    }

    static fromJS(data: any): IContainer {
        data = typeof data === 'object' ? data : {};
        let result = new IContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item);
        }
        return data;
    }
}

export interface IIContainer {
    components?: any[] | undefined;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class ISite implements IISite {
    component?: IComponent;
    container?: IContainer;
    readonly designMode?: boolean;
    name?: string | undefined;

    constructor(data?: IISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.component = _data["component"] ? IComponent.fromJS(_data["component"]) : <any>undefined;
            this.container = _data["container"] ? IContainer.fromJS(_data["container"]) : <any>undefined;
            (<any>this).designMode = _data["designMode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ISite {
        data = typeof data === 'object' ? data : {};
        let result = new ISite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["component"] = this.component ? this.component.toJSON() : <any>undefined;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["designMode"] = this.designMode;
        data["name"] = this.name;
        return data;
    }
}

export interface IISite {
    component?: IComponent;
    container?: IContainer;
    designMode?: boolean;
    name?: string | undefined;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {
}

export class Issue implements IIssue {
    issueId?: string;
    caseId?: string;
    issueTitle?: string | undefined;
    description?: string | undefined;
    case?: Case;
    facts?: Fact[] | undefined;

    constructor(data?: IIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.caseId = _data["caseId"];
            this.issueTitle = _data["issueTitle"];
            this.description = _data["description"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(Fact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Issue {
        data = typeof data === 'object' ? data : {};
        let result = new Issue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["caseId"] = this.caseId;
        data["issueTitle"] = this.issueTitle;
        data["description"] = this.description;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIssue {
    issueId?: string;
    caseId?: string;
    issueTitle?: string | undefined;
    description?: string | undefined;
    case?: Case;
    facts?: Fact[] | undefined;
}

export class IssueState implements IIssueState {
    issueId?: string;
    caseId?: string;
    issueTitle?: string | undefined;
    description?: string | undefined;
    facts?: FactState[] | undefined;

    constructor(data?: IIssueState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.caseId = _data["caseId"];
            this.issueTitle = _data["issueTitle"];
            this.description = _data["description"];
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(FactState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssueState {
        data = typeof data === 'object' ? data : {};
        let result = new IssueState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["caseId"] = this.caseId;
        data["issueTitle"] = this.issueTitle;
        data["description"] = this.description;
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIssueState {
    issueId?: string;
    caseId?: string;
    issueTitle?: string | undefined;
    description?: string | undefined;
    facts?: FactState[] | undefined;
}

export class IssueViewModel implements IIssueViewModel {
    issueId?: string;
    issueTitle?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIssueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.issueTitle = _data["issueTitle"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IssueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["issueTitle"] = this.issueTitle;
        data["description"] = this.description;
        return data;
    }
}

export interface IIssueViewModel {
    issueId?: string;
    issueTitle?: string | undefined;
    description?: string | undefined;
}

export class KeyboardShortcut implements IKeyboardShortcut {
    shortcutKey?: Shortcut;
    shortcutAction?: string | undefined;

    constructor(data?: IKeyboardShortcut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortcutKey = _data["shortcutKey"] ? Shortcut.fromJS(_data["shortcutKey"]) : <any>undefined;
            this.shortcutAction = _data["shortcutAction"];
        }
    }

    static fromJS(data: any): KeyboardShortcut {
        data = typeof data === 'object' ? data : {};
        let result = new KeyboardShortcut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortcutKey"] = this.shortcutKey ? this.shortcutKey.toJSON() : <any>undefined;
        data["shortcutAction"] = this.shortcutAction;
        return data;
    }
}

export interface IKeyboardShortcut {
    shortcutKey?: Shortcut;
    shortcutAction?: string | undefined;
}

export enum LayoutKind {
    _0 = 0,
    _2 = 2,
    _3 = 3,
}

export class LexbeAccount implements ILexbeAccount {
    accountId?: string;
    accountName?: string | undefined;
    accountComments?: string | undefined;
    accountLogoFilename?: string | undefined;
    message?: string | undefined;
    crmUrl?: string | undefined;
    type?: string | undefined;
    lifeCycle?: LifeCycle;
    docSize?: number;
    indexSizeNotCapped?: number;
    readonly indexSizeCapped?: number;
    productionJobSize?: number;
    archiveJobSize?: number;
    downloadSize?: number;
    isHibernated?: boolean;
    customCaseFields?: CustomCaseField[] | undefined;

    constructor(data?: ILexbeAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.accountComments = _data["accountComments"];
            this.accountLogoFilename = _data["accountLogoFilename"];
            this.message = _data["message"];
            this.crmUrl = _data["crmUrl"];
            this.type = _data["type"];
            this.lifeCycle = _data["lifeCycle"];
            this.docSize = _data["docSize"];
            this.indexSizeNotCapped = _data["indexSizeNotCapped"];
            (<any>this).indexSizeCapped = _data["indexSizeCapped"];
            this.productionJobSize = _data["productionJobSize"];
            this.archiveJobSize = _data["archiveJobSize"];
            this.downloadSize = _data["downloadSize"];
            this.isHibernated = _data["isHibernated"];
            if (Array.isArray(_data["customCaseFields"])) {
                this.customCaseFields = [] as any;
                for (let item of _data["customCaseFields"])
                    this.customCaseFields!.push(CustomCaseField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LexbeAccount {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["accountComments"] = this.accountComments;
        data["accountLogoFilename"] = this.accountLogoFilename;
        data["message"] = this.message;
        data["crmUrl"] = this.crmUrl;
        data["type"] = this.type;
        data["lifeCycle"] = this.lifeCycle;
        data["docSize"] = this.docSize;
        data["indexSizeNotCapped"] = this.indexSizeNotCapped;
        data["indexSizeCapped"] = this.indexSizeCapped;
        data["productionJobSize"] = this.productionJobSize;
        data["archiveJobSize"] = this.archiveJobSize;
        data["downloadSize"] = this.downloadSize;
        data["isHibernated"] = this.isHibernated;
        if (Array.isArray(this.customCaseFields)) {
            data["customCaseFields"] = [];
            for (let item of this.customCaseFields)
                data["customCaseFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILexbeAccount {
    accountId?: string;
    accountName?: string | undefined;
    accountComments?: string | undefined;
    accountLogoFilename?: string | undefined;
    message?: string | undefined;
    crmUrl?: string | undefined;
    type?: string | undefined;
    lifeCycle?: LifeCycle;
    docSize?: number;
    indexSizeNotCapped?: number;
    indexSizeCapped?: number;
    productionJobSize?: number;
    archiveJobSize?: number;
    downloadSize?: number;
    isHibernated?: boolean;
    customCaseFields?: CustomCaseField[] | undefined;
}

export class LexbeBriefcaseJob implements ILexbeBriefcaseJob {
    briefcaseJobId?: string;
    caseId?: string;
    createdById?: string;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    customDesignation?: string | undefined;
    isControlNumberStampPages?: boolean;
    isBatesStampPages?: boolean;
    isDocIdStampPages?: boolean;
    titleType?: number;
    briefcaseSize?: number;
    lifecycle?: number;
    status?: number;
    controlNumberBasePrefix?: string | undefined;
    briefcaseJobDocIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    isExhibitStampPages?: boolean;
    sendNotification?: boolean;
    searchParameter?: SearchParameter;
    expandToEmailFamily?: boolean;
    includeMergedPdfs?: boolean;
    allowSharing?: boolean;

    constructor(data?: ILexbeBriefcaseJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.briefcaseJobId = _data["briefcaseJobId"];
            this.caseId = _data["caseId"];
            this.createdById = _data["createdById"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.customDesignation = _data["customDesignation"];
            this.isControlNumberStampPages = _data["isControlNumberStampPages"];
            this.isBatesStampPages = _data["isBatesStampPages"];
            this.isDocIdStampPages = _data["isDocIdStampPages"];
            this.titleType = _data["titleType"];
            this.briefcaseSize = _data["briefcaseSize"];
            this.lifecycle = _data["lifecycle"];
            this.status = _data["status"];
            this.controlNumberBasePrefix = _data["controlNumberBasePrefix"];
            if (Array.isArray(_data["briefcaseJobDocIds"])) {
                this.briefcaseJobDocIds = [] as any;
                for (let item of _data["briefcaseJobDocIds"])
                    this.briefcaseJobDocIds!.push(item);
            }
            this.filterId = _data["filterId"];
            this.selectAll = _data["selectAll"];
            this.isExhibitStampPages = _data["isExhibitStampPages"];
            this.sendNotification = _data["sendNotification"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
            this.expandToEmailFamily = _data["expandToEmailFamily"];
            this.includeMergedPdfs = _data["includeMergedPdfs"];
            this.allowSharing = _data["allowSharing"];
        }
    }

    static fromJS(data: any): LexbeBriefcaseJob {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeBriefcaseJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["briefcaseJobId"] = this.briefcaseJobId;
        data["caseId"] = this.caseId;
        data["createdById"] = this.createdById;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["customDesignation"] = this.customDesignation;
        data["isControlNumberStampPages"] = this.isControlNumberStampPages;
        data["isBatesStampPages"] = this.isBatesStampPages;
        data["isDocIdStampPages"] = this.isDocIdStampPages;
        data["titleType"] = this.titleType;
        data["briefcaseSize"] = this.briefcaseSize;
        data["lifecycle"] = this.lifecycle;
        data["status"] = this.status;
        data["controlNumberBasePrefix"] = this.controlNumberBasePrefix;
        if (Array.isArray(this.briefcaseJobDocIds)) {
            data["briefcaseJobDocIds"] = [];
            for (let item of this.briefcaseJobDocIds)
                data["briefcaseJobDocIds"].push(item);
        }
        data["filterId"] = this.filterId;
        data["selectAll"] = this.selectAll;
        data["isExhibitStampPages"] = this.isExhibitStampPages;
        data["sendNotification"] = this.sendNotification;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        data["expandToEmailFamily"] = this.expandToEmailFamily;
        data["includeMergedPdfs"] = this.includeMergedPdfs;
        data["allowSharing"] = this.allowSharing;
        return data;
    }
}

export interface ILexbeBriefcaseJob {
    briefcaseJobId?: string;
    caseId?: string;
    createdById?: string;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    customDesignation?: string | undefined;
    isControlNumberStampPages?: boolean;
    isBatesStampPages?: boolean;
    isDocIdStampPages?: boolean;
    titleType?: number;
    briefcaseSize?: number;
    lifecycle?: number;
    status?: number;
    controlNumberBasePrefix?: string | undefined;
    briefcaseJobDocIds?: string[] | undefined;
    filterId?: string | undefined;
    selectAll?: boolean;
    isExhibitStampPages?: boolean;
    sendNotification?: boolean;
    searchParameter?: SearchParameter;
    expandToEmailFamily?: boolean;
    includeMergedPdfs?: boolean;
    allowSharing?: boolean;
}

export class LexbeCase implements ILexbeCase {
    caseId?: string;
    accountId?: string;
    account?: LexbeAccount;
    simpleCaseId?: string | undefined;
    caseName?: string | undefined;
    createdById?: string;
    dateTimeCreated?: Date;
    caseNumber?: string | undefined;
    caseType?: string | undefined;
    caseVenue?: string | undefined;
    leadAttorney?: string | undefined;
    trierOfFact?: string | undefined;
    caseComments?: string | undefined;
    customDesignation?: string | undefined;
    caseKeywords?: string | undefined;
    lastCaseKeywordsUpdateDate?: Date;
    lifecycle?: LifeCycle;
    productionJobSize?: number;
    archiveJobSize?: number;
    downloadSize?: number;
    docSize?: number;
    caseDocCount?: number;
    indexSizeNotCapped?: number;
    indexSizeCapped?: number;
    currentCaseSizeBytes?: number;
    useGigabytes?: boolean;
    indexDocCount?: number;
    kbDocCount?: number;
    indexLastModifiedTimestamp?: Date | undefined;
    indexCompressionTimestamp?: Date | undefined;
    customFields?: CustomCaseFieldValue[] | undefined;
    caseContacts?: CaseContact[] | undefined;
    emailThreadSummary?: EmailThreadSummary;
    emailThreadGroupings?: EmailThreadGrouping[] | undefined;

    constructor(data?: ILexbeCase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? LexbeAccount.fromJS(_data["account"]) : <any>undefined;
            this.simpleCaseId = _data["simpleCaseId"];
            this.caseName = _data["caseName"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.caseNumber = _data["caseNumber"];
            this.caseType = _data["caseType"];
            this.caseVenue = _data["caseVenue"];
            this.leadAttorney = _data["leadAttorney"];
            this.trierOfFact = _data["trierOfFact"];
            this.caseComments = _data["caseComments"];
            this.customDesignation = _data["customDesignation"];
            this.caseKeywords = _data["caseKeywords"];
            this.lastCaseKeywordsUpdateDate = _data["lastCaseKeywordsUpdateDate"] ? new Date(_data["lastCaseKeywordsUpdateDate"].toString()) : <any>undefined;
            this.lifecycle = _data["lifecycle"];
            this.productionJobSize = _data["productionJobSize"];
            this.archiveJobSize = _data["archiveJobSize"];
            this.downloadSize = _data["downloadSize"];
            this.docSize = _data["docSize"];
            this.caseDocCount = _data["caseDocCount"];
            this.indexSizeNotCapped = _data["indexSizeNotCapped"];
            this.indexSizeCapped = _data["indexSizeCapped"];
            this.currentCaseSizeBytes = _data["currentCaseSizeBytes"];
            this.useGigabytes = _data["useGigabytes"];
            this.indexDocCount = _data["indexDocCount"];
            this.kbDocCount = _data["kbDocCount"];
            this.indexLastModifiedTimestamp = _data["indexLastModifiedTimestamp"] ? new Date(_data["indexLastModifiedTimestamp"].toString()) : <any>undefined;
            this.indexCompressionTimestamp = _data["indexCompressionTimestamp"] ? new Date(_data["indexCompressionTimestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomCaseFieldValue.fromJS(item));
            }
            if (Array.isArray(_data["caseContacts"])) {
                this.caseContacts = [] as any;
                for (let item of _data["caseContacts"])
                    this.caseContacts!.push(CaseContact.fromJS(item));
            }
            this.emailThreadSummary = _data["emailThreadSummary"] ? EmailThreadSummary.fromJS(_data["emailThreadSummary"]) : <any>undefined;
            if (Array.isArray(_data["emailThreadGroupings"])) {
                this.emailThreadGroupings = [] as any;
                for (let item of _data["emailThreadGroupings"])
                    this.emailThreadGroupings!.push(EmailThreadGrouping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LexbeCase {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeCase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["simpleCaseId"] = this.simpleCaseId;
        data["caseName"] = this.caseName;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["caseNumber"] = this.caseNumber;
        data["caseType"] = this.caseType;
        data["caseVenue"] = this.caseVenue;
        data["leadAttorney"] = this.leadAttorney;
        data["trierOfFact"] = this.trierOfFact;
        data["caseComments"] = this.caseComments;
        data["customDesignation"] = this.customDesignation;
        data["caseKeywords"] = this.caseKeywords;
        data["lastCaseKeywordsUpdateDate"] = this.lastCaseKeywordsUpdateDate ? this.lastCaseKeywordsUpdateDate.toISOString() : <any>undefined;
        data["lifecycle"] = this.lifecycle;
        data["productionJobSize"] = this.productionJobSize;
        data["archiveJobSize"] = this.archiveJobSize;
        data["downloadSize"] = this.downloadSize;
        data["docSize"] = this.docSize;
        data["caseDocCount"] = this.caseDocCount;
        data["indexSizeNotCapped"] = this.indexSizeNotCapped;
        data["indexSizeCapped"] = this.indexSizeCapped;
        data["currentCaseSizeBytes"] = this.currentCaseSizeBytes;
        data["useGigabytes"] = this.useGigabytes;
        data["indexDocCount"] = this.indexDocCount;
        data["kbDocCount"] = this.kbDocCount;
        data["indexLastModifiedTimestamp"] = this.indexLastModifiedTimestamp ? this.indexLastModifiedTimestamp.toISOString() : <any>undefined;
        data["indexCompressionTimestamp"] = this.indexCompressionTimestamp ? this.indexCompressionTimestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        if (Array.isArray(this.caseContacts)) {
            data["caseContacts"] = [];
            for (let item of this.caseContacts)
                data["caseContacts"].push(item.toJSON());
        }
        data["emailThreadSummary"] = this.emailThreadSummary ? this.emailThreadSummary.toJSON() : <any>undefined;
        if (Array.isArray(this.emailThreadGroupings)) {
            data["emailThreadGroupings"] = [];
            for (let item of this.emailThreadGroupings)
                data["emailThreadGroupings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILexbeCase {
    caseId?: string;
    accountId?: string;
    account?: LexbeAccount;
    simpleCaseId?: string | undefined;
    caseName?: string | undefined;
    createdById?: string;
    dateTimeCreated?: Date;
    caseNumber?: string | undefined;
    caseType?: string | undefined;
    caseVenue?: string | undefined;
    leadAttorney?: string | undefined;
    trierOfFact?: string | undefined;
    caseComments?: string | undefined;
    customDesignation?: string | undefined;
    caseKeywords?: string | undefined;
    lastCaseKeywordsUpdateDate?: Date;
    lifecycle?: LifeCycle;
    productionJobSize?: number;
    archiveJobSize?: number;
    downloadSize?: number;
    docSize?: number;
    caseDocCount?: number;
    indexSizeNotCapped?: number;
    indexSizeCapped?: number;
    currentCaseSizeBytes?: number;
    useGigabytes?: boolean;
    indexDocCount?: number;
    kbDocCount?: number;
    indexLastModifiedTimestamp?: Date | undefined;
    indexCompressionTimestamp?: Date | undefined;
    customFields?: CustomCaseFieldValue[] | undefined;
    caseContacts?: CaseContact[] | undefined;
    emailThreadSummary?: EmailThreadSummary;
    emailThreadGroupings?: EmailThreadGrouping[] | undefined;
}

export class LexbeCaseBrief implements ILexbeCaseBrief {
    caseId?: string;
    accountId?: string;
    caseName?: string | undefined;
    docCount?: number;
    accessDateTime?: Date | undefined;

    constructor(data?: ILexbeCaseBrief) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.accountId = _data["accountId"];
            this.caseName = _data["caseName"];
            this.docCount = _data["docCount"];
            this.accessDateTime = _data["accessDateTime"] ? new Date(_data["accessDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LexbeCaseBrief {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeCaseBrief();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["accountId"] = this.accountId;
        data["caseName"] = this.caseName;
        data["docCount"] = this.docCount;
        data["accessDateTime"] = this.accessDateTime ? this.accessDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILexbeCaseBrief {
    caseId?: string;
    accountId?: string;
    caseName?: string | undefined;
    docCount?: number;
    accessDateTime?: Date | undefined;
}

export class LexbeCoding implements ILexbeCoding {
    fieldId?: string;
    docId?: string;

    constructor(data?: ILexbeCoding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.docId = _data["docId"];
        }
    }

    static fromJS(data: any): LexbeCoding {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeCoding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["docId"] = this.docId;
        return data;
    }
}

export interface ILexbeCoding {
    fieldId?: string;
    docId?: string;
}

export class LexbeDoc implements ILexbeDoc {
    docId?: string;
    parentDocId?: string;
    caseId?: string;
    folderId?: string;
    folderFullPath?: string | undefined;
    uploadBatchId?: string;
    custodianId?: string;
    custodianName?: string | undefined;
    emailFamilyId?: string;
    dedupFamilyId?: string;
    searchDocId?: number;
    textGroupId?: number;
    lifecycle?: number;
    createdById?: string;
    dateTimeUploaded?: Date;
    emailType?: LexbeEmailType;
    common?: LexbeDocCommon;
    email?: LexbeDocEmail;
    native?: LexbeDocNative;
    coding?: LexbeDocCoding;
    review?: LexbeDocReview;
    bates?: LexbeDocBates;
    status?: LexbeDocStatus;
    customCodingFields?: LexbeCoding[] | undefined;
    searchMetadata?: SearchMetadata;
    isExpandedResult?: boolean;
    childLevel?: number;

    constructor(data?: ILexbeDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.parentDocId = _data["parentDocId"];
            this.caseId = _data["caseId"];
            this.folderId = _data["folderId"];
            this.folderFullPath = _data["folderFullPath"];
            this.uploadBatchId = _data["uploadBatchId"];
            this.custodianId = _data["custodianId"];
            this.custodianName = _data["custodianName"];
            this.emailFamilyId = _data["emailFamilyId"];
            this.dedupFamilyId = _data["dedupFamilyId"];
            this.searchDocId = _data["searchDocId"];
            this.textGroupId = _data["textGroupId"];
            this.lifecycle = _data["lifecycle"];
            this.createdById = _data["createdById"];
            this.dateTimeUploaded = _data["dateTimeUploaded"] ? new Date(_data["dateTimeUploaded"].toString()) : <any>undefined;
            this.emailType = _data["emailType"] ? LexbeEmailType.fromJS(_data["emailType"]) : <any>undefined;
            this.common = _data["common"] ? LexbeDocCommon.fromJS(_data["common"]) : <any>undefined;
            this.email = _data["email"] ? LexbeDocEmail.fromJS(_data["email"]) : <any>undefined;
            this.native = _data["native"] ? LexbeDocNative.fromJS(_data["native"]) : <any>undefined;
            this.coding = _data["coding"] ? LexbeDocCoding.fromJS(_data["coding"]) : <any>undefined;
            this.review = _data["review"] ? LexbeDocReview.fromJS(_data["review"]) : <any>undefined;
            this.bates = _data["bates"] ? LexbeDocBates.fromJS(_data["bates"]) : <any>undefined;
            this.status = _data["status"] ? LexbeDocStatus.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["customCodingFields"])) {
                this.customCodingFields = [] as any;
                for (let item of _data["customCodingFields"])
                    this.customCodingFields!.push(LexbeCoding.fromJS(item));
            }
            this.searchMetadata = _data["searchMetadata"] ? SearchMetadata.fromJS(_data["searchMetadata"]) : <any>undefined;
            this.isExpandedResult = _data["isExpandedResult"];
            this.childLevel = _data["childLevel"];
        }
    }

    static fromJS(data: any): LexbeDoc {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["parentDocId"] = this.parentDocId;
        data["caseId"] = this.caseId;
        data["folderId"] = this.folderId;
        data["folderFullPath"] = this.folderFullPath;
        data["uploadBatchId"] = this.uploadBatchId;
        data["custodianId"] = this.custodianId;
        data["custodianName"] = this.custodianName;
        data["emailFamilyId"] = this.emailFamilyId;
        data["dedupFamilyId"] = this.dedupFamilyId;
        data["searchDocId"] = this.searchDocId;
        data["textGroupId"] = this.textGroupId;
        data["lifecycle"] = this.lifecycle;
        data["createdById"] = this.createdById;
        data["dateTimeUploaded"] = this.dateTimeUploaded ? this.dateTimeUploaded.toISOString() : <any>undefined;
        data["emailType"] = this.emailType ? this.emailType.toJSON() : <any>undefined;
        data["common"] = this.common ? this.common.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["native"] = this.native ? this.native.toJSON() : <any>undefined;
        data["coding"] = this.coding ? this.coding.toJSON() : <any>undefined;
        data["review"] = this.review ? this.review.toJSON() : <any>undefined;
        data["bates"] = this.bates ? this.bates.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.customCodingFields)) {
            data["customCodingFields"] = [];
            for (let item of this.customCodingFields)
                data["customCodingFields"].push(item.toJSON());
        }
        data["searchMetadata"] = this.searchMetadata ? this.searchMetadata.toJSON() : <any>undefined;
        data["isExpandedResult"] = this.isExpandedResult;
        data["childLevel"] = this.childLevel;
        return data;
    }
}

export interface ILexbeDoc {
    docId?: string;
    parentDocId?: string;
    caseId?: string;
    folderId?: string;
    folderFullPath?: string | undefined;
    uploadBatchId?: string;
    custodianId?: string;
    custodianName?: string | undefined;
    emailFamilyId?: string;
    dedupFamilyId?: string;
    searchDocId?: number;
    textGroupId?: number;
    lifecycle?: number;
    createdById?: string;
    dateTimeUploaded?: Date;
    emailType?: LexbeEmailType;
    common?: LexbeDocCommon;
    email?: LexbeDocEmail;
    native?: LexbeDocNative;
    coding?: LexbeDocCoding;
    review?: LexbeDocReview;
    bates?: LexbeDocBates;
    status?: LexbeDocStatus;
    customCodingFields?: LexbeCoding[] | undefined;
    searchMetadata?: SearchMetadata;
    isExpandedResult?: boolean;
    childLevel?: number;
}

export class LexbeDocBates implements ILexbeDocBates {
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;

    constructor(data?: ILexbeDocBates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batesPrefix = _data["batesPrefix"];
            this.batesNumberStart = _data["batesNumberStart"];
            this.batesNumberDigits = _data["batesNumberDigits"];
        }
    }

    static fromJS(data: any): LexbeDocBates {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocBates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batesPrefix"] = this.batesPrefix;
        data["batesNumberStart"] = this.batesNumberStart;
        data["batesNumberDigits"] = this.batesNumberDigits;
        return data;
    }
}

export interface ILexbeDocBates {
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
}

export class LexbeDocCoding implements ILexbeDocCoding {
    responsive?: number;
    privilege?: boolean;
    workProduct?: boolean;
    redactForPrivilege?: boolean;
    redactForPi?: boolean;
    readonly isWithheld?: boolean;
    confidential?: boolean;
    customDesignation?: boolean;
    isKey?: boolean;
    description?: string | undefined;
    isPropagated?: boolean;
    hasBeenReviewed?: boolean;
    reviewedBy?: string | undefined;

    constructor(data?: ILexbeDocCoding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsive = _data["responsive"];
            this.privilege = _data["privilege"];
            this.workProduct = _data["workProduct"];
            this.redactForPrivilege = _data["redactForPrivilege"];
            this.redactForPi = _data["redactForPi"];
            (<any>this).isWithheld = _data["isWithheld"];
            this.confidential = _data["confidential"];
            this.customDesignation = _data["customDesignation"];
            this.isKey = _data["isKey"];
            this.description = _data["description"];
            this.isPropagated = _data["isPropagated"];
            this.hasBeenReviewed = _data["hasBeenReviewed"];
            this.reviewedBy = _data["reviewedBy"];
        }
    }

    static fromJS(data: any): LexbeDocCoding {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocCoding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsive"] = this.responsive;
        data["privilege"] = this.privilege;
        data["workProduct"] = this.workProduct;
        data["redactForPrivilege"] = this.redactForPrivilege;
        data["redactForPi"] = this.redactForPi;
        data["isWithheld"] = this.isWithheld;
        data["confidential"] = this.confidential;
        data["customDesignation"] = this.customDesignation;
        data["isKey"] = this.isKey;
        data["description"] = this.description;
        data["isPropagated"] = this.isPropagated;
        data["hasBeenReviewed"] = this.hasBeenReviewed;
        data["reviewedBy"] = this.reviewedBy;
        return data;
    }
}

export interface ILexbeDocCoding {
    responsive?: number;
    privilege?: boolean;
    workProduct?: boolean;
    redactForPrivilege?: boolean;
    redactForPi?: boolean;
    isWithheld?: boolean;
    confidential?: boolean;
    customDesignation?: boolean;
    isKey?: boolean;
    description?: string | undefined;
    isPropagated?: boolean;
    hasBeenReviewed?: boolean;
    reviewedBy?: string | undefined;
}

export class LexbeDocCommon implements ILexbeDocCommon {
    docTitle?: string | undefined;
    docOriginalTitle?: string | undefined;
    docExtension?: string | undefined;
    docOriginalExtension?: string | undefined;
    sourceFilePath?: string | undefined;
    docSource?: string | undefined;
    docType?: string | undefined;
    dedupHash?: string | undefined;
    docCategory?: string | undefined;
    pageCount?: number;
    wordCount?: number;
    docSize?: number;
    masterDate?: Date | undefined;
    controlNumber?: number;

    constructor(data?: ILexbeDocCommon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docTitle = _data["docTitle"];
            this.docOriginalTitle = _data["docOriginalTitle"];
            this.docExtension = _data["docExtension"];
            this.docOriginalExtension = _data["docOriginalExtension"];
            this.sourceFilePath = _data["sourceFilePath"];
            this.docSource = _data["docSource"];
            this.docType = _data["docType"];
            this.dedupHash = _data["dedupHash"];
            this.docCategory = _data["docCategory"];
            this.pageCount = _data["pageCount"];
            this.wordCount = _data["wordCount"];
            this.docSize = _data["docSize"];
            this.masterDate = _data["masterDate"] ? new Date(_data["masterDate"].toString()) : <any>undefined;
            this.controlNumber = _data["controlNumber"];
        }
    }

    static fromJS(data: any): LexbeDocCommon {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocCommon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTitle"] = this.docTitle;
        data["docOriginalTitle"] = this.docOriginalTitle;
        data["docExtension"] = this.docExtension;
        data["docOriginalExtension"] = this.docOriginalExtension;
        data["sourceFilePath"] = this.sourceFilePath;
        data["docSource"] = this.docSource;
        data["docType"] = this.docType;
        data["dedupHash"] = this.dedupHash;
        data["docCategory"] = this.docCategory;
        data["pageCount"] = this.pageCount;
        data["wordCount"] = this.wordCount;
        data["docSize"] = this.docSize;
        data["masterDate"] = this.masterDate ? this.masterDate.toISOString() : <any>undefined;
        data["controlNumber"] = this.controlNumber;
        return data;
    }
}

export interface ILexbeDocCommon {
    docTitle?: string | undefined;
    docOriginalTitle?: string | undefined;
    docExtension?: string | undefined;
    docOriginalExtension?: string | undefined;
    sourceFilePath?: string | undefined;
    docSource?: string | undefined;
    docType?: string | undefined;
    dedupHash?: string | undefined;
    docCategory?: string | undefined;
    pageCount?: number;
    wordCount?: number;
    docSize?: number;
    masterDate?: Date | undefined;
    controlNumber?: number;
}

export class LexbeDocEmail implements ILexbeDocEmail {
    fromField?: string | undefined;
    toField?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subjectMatter?: string | undefined;
    dateSent?: Date | undefined;
    dateReceived?: Date | undefined;

    constructor(data?: ILexbeDocEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromField = _data["fromField"];
            this.toField = _data["toField"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.subjectMatter = _data["subjectMatter"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LexbeDocEmail {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromField"] = this.fromField;
        data["toField"] = this.toField;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["subjectMatter"] = this.subjectMatter;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILexbeDocEmail {
    fromField?: string | undefined;
    toField?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subjectMatter?: string | undefined;
    dateSent?: Date | undefined;
    dateReceived?: Date | undefined;
}

export class LexbeDocNative implements ILexbeDocNative {
    author?: string | undefined;
    lastModifiedBy?: string | undefined;
    docDate?: Date | undefined;
    dateCreated?: Date | undefined;
    dateLastModified?: Date | undefined;

    constructor(data?: ILexbeDocNative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.author = _data["author"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.docDate = _data["docDate"] ? new Date(_data["docDate"].toString()) : <any>undefined;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateLastModified = _data["dateLastModified"] ? new Date(_data["dateLastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LexbeDocNative {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocNative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["author"] = this.author;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateLastModified"] = this.dateLastModified ? this.dateLastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILexbeDocNative {
    author?: string | undefined;
    lastModifiedBy?: string | undefined;
    docDate?: Date | undefined;
    dateCreated?: Date | undefined;
    dateLastModified?: Date | undefined;
}

export class LexbeDocNote implements ILexbeDocNote {
    docNoteId?: string | undefined;
    docNoteTitle?: string | undefined;
    docNote?: string | undefined;
    pageNumber?: number;
    isPrivate?: boolean;
    docId?: string;
    createdById?: string;
    dateTimeCreated?: Date;
    doc?: Doc;
    author?: string | undefined;
    documentName?: string | undefined;
    pageCount?: number;

    constructor(data?: ILexbeDocNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docNoteId = _data["docNoteId"];
            this.docNoteTitle = _data["docNoteTitle"];
            this.docNote = _data["docNote"];
            this.pageNumber = _data["pageNumber"];
            this.isPrivate = _data["isPrivate"];
            this.docId = _data["docId"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.doc = _data["doc"] ? Doc.fromJS(_data["doc"]) : <any>undefined;
            this.author = _data["author"];
            this.documentName = _data["documentName"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): LexbeDocNote {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNoteId"] = this.docNoteId;
        data["docNoteTitle"] = this.docNoteTitle;
        data["docNote"] = this.docNote;
        data["pageNumber"] = this.pageNumber;
        data["isPrivate"] = this.isPrivate;
        data["docId"] = this.docId;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["doc"] = this.doc ? this.doc.toJSON() : <any>undefined;
        data["author"] = this.author;
        data["documentName"] = this.documentName;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface ILexbeDocNote {
    docNoteId?: string | undefined;
    docNoteTitle?: string | undefined;
    docNote?: string | undefined;
    pageNumber?: number;
    isPrivate?: boolean;
    docId?: string;
    createdById?: string;
    dateTimeCreated?: Date;
    doc?: Doc;
    author?: string | undefined;
    documentName?: string | undefined;
    pageCount?: number;
}

export class LexbeDocReview implements ILexbeDocReview {
    attorneyComments?: string | undefined;

    constructor(data?: ILexbeDocReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attorneyComments = _data["attorneyComments"];
        }
    }

    static fromJS(data: any): LexbeDocReview {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attorneyComments"] = this.attorneyComments;
        return data;
    }
}

export interface ILexbeDocReview {
    attorneyComments?: string | undefined;
}

export class LexbeDocSplit implements ILexbeDocSplit {
    caseId?: string;
    docId?: string | undefined;
    splitString?: string | undefined;
    taskType?: string | undefined;

    constructor(data?: ILexbeDocSplit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.docId = _data["docId"];
            this.splitString = _data["splitString"];
            this.taskType = _data["taskType"];
        }
    }

    static fromJS(data: any): LexbeDocSplit {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocSplit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["docId"] = this.docId;
        data["splitString"] = this.splitString;
        data["taskType"] = this.taskType;
        return data;
    }
}

export interface ILexbeDocSplit {
    caseId?: string;
    docId?: string | undefined;
    splitString?: string | undefined;
    taskType?: string | undefined;
}

export class LexbeDocStatus implements ILexbeDocStatus {
    issues?: DocIssueTypes;
    hasNotes?: boolean;
    isDuplicate?: boolean;
    translationStatus?: number;
    redactionStatus?: RedactionStatus;
    annotationStatus?: AnnotationStatus;
    ocrStatus?: number;
    readonly isRedacted?: boolean;
    readonly isRedactionProcessing?: boolean;
    readonly isAnnotated?: boolean;
    readonly isAnnotationProcessing?: boolean;
    readonly isPlaceholder?: boolean;

    constructor(data?: ILexbeDocStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issues = _data["issues"];
            this.hasNotes = _data["hasNotes"];
            this.isDuplicate = _data["isDuplicate"];
            this.translationStatus = _data["translationStatus"];
            this.redactionStatus = _data["redactionStatus"];
            this.annotationStatus = _data["annotationStatus"];
            this.ocrStatus = _data["ocrStatus"];
            (<any>this).isRedacted = _data["isRedacted"];
            (<any>this).isRedactionProcessing = _data["isRedactionProcessing"];
            (<any>this).isAnnotated = _data["isAnnotated"];
            (<any>this).isAnnotationProcessing = _data["isAnnotationProcessing"];
            (<any>this).isPlaceholder = _data["isPlaceholder"];
        }
    }

    static fromJS(data: any): LexbeDocStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeDocStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issues"] = this.issues;
        data["hasNotes"] = this.hasNotes;
        data["isDuplicate"] = this.isDuplicate;
        data["translationStatus"] = this.translationStatus;
        data["redactionStatus"] = this.redactionStatus;
        data["annotationStatus"] = this.annotationStatus;
        data["ocrStatus"] = this.ocrStatus;
        data["isRedacted"] = this.isRedacted;
        data["isRedactionProcessing"] = this.isRedactionProcessing;
        data["isAnnotated"] = this.isAnnotated;
        data["isAnnotationProcessing"] = this.isAnnotationProcessing;
        data["isPlaceholder"] = this.isPlaceholder;
        return data;
    }
}

export interface ILexbeDocStatus {
    issues?: DocIssueTypes;
    hasNotes?: boolean;
    isDuplicate?: boolean;
    translationStatus?: number;
    redactionStatus?: RedactionStatus;
    annotationStatus?: AnnotationStatus;
    ocrStatus?: number;
    isRedacted?: boolean;
    isRedactionProcessing?: boolean;
    isAnnotated?: boolean;
    isAnnotationProcessing?: boolean;
    isPlaceholder?: boolean;
}

export class LexbeEmailType implements ILexbeEmailType {
    value?: string;
    displayName?: string | undefined;

    constructor(data?: ILexbeEmailType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): LexbeEmailType {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeEmailType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ILexbeEmailType {
    value?: string;
    displayName?: string | undefined;
}

export class LexbeField implements ILexbeField {
    fieldId?: string;
    displayTitle?: string | undefined;
    databaseTitle?: string | undefined;
    type?: FieldType;
    isDatMapOption?: boolean;

    constructor(data?: ILexbeField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.displayTitle = _data["displayTitle"];
            this.databaseTitle = _data["databaseTitle"];
            this.type = _data["type"];
            this.isDatMapOption = _data["isDatMapOption"];
        }
    }

    static fromJS(data: any): LexbeField {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["displayTitle"] = this.displayTitle;
        data["databaseTitle"] = this.databaseTitle;
        data["type"] = this.type;
        data["isDatMapOption"] = this.isDatMapOption;
        return data;
    }
}

export interface ILexbeField {
    fieldId?: string;
    displayTitle?: string | undefined;
    databaseTitle?: string | undefined;
    type?: FieldType;
    isDatMapOption?: boolean;
}

export class LexbeUserProfile implements ILexbeUserProfile {
    userId?: string;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    lastUpdatedDate?: Date;

    constructor(data?: ILexbeUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LexbeUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new LexbeUserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILexbeUserProfile {
    userId?: string;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    lastUpdatedDate?: Date;
}

export enum LifeCycle {
    _0 = 0,
    _1 = 1,
}

export enum LifeCycleEditStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class LoginRequest implements ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export class LoginTracker implements ILoginTracker {
    trackerId?: string;
    isLoginSuccess?: boolean;
    userName?: string | undefined;
    userIPAddress?: string | undefined;
    utcDateTime?: Date;

    constructor(data?: ILoginTracker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackerId = _data["trackerId"];
            this.isLoginSuccess = _data["isLoginSuccess"];
            this.userName = _data["userName"];
            this.userIPAddress = _data["userIPAddress"];
            this.utcDateTime = _data["utcDateTime"] ? new Date(_data["utcDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginTracker {
        data = typeof data === 'object' ? data : {};
        let result = new LoginTracker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerId"] = this.trackerId;
        data["isLoginSuccess"] = this.isLoginSuccess;
        data["userName"] = this.userName;
        data["userIPAddress"] = this.userIPAddress;
        data["utcDateTime"] = this.utcDateTime ? this.utcDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILoginTracker {
    trackerId?: string;
    isLoginSuccess?: boolean;
    userName?: string | undefined;
    userIPAddress?: string | undefined;
    utcDateTime?: Date;
}

export class LoginTrackerPagingResponse implements ILoginTrackerPagingResponse {
    value?: LoginTracker[] | undefined;
    count?: number | undefined;

    constructor(data?: ILoginTrackerPagingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(LoginTracker.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): LoginTrackerPagingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginTrackerPagingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface ILoginTrackerPagingResponse {
    value?: LoginTracker[] | undefined;
    count?: number | undefined;
}

export class LoginViewState implements ILoginViewState {
    loginPosterUrl?: string | undefined;

    constructor(data?: ILoginViewState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginPosterUrl = _data["loginPosterUrl"];
        }
    }

    static fromJS(data: any): LoginViewState {
        data = typeof data === 'object' ? data : {};
        let result = new LoginViewState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginPosterUrl"] = this.loginPosterUrl;
        return data;
    }
}

export interface ILoginViewState {
    loginPosterUrl?: string | undefined;
}

export enum MappingType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class MatterClientModel implements IMatterClientModel {

    constructor(data?: IMatterClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MatterClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatterClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMatterClientModel {
}

export class MatterDataModel implements IMatterDataModel {
    id?: number;
    displayNumber?: string | undefined;
    description?: string | undefined;
    folder?: ParentModel;
    client?: MatterClientModel;
    openDate?: string | undefined;

    constructor(data?: IMatterDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayNumber = _data["displayNumber"];
            this.description = _data["description"];
            this.folder = _data["folder"] ? ParentModel.fromJS(_data["folder"]) : <any>undefined;
            this.client = _data["client"] ? MatterClientModel.fromJS(_data["client"]) : <any>undefined;
            this.openDate = _data["openDate"];
        }
    }

    static fromJS(data: any): MatterDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatterDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayNumber"] = this.displayNumber;
        data["description"] = this.description;
        data["folder"] = this.folder ? this.folder.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["openDate"] = this.openDate;
        return data;
    }
}

export interface IMatterDataModel {
    id?: number;
    displayNumber?: string | undefined;
    description?: string | undefined;
    folder?: ParentModel;
    client?: MatterClientModel;
    openDate?: string | undefined;
}

export class MemberInfo implements IMemberInfo {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
}

export enum MemberTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _191 = 191,
}

export class MessagingManagementRequest implements IMessagingManagementRequest {
    serviceName?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IMessagingManagementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): MessagingManagementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MessagingManagementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IMessagingManagementRequest {
    serviceName?: string | undefined;
    isEnabled?: boolean;
}

export class MetaModel implements IMetaModel {
    paging?: PagingModel;
    records?: number;

    constructor(data?: IMetaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paging = _data["paging"] ? PagingModel.fromJS(_data["paging"]) : <any>undefined;
            this.records = _data["records"];
        }
    }

    static fromJS(data: any): MetaModel {
        data = typeof data === 'object' ? data : {};
        let result = new MetaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paging"] = this.paging ? this.paging.toJSON() : <any>undefined;
        data["records"] = this.records;
        return data;
    }
}

export interface IMetaModel {
    paging?: PagingModel;
    records?: number;
}

export enum MethodAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _53248 = 53248,
}

export class MethodBase implements IMethodBase {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }
}

export interface IMethodBase {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

export enum MethodImplAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _4096 = 4096,
    _65535 = 65535,
}

export class MethodInfo implements IMethodInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : <any>undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMethodInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;
}

export class Module implements IModule {
    assembly?: Assembly;
    readonly fullyQualifiedName?: string | undefined;
    readonly name?: string | undefined;
    readonly mdStreamVersion?: number;
    readonly moduleVersionId?: string;
    readonly scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly?: Assembly;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion?: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number;
}

export class MultiDocUpdateRequest implements IMultiDocUpdateRequest {
    filterId?: string | undefined;
    selectedDocIds?: string[] | undefined;
    allDocsSelected?: boolean;
    expandEmailFamily?: boolean;
    isEdit?: boolean;
    setReviewByMe?: boolean;
    sourceFieldId?: string | undefined;
    sourceFieldType?: number;
    targetFieldId?: string;
    targetFieldType?: number;
    newFieldValue?: string | undefined;
    searchParameter?: SearchParameter;

    constructor(data?: IMultiDocUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            if (Array.isArray(_data["selectedDocIds"])) {
                this.selectedDocIds = [] as any;
                for (let item of _data["selectedDocIds"])
                    this.selectedDocIds!.push(item);
            }
            this.allDocsSelected = _data["allDocsSelected"];
            this.expandEmailFamily = _data["expandEmailFamily"];
            this.isEdit = _data["isEdit"];
            this.setReviewByMe = _data["setReviewByMe"];
            this.sourceFieldId = _data["sourceFieldId"];
            this.sourceFieldType = _data["sourceFieldType"];
            this.targetFieldId = _data["targetFieldId"];
            this.targetFieldType = _data["targetFieldType"];
            this.newFieldValue = _data["newFieldValue"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiDocUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDocUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        if (Array.isArray(this.selectedDocIds)) {
            data["selectedDocIds"] = [];
            for (let item of this.selectedDocIds)
                data["selectedDocIds"].push(item);
        }
        data["allDocsSelected"] = this.allDocsSelected;
        data["expandEmailFamily"] = this.expandEmailFamily;
        data["isEdit"] = this.isEdit;
        data["setReviewByMe"] = this.setReviewByMe;
        data["sourceFieldId"] = this.sourceFieldId;
        data["sourceFieldType"] = this.sourceFieldType;
        data["targetFieldId"] = this.targetFieldId;
        data["targetFieldType"] = this.targetFieldType;
        data["newFieldValue"] = this.newFieldValue;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMultiDocUpdateRequest {
    filterId?: string | undefined;
    selectedDocIds?: string[] | undefined;
    allDocsSelected?: boolean;
    expandEmailFamily?: boolean;
    isEdit?: boolean;
    setReviewByMe?: boolean;
    sourceFieldId?: string | undefined;
    sourceFieldType?: number;
    targetFieldId?: string;
    targetFieldType?: number;
    newFieldValue?: string | undefined;
    searchParameter?: SearchParameter;
}

export class MultiProcessingStepBody implements IMultiProcessingStepBody {
    request?: ProcessingQueueRequest;
    bulkData?: BulkDocAddRequest;

    constructor(data?: IMultiProcessingStepBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? ProcessingQueueRequest.fromJS(_data["request"]) : <any>undefined;
            this.bulkData = _data["bulkData"] ? BulkDocAddRequest.fromJS(_data["bulkData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiProcessingStepBody {
        data = typeof data === 'object' ? data : {};
        let result = new MultiProcessingStepBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["bulkData"] = this.bulkData ? this.bulkData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMultiProcessingStepBody {
    request?: ProcessingQueueRequest;
    bulkData?: BulkDocAddRequest;
}

export class MultiSort implements IMultiSort {
    first?: Sort;
    second?: Sort;
    third?: Sort;

    constructor(data?: IMultiSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.first = _data["first"] ? Sort.fromJS(_data["first"]) : <any>undefined;
            this.second = _data["second"] ? Sort.fromJS(_data["second"]) : <any>undefined;
            this.third = _data["third"] ? Sort.fromJS(_data["third"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiSort {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["first"] = this.first ? this.first.toJSON() : <any>undefined;
        data["second"] = this.second ? this.second.toJSON() : <any>undefined;
        data["third"] = this.third ? this.third.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMultiSort {
    first?: Sort;
    second?: Sort;
    third?: Sort;
}

export class NumberFormatInfo implements INumberFormatInfo {
    currencyDecimalDigits?: number;
    currencyDecimalSeparator?: string | undefined;
    readonly isReadOnly?: boolean;
    currencyGroupSizes?: number[] | undefined;
    numberGroupSizes?: number[] | undefined;
    percentGroupSizes?: number[] | undefined;
    currencyGroupSeparator?: string | undefined;
    currencySymbol?: string | undefined;
    naNSymbol?: string | undefined;
    currencyNegativePattern?: number;
    numberNegativePattern?: number;
    percentPositivePattern?: number;
    percentNegativePattern?: number;
    negativeInfinitySymbol?: string | undefined;
    negativeSign?: string | undefined;
    numberDecimalDigits?: number;
    numberDecimalSeparator?: string | undefined;
    numberGroupSeparator?: string | undefined;
    currencyPositivePattern?: number;
    positiveInfinitySymbol?: string | undefined;
    positiveSign?: string | undefined;
    percentDecimalDigits?: number;
    percentDecimalSeparator?: string | undefined;
    percentGroupSeparator?: string | undefined;
    percentSymbol?: string | undefined;
    perMilleSymbol?: string | undefined;
    nativeDigits?: string[] | undefined;
    digitSubstitution?: DigitShapes;

    constructor(data?: INumberFormatInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyDecimalDigits = _data["currencyDecimalDigits"];
            this.currencyDecimalSeparator = _data["currencyDecimalSeparator"];
            (<any>this).isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["currencyGroupSizes"])) {
                this.currencyGroupSizes = [] as any;
                for (let item of _data["currencyGroupSizes"])
                    this.currencyGroupSizes!.push(item);
            }
            if (Array.isArray(_data["numberGroupSizes"])) {
                this.numberGroupSizes = [] as any;
                for (let item of _data["numberGroupSizes"])
                    this.numberGroupSizes!.push(item);
            }
            if (Array.isArray(_data["percentGroupSizes"])) {
                this.percentGroupSizes = [] as any;
                for (let item of _data["percentGroupSizes"])
                    this.percentGroupSizes!.push(item);
            }
            this.currencyGroupSeparator = _data["currencyGroupSeparator"];
            this.currencySymbol = _data["currencySymbol"];
            this.naNSymbol = _data["naNSymbol"];
            this.currencyNegativePattern = _data["currencyNegativePattern"];
            this.numberNegativePattern = _data["numberNegativePattern"];
            this.percentPositivePattern = _data["percentPositivePattern"];
            this.percentNegativePattern = _data["percentNegativePattern"];
            this.negativeInfinitySymbol = _data["negativeInfinitySymbol"];
            this.negativeSign = _data["negativeSign"];
            this.numberDecimalDigits = _data["numberDecimalDigits"];
            this.numberDecimalSeparator = _data["numberDecimalSeparator"];
            this.numberGroupSeparator = _data["numberGroupSeparator"];
            this.currencyPositivePattern = _data["currencyPositivePattern"];
            this.positiveInfinitySymbol = _data["positiveInfinitySymbol"];
            this.positiveSign = _data["positiveSign"];
            this.percentDecimalDigits = _data["percentDecimalDigits"];
            this.percentDecimalSeparator = _data["percentDecimalSeparator"];
            this.percentGroupSeparator = _data["percentGroupSeparator"];
            this.percentSymbol = _data["percentSymbol"];
            this.perMilleSymbol = _data["perMilleSymbol"];
            if (Array.isArray(_data["nativeDigits"])) {
                this.nativeDigits = [] as any;
                for (let item of _data["nativeDigits"])
                    this.nativeDigits!.push(item);
            }
            this.digitSubstitution = _data["digitSubstitution"];
        }
    }

    static fromJS(data: any): NumberFormatInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NumberFormatInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyDecimalDigits"] = this.currencyDecimalDigits;
        data["currencyDecimalSeparator"] = this.currencyDecimalSeparator;
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.currencyGroupSizes)) {
            data["currencyGroupSizes"] = [];
            for (let item of this.currencyGroupSizes)
                data["currencyGroupSizes"].push(item);
        }
        if (Array.isArray(this.numberGroupSizes)) {
            data["numberGroupSizes"] = [];
            for (let item of this.numberGroupSizes)
                data["numberGroupSizes"].push(item);
        }
        if (Array.isArray(this.percentGroupSizes)) {
            data["percentGroupSizes"] = [];
            for (let item of this.percentGroupSizes)
                data["percentGroupSizes"].push(item);
        }
        data["currencyGroupSeparator"] = this.currencyGroupSeparator;
        data["currencySymbol"] = this.currencySymbol;
        data["naNSymbol"] = this.naNSymbol;
        data["currencyNegativePattern"] = this.currencyNegativePattern;
        data["numberNegativePattern"] = this.numberNegativePattern;
        data["percentPositivePattern"] = this.percentPositivePattern;
        data["percentNegativePattern"] = this.percentNegativePattern;
        data["negativeInfinitySymbol"] = this.negativeInfinitySymbol;
        data["negativeSign"] = this.negativeSign;
        data["numberDecimalDigits"] = this.numberDecimalDigits;
        data["numberDecimalSeparator"] = this.numberDecimalSeparator;
        data["numberGroupSeparator"] = this.numberGroupSeparator;
        data["currencyPositivePattern"] = this.currencyPositivePattern;
        data["positiveInfinitySymbol"] = this.positiveInfinitySymbol;
        data["positiveSign"] = this.positiveSign;
        data["percentDecimalDigits"] = this.percentDecimalDigits;
        data["percentDecimalSeparator"] = this.percentDecimalSeparator;
        data["percentGroupSeparator"] = this.percentGroupSeparator;
        data["percentSymbol"] = this.percentSymbol;
        data["perMilleSymbol"] = this.perMilleSymbol;
        if (Array.isArray(this.nativeDigits)) {
            data["nativeDigits"] = [];
            for (let item of this.nativeDigits)
                data["nativeDigits"].push(item);
        }
        data["digitSubstitution"] = this.digitSubstitution;
        return data;
    }
}

export interface INumberFormatInfo {
    currencyDecimalDigits?: number;
    currencyDecimalSeparator?: string | undefined;
    isReadOnly?: boolean;
    currencyGroupSizes?: number[] | undefined;
    numberGroupSizes?: number[] | undefined;
    percentGroupSizes?: number[] | undefined;
    currencyGroupSeparator?: string | undefined;
    currencySymbol?: string | undefined;
    naNSymbol?: string | undefined;
    currencyNegativePattern?: number;
    numberNegativePattern?: number;
    percentPositivePattern?: number;
    percentNegativePattern?: number;
    negativeInfinitySymbol?: string | undefined;
    negativeSign?: string | undefined;
    numberDecimalDigits?: number;
    numberDecimalSeparator?: string | undefined;
    numberGroupSeparator?: string | undefined;
    currencyPositivePattern?: number;
    positiveInfinitySymbol?: string | undefined;
    positiveSign?: string | undefined;
    percentDecimalDigits?: number;
    percentDecimalSeparator?: string | undefined;
    percentGroupSeparator?: string | undefined;
    percentSymbol?: string | undefined;
    perMilleSymbol?: string | undefined;
    nativeDigits?: string[] | undefined;
    digitSubstitution?: DigitShapes;
}

export class OpenAISetting implements IOpenAISetting {
    apiKey?: string | undefined;
    model?: string | undefined;

    constructor(data?: IOpenAISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): OpenAISetting {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAISetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["model"] = this.model;
        return data;
    }
}

export interface IOpenAISetting {
    apiKey?: string | undefined;
    model?: string | undefined;
}

export class Operation implements IOperation {
    operationType?: OperationType;
    path?: string | undefined;
    op?: string | undefined;
    from?: string | undefined;
    value?: any | undefined;

    constructor(data?: IOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationType = _data["operationType"];
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType;
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        data["value"] = this.value;
        return data;
    }
}

export interface IOperation {
    operationType?: OperationType;
    path?: string | undefined;
    op?: string | undefined;
    from?: string | undefined;
    value?: any | undefined;
}

export enum OperationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class PagingModel implements IPagingModel {
    previous?: string | undefined;
    next?: string | undefined;

    constructor(data?: IPagingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previous = _data["previous"];
            this.next = _data["next"];
        }
    }

    static fromJS(data: any): PagingModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previous"] = this.previous;
        data["next"] = this.next;
        return data;
    }
}

export interface IPagingModel {
    previous?: string | undefined;
    next?: string | undefined;
}

export enum ParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _61440 = 61440,
}

export class ParameterInfo implements IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    readonly name?: string | undefined;
    parameterType?: Type;
    readonly position?: number;
    readonly isIn?: boolean;
    readonly isLcid?: boolean;
    readonly isOptional?: boolean;
    readonly isOut?: boolean;
    readonly isRetval?: boolean;
    readonly defaultValue?: any | undefined;
    readonly rawDefaultValue?: any | undefined;
    readonly hasDefaultValue?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : <any>undefined;
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: Type;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export class ParentModel implements IParentModel {
    id?: number;
    name?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IParentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParentModel {
    id?: number;
    name?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export class PartETag implements IPartETag {
    partNumber?: number | undefined;
    eTag?: string | undefined;
    checksumCRC32?: string | undefined;
    checksumCRC32C?: string | undefined;
    checksumCRC64NVME?: string | undefined;
    checksumSHA1?: string | undefined;
    checksumSHA256?: string | undefined;

    constructor(data?: IPartETag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partNumber = _data["partNumber"];
            this.eTag = _data["eTag"];
            this.checksumCRC32 = _data["checksumCRC32"];
            this.checksumCRC32C = _data["checksumCRC32C"];
            this.checksumCRC64NVME = _data["checksumCRC64NVME"];
            this.checksumSHA1 = _data["checksumSHA1"];
            this.checksumSHA256 = _data["checksumSHA256"];
        }
    }

    static fromJS(data: any): PartETag {
        data = typeof data === 'object' ? data : {};
        let result = new PartETag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partNumber"] = this.partNumber;
        data["eTag"] = this.eTag;
        data["checksumCRC32"] = this.checksumCRC32;
        data["checksumCRC32C"] = this.checksumCRC32C;
        data["checksumCRC64NVME"] = this.checksumCRC64NVME;
        data["checksumSHA1"] = this.checksumSHA1;
        data["checksumSHA256"] = this.checksumSHA256;
        return data;
    }
}

export interface IPartETag {
    partNumber?: number | undefined;
    eTag?: string | undefined;
    checksumCRC32?: string | undefined;
    checksumCRC32C?: string | undefined;
    checksumCRC64NVME?: string | undefined;
    checksumSHA1?: string | undefined;
    checksumSHA256?: string | undefined;
}

export class PilotRequest implements IPilotRequest {
    aiModel?: string | undefined;
    promptId?: string;
    searchType?: PilotSearchType;

    constructor(data?: IPilotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aiModel = _data["aiModel"];
            this.promptId = _data["promptId"];
            this.searchType = _data["searchType"];
        }
    }

    static fromJS(data: any): PilotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PilotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aiModel"] = this.aiModel;
        data["promptId"] = this.promptId;
        data["searchType"] = this.searchType;
        return data;
    }
}

export interface IPilotRequest {
    aiModel?: string | undefined;
    promptId?: string;
    searchType?: PilotSearchType;
}

export class PilotRequestStreamingRequest implements IPilotRequestStreamingRequest {
    workflowKey?: string | undefined;

    constructor(data?: IPilotRequestStreamingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowKey = _data["workflowKey"];
        }
    }

    static fromJS(data: any): PilotRequestStreamingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PilotRequestStreamingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowKey"] = this.workflowKey;
        return data;
    }
}

export interface IPilotRequestStreamingRequest {
    workflowKey?: string | undefined;
}

export class PilotRequestStreamingResponse implements IPilotRequestStreamingResponse {
    result?: string | undefined;
    docIds?: string[] | undefined;
    completed?: boolean;

    constructor(data?: IPilotRequestStreamingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): PilotRequestStreamingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PilotRequestStreamingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["completed"] = this.completed;
        return data;
    }
}

export interface IPilotRequestStreamingResponse {
    result?: string | undefined;
    docIds?: string[] | undefined;
    completed?: boolean;
}

export enum PilotSearchType {
    _0 = 0,
    _1 = 1,
}

export class PreferenceControlModule implements IPreferenceControlModule {
    userId?: string;
    caseId?: string;
    moduleId?: string;
    isCollapsed?: boolean;

    constructor(data?: IPreferenceControlModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.caseId = _data["caseId"];
            this.moduleId = _data["moduleId"];
            this.isCollapsed = _data["isCollapsed"];
        }
    }

    static fromJS(data: any): PreferenceControlModule {
        data = typeof data === 'object' ? data : {};
        let result = new PreferenceControlModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["caseId"] = this.caseId;
        data["moduleId"] = this.moduleId;
        data["isCollapsed"] = this.isCollapsed;
        return data;
    }
}

export interface IPreferenceControlModule {
    userId?: string;
    caseId?: string;
    moduleId?: string;
    isCollapsed?: boolean;
}

export enum PresetType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProcessingQueueRequest implements IProcessingQueueRequest {
    functionId?: string;
    functionArgument?: string | undefined;
    caseId?: string;
    docId?: string;

    constructor(data?: IProcessingQueueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionId = _data["functionId"];
            this.functionArgument = _data["functionArgument"];
            this.caseId = _data["caseId"];
            this.docId = _data["docId"];
        }
    }

    static fromJS(data: any): ProcessingQueueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingQueueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionId"] = this.functionId;
        data["functionArgument"] = this.functionArgument;
        data["caseId"] = this.caseId;
        data["docId"] = this.docId;
        return data;
    }
}

export interface IProcessingQueueRequest {
    functionId?: string;
    functionArgument?: string | undefined;
    caseId?: string;
    docId?: string;
}

export enum ProcessingStepFunctionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
}

export class ProductionAudit implements IProductionAudit {
    createdAt?: number;
    readonly createdAtDateTimeOffset?: Date;
    auditAt?: number;
    readonly auditAtDateTimeOffset?: Date;
    productionId?: string;
    caseId?: string;
    sharedProductionJobId?: string | undefined;
    partIndex?: number | undefined;
    email?: string | undefined;
    ipv4?: string | undefined;
    browser?: string | undefined;
    operatingSystem?: string | undefined;
    sourceEventId?: string | undefined;
    readonly entity?: string | undefined;
    readonly entityId?: string | undefined;
    action?: string | undefined;

    constructor(data?: IProductionAudit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"];
            (<any>this).createdAtDateTimeOffset = _data["createdAtDateTimeOffset"] ? new Date(_data["createdAtDateTimeOffset"].toString()) : <any>undefined;
            this.auditAt = _data["auditAt"];
            (<any>this).auditAtDateTimeOffset = _data["auditAtDateTimeOffset"] ? new Date(_data["auditAtDateTimeOffset"].toString()) : <any>undefined;
            this.productionId = _data["productionId"];
            this.caseId = _data["caseId"];
            this.sharedProductionJobId = _data["sharedProductionJobId"];
            this.partIndex = _data["partIndex"];
            this.email = _data["email"];
            this.ipv4 = _data["ipv4"];
            this.browser = _data["browser"];
            this.operatingSystem = _data["operatingSystem"];
            this.sourceEventId = _data["sourceEventId"];
            (<any>this).entity = _data["entity"];
            (<any>this).entityId = _data["entityId"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ProductionAudit {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionAudit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt;
        data["createdAtDateTimeOffset"] = this.createdAtDateTimeOffset ? this.createdAtDateTimeOffset.toISOString() : <any>undefined;
        data["auditAt"] = this.auditAt;
        data["auditAtDateTimeOffset"] = this.auditAtDateTimeOffset ? this.auditAtDateTimeOffset.toISOString() : <any>undefined;
        data["productionId"] = this.productionId;
        data["caseId"] = this.caseId;
        data["sharedProductionJobId"] = this.sharedProductionJobId;
        data["partIndex"] = this.partIndex;
        data["email"] = this.email;
        data["ipv4"] = this.ipv4;
        data["browser"] = this.browser;
        data["operatingSystem"] = this.operatingSystem;
        data["sourceEventId"] = this.sourceEventId;
        data["entity"] = this.entity;
        data["entityId"] = this.entityId;
        data["action"] = this.action;
        return data;
    }
}

export interface IProductionAudit {
    createdAt?: number;
    createdAtDateTimeOffset?: Date;
    auditAt?: number;
    auditAtDateTimeOffset?: Date;
    productionId?: string;
    caseId?: string;
    sharedProductionJobId?: string | undefined;
    partIndex?: number | undefined;
    email?: string | undefined;
    ipv4?: string | undefined;
    browser?: string | undefined;
    operatingSystem?: string | undefined;
    sourceEventId?: string | undefined;
    entity?: string | undefined;
    entityId?: string | undefined;
    action?: string | undefined;
}

export class ProductionJob implements IProductionJob {
    productionJobId?: string;
    caseId?: string;
    createdById?: string;
    runById?: string | undefined;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    batesBasePrefix?: string | undefined;
    batesBaseNumberStart?: number;
    batesBaseNumberDigits?: number;
    customDesignation?: string | undefined;
    isBatesStampPages?: boolean;
    isControlNumberStampPages?: boolean;
    isCreateTiff?: boolean;
    docSizeProduced?: number;
    docSizeWithheld?: number;
    batesRangeProduction?: string | undefined;
    isImportProductionJob?: boolean;
    batesRangeWithheld?: string | undefined;
    lifecycle?: number;
    status?: ProductionJobStatus;
    isIncludeNativeEmails?: boolean;
    sortId?: string | undefined;
    sortLevel1?: number;
    sortLevel2?: number;
    level1FieldId?: string;
    processingStepCount?: number | undefined;
    totalDocCount?: number | undefined;
    lastModified?: Date;
    fieldLayoutId?: string | undefined;
    fieldLayout?: FieldLayout;
    savedSort?: SavedSort;

    constructor(data?: IProductionJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionJobId = _data["productionJobId"];
            this.caseId = _data["caseId"];
            this.createdById = _data["createdById"];
            this.runById = _data["runById"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeRun = _data["dateTimeRun"] ? new Date(_data["dateTimeRun"].toString()) : <any>undefined;
            this.batesBasePrefix = _data["batesBasePrefix"];
            this.batesBaseNumberStart = _data["batesBaseNumberStart"];
            this.batesBaseNumberDigits = _data["batesBaseNumberDigits"];
            this.customDesignation = _data["customDesignation"];
            this.isBatesStampPages = _data["isBatesStampPages"];
            this.isControlNumberStampPages = _data["isControlNumberStampPages"];
            this.isCreateTiff = _data["isCreateTiff"];
            this.docSizeProduced = _data["docSizeProduced"];
            this.docSizeWithheld = _data["docSizeWithheld"];
            this.batesRangeProduction = _data["batesRangeProduction"];
            this.isImportProductionJob = _data["isImportProductionJob"];
            this.batesRangeWithheld = _data["batesRangeWithheld"];
            this.lifecycle = _data["lifecycle"];
            this.status = _data["status"];
            this.isIncludeNativeEmails = _data["isIncludeNativeEmails"];
            this.sortId = _data["sortId"];
            this.sortLevel1 = _data["sortLevel1"];
            this.sortLevel2 = _data["sortLevel2"];
            this.level1FieldId = _data["level1FieldId"];
            this.processingStepCount = _data["processingStepCount"];
            this.totalDocCount = _data["totalDocCount"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.fieldLayoutId = _data["fieldLayoutId"];
            this.fieldLayout = _data["fieldLayout"] ? FieldLayout.fromJS(_data["fieldLayout"]) : <any>undefined;
            this.savedSort = _data["savedSort"] ? SavedSort.fromJS(_data["savedSort"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductionJob {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionJobId"] = this.productionJobId;
        data["caseId"] = this.caseId;
        data["createdById"] = this.createdById;
        data["runById"] = this.runById;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeRun"] = this.dateTimeRun ? this.dateTimeRun.toISOString() : <any>undefined;
        data["batesBasePrefix"] = this.batesBasePrefix;
        data["batesBaseNumberStart"] = this.batesBaseNumberStart;
        data["batesBaseNumberDigits"] = this.batesBaseNumberDigits;
        data["customDesignation"] = this.customDesignation;
        data["isBatesStampPages"] = this.isBatesStampPages;
        data["isControlNumberStampPages"] = this.isControlNumberStampPages;
        data["isCreateTiff"] = this.isCreateTiff;
        data["docSizeProduced"] = this.docSizeProduced;
        data["docSizeWithheld"] = this.docSizeWithheld;
        data["batesRangeProduction"] = this.batesRangeProduction;
        data["isImportProductionJob"] = this.isImportProductionJob;
        data["batesRangeWithheld"] = this.batesRangeWithheld;
        data["lifecycle"] = this.lifecycle;
        data["status"] = this.status;
        data["isIncludeNativeEmails"] = this.isIncludeNativeEmails;
        data["sortId"] = this.sortId;
        data["sortLevel1"] = this.sortLevel1;
        data["sortLevel2"] = this.sortLevel2;
        data["level1FieldId"] = this.level1FieldId;
        data["processingStepCount"] = this.processingStepCount;
        data["totalDocCount"] = this.totalDocCount;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["fieldLayoutId"] = this.fieldLayoutId;
        data["fieldLayout"] = this.fieldLayout ? this.fieldLayout.toJSON() : <any>undefined;
        data["savedSort"] = this.savedSort ? this.savedSort.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProductionJob {
    productionJobId?: string;
    caseId?: string;
    createdById?: string;
    runById?: string | undefined;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    batesBasePrefix?: string | undefined;
    batesBaseNumberStart?: number;
    batesBaseNumberDigits?: number;
    customDesignation?: string | undefined;
    isBatesStampPages?: boolean;
    isControlNumberStampPages?: boolean;
    isCreateTiff?: boolean;
    docSizeProduced?: number;
    docSizeWithheld?: number;
    batesRangeProduction?: string | undefined;
    isImportProductionJob?: boolean;
    batesRangeWithheld?: string | undefined;
    lifecycle?: number;
    status?: ProductionJobStatus;
    isIncludeNativeEmails?: boolean;
    sortId?: string | undefined;
    sortLevel1?: number;
    sortLevel2?: number;
    level1FieldId?: string;
    processingStepCount?: number | undefined;
    totalDocCount?: number | undefined;
    lastModified?: Date;
    fieldLayoutId?: string | undefined;
    fieldLayout?: FieldLayout;
    savedSort?: SavedSort;
}

export class ProductionJobDocViewModel implements IProductionJobDocViewModel {
    productionJobId?: string;
    docId?: string;
    caseId?: string;
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
    privilege?: boolean;
    workProduct?: boolean;
    redactForPrivilege?: boolean;
    redactForPi?: boolean;
    confidential?: boolean;
    useCustomDesignation?: boolean;
    responsive?: number;

    constructor(data?: IProductionJobDocViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionJobId = _data["productionJobId"];
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.batesPrefix = _data["batesPrefix"];
            this.batesNumberStart = _data["batesNumberStart"];
            this.batesNumberDigits = _data["batesNumberDigits"];
            this.privilege = _data["privilege"];
            this.workProduct = _data["workProduct"];
            this.redactForPrivilege = _data["redactForPrivilege"];
            this.redactForPi = _data["redactForPi"];
            this.confidential = _data["confidential"];
            this.useCustomDesignation = _data["useCustomDesignation"];
            this.responsive = _data["responsive"];
        }
    }

    static fromJS(data: any): ProductionJobDocViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJobDocViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionJobId"] = this.productionJobId;
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["batesPrefix"] = this.batesPrefix;
        data["batesNumberStart"] = this.batesNumberStart;
        data["batesNumberDigits"] = this.batesNumberDigits;
        data["privilege"] = this.privilege;
        data["workProduct"] = this.workProduct;
        data["redactForPrivilege"] = this.redactForPrivilege;
        data["redactForPi"] = this.redactForPi;
        data["confidential"] = this.confidential;
        data["useCustomDesignation"] = this.useCustomDesignation;
        data["responsive"] = this.responsive;
        return data;
    }
}

export interface IProductionJobDocViewModel {
    productionJobId?: string;
    docId?: string;
    caseId?: string;
    batesPrefix?: string | undefined;
    batesNumberStart?: number;
    batesNumberDigits?: number;
    privilege?: boolean;
    workProduct?: boolean;
    redactForPrivilege?: boolean;
    redactForPi?: boolean;
    confidential?: boolean;
    useCustomDesignation?: boolean;
    responsive?: number;
}

export class ProductionJobShared implements IProductionJobShared {
    sharedId?: string;
    productionJobId?: string;
    downloadPassword?: string | undefined;
    expires?: Date | undefined;

    constructor(data?: IProductionJobShared) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedId = _data["sharedId"];
            this.productionJobId = _data["productionJobId"];
            this.downloadPassword = _data["downloadPassword"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductionJobShared {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJobShared();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedId"] = this.sharedId;
        data["productionJobId"] = this.productionJobId;
        data["downloadPassword"] = this.downloadPassword;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductionJobShared {
    sharedId?: string;
    productionJobId?: string;
    downloadPassword?: string | undefined;
    expires?: Date | undefined;
}

export class ProductionJobSharedDetail implements IProductionJobSharedDetail {
    sharedId?: string;
    productionJobId?: string;
    caseId?: string;
    title?: string | undefined;
    docSizeProduced?: number;
    hasPassword?: boolean;
    jobStatus?: ProductionJobStatus;

    constructor(data?: IProductionJobSharedDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedId = _data["sharedId"];
            this.productionJobId = _data["productionJobId"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.docSizeProduced = _data["docSizeProduced"];
            this.hasPassword = _data["hasPassword"];
            this.jobStatus = _data["jobStatus"];
        }
    }

    static fromJS(data: any): ProductionJobSharedDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJobSharedDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedId"] = this.sharedId;
        data["productionJobId"] = this.productionJobId;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["docSizeProduced"] = this.docSizeProduced;
        data["hasPassword"] = this.hasPassword;
        data["jobStatus"] = this.jobStatus;
        return data;
    }
}

export interface IProductionJobSharedDetail {
    sharedId?: string;
    productionJobId?: string;
    caseId?: string;
    title?: string | undefined;
    docSizeProduced?: number;
    hasPassword?: boolean;
    jobStatus?: ProductionJobStatus;
}

export class ProductionJobSharedResponse implements IProductionJobSharedResponse {
    success?: boolean;
    export?: SharedExport;

    constructor(data?: IProductionJobSharedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.export = _data["export"] ? SharedExport.fromJS(_data["export"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductionJobSharedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJobSharedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["export"] = this.export ? this.export.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProductionJobSharedResponse {
    success?: boolean;
    export?: SharedExport;
}

export class ProductionJobState implements IProductionJobState {
    productionJobs?: ProductionJobView[] | undefined;
    caseProductionJobCount?: number;
    totalDocCount?: number;

    constructor(data?: IProductionJobState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productionJobs"])) {
                this.productionJobs = [] as any;
                for (let item of _data["productionJobs"])
                    this.productionJobs!.push(ProductionJobView.fromJS(item));
            }
            this.caseProductionJobCount = _data["caseProductionJobCount"];
            this.totalDocCount = _data["totalDocCount"];
        }
    }

    static fromJS(data: any): ProductionJobState {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJobState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productionJobs)) {
            data["productionJobs"] = [];
            for (let item of this.productionJobs)
                data["productionJobs"].push(item.toJSON());
        }
        data["caseProductionJobCount"] = this.caseProductionJobCount;
        data["totalDocCount"] = this.totalDocCount;
        return data;
    }
}

export interface IProductionJobState {
    productionJobs?: ProductionJobView[] | undefined;
    caseProductionJobCount?: number;
    totalDocCount?: number;
}

export enum ProductionJobStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ProductionJobView implements IProductionJobView {
    productionJobId?: string;
    caseId?: string;
    createdById?: string;
    runById?: string | undefined;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    batesBasePrefix?: string | undefined;
    batesBaseNumberStart?: number;
    batesBaseNumberDigits?: number;
    customDesignation?: string | undefined;
    isBatesStampPages?: boolean;
    isControlNumberStampPages?: boolean;
    isCreateTiff?: boolean;
    docSizeProduced?: number;
    docSizeWithheld?: number;
    batesRangeProduction?: string | undefined;
    isImportProductionJob?: boolean;
    batesRangeWithheld?: string | undefined;
    lifecycle?: number;
    status?: ProductionJobStatus;
    isIncludeNativeEmails?: boolean;
    sortId?: string | undefined;
    sortLevel1?: number;
    sortLevel2?: number;
    level1FieldId?: string;
    processingStepCount?: number | undefined;
    totalDocCount?: number | undefined;
    lastModified?: Date;
    producedDocCount?: number;
    withheldDocCount?: number;
    partiallyPrivilegedDocCount?: number;

    constructor(data?: IProductionJobView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionJobId = _data["productionJobId"];
            this.caseId = _data["caseId"];
            this.createdById = _data["createdById"];
            this.runById = _data["runById"];
            this.title = _data["title"];
            this.comments = _data["comments"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeRun = _data["dateTimeRun"] ? new Date(_data["dateTimeRun"].toString()) : <any>undefined;
            this.batesBasePrefix = _data["batesBasePrefix"];
            this.batesBaseNumberStart = _data["batesBaseNumberStart"];
            this.batesBaseNumberDigits = _data["batesBaseNumberDigits"];
            this.customDesignation = _data["customDesignation"];
            this.isBatesStampPages = _data["isBatesStampPages"];
            this.isControlNumberStampPages = _data["isControlNumberStampPages"];
            this.isCreateTiff = _data["isCreateTiff"];
            this.docSizeProduced = _data["docSizeProduced"];
            this.docSizeWithheld = _data["docSizeWithheld"];
            this.batesRangeProduction = _data["batesRangeProduction"];
            this.isImportProductionJob = _data["isImportProductionJob"];
            this.batesRangeWithheld = _data["batesRangeWithheld"];
            this.lifecycle = _data["lifecycle"];
            this.status = _data["status"];
            this.isIncludeNativeEmails = _data["isIncludeNativeEmails"];
            this.sortId = _data["sortId"];
            this.sortLevel1 = _data["sortLevel1"];
            this.sortLevel2 = _data["sortLevel2"];
            this.level1FieldId = _data["level1FieldId"];
            this.processingStepCount = _data["processingStepCount"];
            this.totalDocCount = _data["totalDocCount"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.producedDocCount = _data["producedDocCount"];
            this.withheldDocCount = _data["withheldDocCount"];
            this.partiallyPrivilegedDocCount = _data["partiallyPrivilegedDocCount"];
        }
    }

    static fromJS(data: any): ProductionJobView {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionJobView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionJobId"] = this.productionJobId;
        data["caseId"] = this.caseId;
        data["createdById"] = this.createdById;
        data["runById"] = this.runById;
        data["title"] = this.title;
        data["comments"] = this.comments;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeRun"] = this.dateTimeRun ? this.dateTimeRun.toISOString() : <any>undefined;
        data["batesBasePrefix"] = this.batesBasePrefix;
        data["batesBaseNumberStart"] = this.batesBaseNumberStart;
        data["batesBaseNumberDigits"] = this.batesBaseNumberDigits;
        data["customDesignation"] = this.customDesignation;
        data["isBatesStampPages"] = this.isBatesStampPages;
        data["isControlNumberStampPages"] = this.isControlNumberStampPages;
        data["isCreateTiff"] = this.isCreateTiff;
        data["docSizeProduced"] = this.docSizeProduced;
        data["docSizeWithheld"] = this.docSizeWithheld;
        data["batesRangeProduction"] = this.batesRangeProduction;
        data["isImportProductionJob"] = this.isImportProductionJob;
        data["batesRangeWithheld"] = this.batesRangeWithheld;
        data["lifecycle"] = this.lifecycle;
        data["status"] = this.status;
        data["isIncludeNativeEmails"] = this.isIncludeNativeEmails;
        data["sortId"] = this.sortId;
        data["sortLevel1"] = this.sortLevel1;
        data["sortLevel2"] = this.sortLevel2;
        data["level1FieldId"] = this.level1FieldId;
        data["processingStepCount"] = this.processingStepCount;
        data["totalDocCount"] = this.totalDocCount;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["producedDocCount"] = this.producedDocCount;
        data["withheldDocCount"] = this.withheldDocCount;
        data["partiallyPrivilegedDocCount"] = this.partiallyPrivilegedDocCount;
        return data;
    }
}

export interface IProductionJobView {
    productionJobId?: string;
    caseId?: string;
    createdById?: string;
    runById?: string | undefined;
    title?: string | undefined;
    comments?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeRun?: Date | undefined;
    batesBasePrefix?: string | undefined;
    batesBaseNumberStart?: number;
    batesBaseNumberDigits?: number;
    customDesignation?: string | undefined;
    isBatesStampPages?: boolean;
    isControlNumberStampPages?: boolean;
    isCreateTiff?: boolean;
    docSizeProduced?: number;
    docSizeWithheld?: number;
    batesRangeProduction?: string | undefined;
    isImportProductionJob?: boolean;
    batesRangeWithheld?: string | undefined;
    lifecycle?: number;
    status?: ProductionJobStatus;
    isIncludeNativeEmails?: boolean;
    sortId?: string | undefined;
    sortLevel1?: number;
    sortLevel2?: number;
    level1FieldId?: string;
    processingStepCount?: number | undefined;
    totalDocCount?: number | undefined;
    lastModified?: Date;
    producedDocCount?: number;
    withheldDocCount?: number;
    partiallyPrivilegedDocCount?: number;
}

export enum ProductionValidator {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class Prompt implements IPrompt {
    promptId?: string;
    createdById?: string;
    caseId?: string;
    title?: string | undefined;
    fullPrompt?: string | undefined;
    isPinned?: boolean;
    isShared?: boolean;
    dateTimeCreated?: Date;
    lifeCycle?: number;
    promptType?: PromptType;

    constructor(data?: IPrompt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptId = _data["promptId"];
            this.createdById = _data["createdById"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.fullPrompt = _data["fullPrompt"];
            this.isPinned = _data["isPinned"];
            this.isShared = _data["isShared"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.lifeCycle = _data["lifeCycle"];
            this.promptType = _data["promptType"];
        }
    }

    static fromJS(data: any): Prompt {
        data = typeof data === 'object' ? data : {};
        let result = new Prompt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptId"] = this.promptId;
        data["createdById"] = this.createdById;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["fullPrompt"] = this.fullPrompt;
        data["isPinned"] = this.isPinned;
        data["isShared"] = this.isShared;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["lifeCycle"] = this.lifeCycle;
        data["promptType"] = this.promptType;
        return data;
    }
}

export interface IPrompt {
    promptId?: string;
    createdById?: string;
    caseId?: string;
    title?: string | undefined;
    fullPrompt?: string | undefined;
    isPinned?: boolean;
    isShared?: boolean;
    dateTimeCreated?: Date;
    lifeCycle?: number;
    promptType?: PromptType;
}

export enum PromptType {
    _0 = 0,
    _1 = 1,
}

export enum PropertyAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _62464 = 62464,
}

export class PropertyInfo implements IPropertyInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    readonly isSpecialName?: boolean;
    readonly canRead?: boolean;
    readonly canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : <any>undefined;
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    isSpecialName?: boolean;
    canRead?: boolean;
    canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;
}

export class RecoverPasswordRequest implements IRecoverPasswordRequest {
    email?: string | undefined;

    constructor(data?: IRecoverPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RecoverPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecoverPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IRecoverPasswordRequest {
    email?: string | undefined;
}

export class Redaction implements IRedaction {
    redactionId?: string;
    userId?: string;
    docId?: string;
    fileId?: string;
    autoRedactionRuleId?: string | undefined;
    rank?: number;
    x?: number;
    y?: number;
    height?: number;
    width?: number;
    redactionText?: string | undefined;
    redactionColorValue?: string | undefined;
    redactionColorId?: string;
    autoRedactionRule?: AutoRedactionRule;

    constructor(data?: IRedaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redactionId = _data["redactionId"];
            this.userId = _data["userId"];
            this.docId = _data["docId"];
            this.fileId = _data["fileId"];
            this.autoRedactionRuleId = _data["autoRedactionRuleId"];
            this.rank = _data["rank"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.redactionText = _data["redactionText"];
            this.redactionColorValue = _data["redactionColorValue"];
            this.redactionColorId = _data["redactionColorId"];
            this.autoRedactionRule = _data["autoRedactionRule"] ? AutoRedactionRule.fromJS(_data["autoRedactionRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Redaction {
        data = typeof data === 'object' ? data : {};
        let result = new Redaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redactionId"] = this.redactionId;
        data["userId"] = this.userId;
        data["docId"] = this.docId;
        data["fileId"] = this.fileId;
        data["autoRedactionRuleId"] = this.autoRedactionRuleId;
        data["rank"] = this.rank;
        data["x"] = this.x;
        data["y"] = this.y;
        data["height"] = this.height;
        data["width"] = this.width;
        data["redactionText"] = this.redactionText;
        data["redactionColorValue"] = this.redactionColorValue;
        data["redactionColorId"] = this.redactionColorId;
        data["autoRedactionRule"] = this.autoRedactionRule ? this.autoRedactionRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRedaction {
    redactionId?: string;
    userId?: string;
    docId?: string;
    fileId?: string;
    autoRedactionRuleId?: string | undefined;
    rank?: number;
    x?: number;
    y?: number;
    height?: number;
    width?: number;
    redactionText?: string | undefined;
    redactionColorValue?: string | undefined;
    redactionColorId?: string;
    autoRedactionRule?: AutoRedactionRule;
}

export class RedactionAnnotation implements IRedactionAnnotation {
    id?: string;
    userId?: string;
    docId?: string;
    fileId?: string;
    rank?: number;
    x?: number;
    y?: number;
    height?: number;
    width?: number;
    text?: string | undefined;
    highlightColorId?: string | undefined;
    highlightColor?: string | undefined;
    status?: LifeCycleEditStatus;
    autoRedactionRuleId?: string | undefined;
    autoRedactionRule?: AutoRedactionRule;

    constructor(data?: IRedactionAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.docId = _data["docId"];
            this.fileId = _data["fileId"];
            this.rank = _data["rank"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.text = _data["text"];
            this.highlightColorId = _data["highlightColorId"];
            this.highlightColor = _data["highlightColor"];
            this.status = _data["status"];
            this.autoRedactionRuleId = _data["autoRedactionRuleId"];
            this.autoRedactionRule = _data["autoRedactionRule"] ? AutoRedactionRule.fromJS(_data["autoRedactionRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RedactionAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new RedactionAnnotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["docId"] = this.docId;
        data["fileId"] = this.fileId;
        data["rank"] = this.rank;
        data["x"] = this.x;
        data["y"] = this.y;
        data["height"] = this.height;
        data["width"] = this.width;
        data["text"] = this.text;
        data["highlightColorId"] = this.highlightColorId;
        data["highlightColor"] = this.highlightColor;
        data["status"] = this.status;
        data["autoRedactionRuleId"] = this.autoRedactionRuleId;
        data["autoRedactionRule"] = this.autoRedactionRule ? this.autoRedactionRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRedactionAnnotation {
    id?: string;
    userId?: string;
    docId?: string;
    fileId?: string;
    rank?: number;
    x?: number;
    y?: number;
    height?: number;
    width?: number;
    text?: string | undefined;
    highlightColorId?: string | undefined;
    highlightColor?: string | undefined;
    status?: LifeCycleEditStatus;
    autoRedactionRuleId?: string | undefined;
    autoRedactionRule?: AutoRedactionRule;
}

export class RedactionAnnotationCreateImageRequest implements IRedactionAnnotationCreateImageRequest {
    docId?: string;
    isRedaction?: boolean;

    constructor(data?: IRedactionAnnotationCreateImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.isRedaction = _data["isRedaction"];
        }
    }

    static fromJS(data: any): RedactionAnnotationCreateImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RedactionAnnotationCreateImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["isRedaction"] = this.isRedaction;
        return data;
    }
}

export interface IRedactionAnnotationCreateImageRequest {
    docId?: string;
    isRedaction?: boolean;
}

export class RedactionAnnotationCreatePdfRequest implements IRedactionAnnotationCreatePdfRequest {
    docId?: string;
    isRedaction?: boolean;
    edits?: RedactionAnnotation[] | undefined;

    constructor(data?: IRedactionAnnotationCreatePdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docId = _data["docId"];
            this.isRedaction = _data["isRedaction"];
            if (Array.isArray(_data["edits"])) {
                this.edits = [] as any;
                for (let item of _data["edits"])
                    this.edits!.push(RedactionAnnotation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RedactionAnnotationCreatePdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RedactionAnnotationCreatePdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["isRedaction"] = this.isRedaction;
        if (Array.isArray(this.edits)) {
            data["edits"] = [];
            for (let item of this.edits)
                data["edits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRedactionAnnotationCreatePdfRequest {
    docId?: string;
    isRedaction?: boolean;
    edits?: RedactionAnnotation[] | undefined;
}

export enum RedactionStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _60 = 60,
    _64 = 64,
    _65 = 65,
}

export enum ReportDateUnitType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ReportRequest implements IReportRequest {
    caseId?: string;
    currentUserId?: string;
    filter?: string;
    reportType?: ReportType;
    customReportFields?: CustomReportFields;

    constructor(data?: IReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.currentUserId = _data["currentUserId"];
            this.filter = _data["filter"];
            this.reportType = _data["reportType"];
            this.customReportFields = _data["customReportFields"] ? CustomReportFields.fromJS(_data["customReportFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["currentUserId"] = this.currentUserId;
        data["filter"] = this.filter;
        data["reportType"] = this.reportType;
        data["customReportFields"] = this.customReportFields ? this.customReportFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportRequest {
    caseId?: string;
    currentUserId?: string;
    filter?: string;
    reportType?: ReportType;
    customReportFields?: CustomReportFields;
}

export class ReportResponse implements IReportResponse {
    pivotLabel?: string | undefined;
    data?: DataTable;

    constructor(data?: IReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pivotLabel = _data["pivotLabel"];
            this.data = _data["data"] ? DataTable.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pivotLabel"] = this.pivotLabel;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportResponse {
    pivotLabel?: string | undefined;
    data?: DataTable;
}

export enum ReportSumUnitType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ReportType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
}

export class RequestProcessingImageCreationRequest implements IRequestProcessingImageCreationRequest {
    releaseName?: string | undefined;

    constructor(data?: IRequestProcessingImageCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseName = _data["releaseName"];
        }
    }

    static fromJS(data: any): RequestProcessingImageCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestProcessingImageCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseName"] = this.releaseName;
        return data;
    }
}

export interface IRequestProcessingImageCreationRequest {
    releaseName?: string | undefined;
}

export class ResetRequest implements IResetRequest {
    userId?: string | undefined;
    newPassword?: string | undefined;
    oldPassword?: string | undefined;
    resetToken?: string | undefined;
    confirmationCode?: string | undefined;

    constructor(data?: IResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
            this.oldPassword = _data["oldPassword"];
            this.resetToken = _data["resetToken"];
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): ResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        data["oldPassword"] = this.oldPassword;
        data["resetToken"] = this.resetToken;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export interface IResetRequest {
    userId?: string | undefined;
    newPassword?: string | undefined;
    oldPassword?: string | undefined;
    resetToken?: string | undefined;
    confirmationCode?: string | undefined;
}

export class ReviewDoc implements IReviewDoc {
    reviewSetId?: string;
    docId?: string;
    caseId?: string;
    userId?: string | undefined;
    emailFamilyId?: string;
    status?: number;
    reviewOrder?: number;
    reviewSet?: ReviewSet;
    doc?: Doc;

    constructor(data?: IReviewDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewSetId = _data["reviewSetId"];
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.emailFamilyId = _data["emailFamilyId"];
            this.status = _data["status"];
            this.reviewOrder = _data["reviewOrder"];
            this.reviewSet = _data["reviewSet"] ? ReviewSet.fromJS(_data["reviewSet"]) : <any>undefined;
            this.doc = _data["doc"] ? Doc.fromJS(_data["doc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReviewDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewSetId"] = this.reviewSetId;
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["emailFamilyId"] = this.emailFamilyId;
        data["status"] = this.status;
        data["reviewOrder"] = this.reviewOrder;
        data["reviewSet"] = this.reviewSet ? this.reviewSet.toJSON() : <any>undefined;
        data["doc"] = this.doc ? this.doc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReviewDoc {
    reviewSetId?: string;
    docId?: string;
    caseId?: string;
    userId?: string | undefined;
    emailFamilyId?: string;
    status?: number;
    reviewOrder?: number;
    reviewSet?: ReviewSet;
    doc?: Doc;
}

export class ReviewDocView implements IReviewDocView {
    reviewSetId?: string;
    docId?: string;
    caseId?: string;
    userId?: string | undefined;
    emailFamilyId?: string;
    status?: number;
    reviewOrder?: number;
    documentTitle?: string | undefined;
    emailParentId?: string;
    emailTypeId?: string;
    hasChildren?: boolean;
    hasBeenReviewed?: boolean;
    parentDocId?: string;
    validationErrors?: DocumentReviewValidationRuleType[] | undefined;

    constructor(data?: IReviewDocView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewSetId = _data["reviewSetId"];
            this.docId = _data["docId"];
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.emailFamilyId = _data["emailFamilyId"];
            this.status = _data["status"];
            this.reviewOrder = _data["reviewOrder"];
            this.documentTitle = _data["documentTitle"];
            this.emailParentId = _data["emailParentId"];
            this.emailTypeId = _data["emailTypeId"];
            this.hasChildren = _data["hasChildren"];
            this.hasBeenReviewed = _data["hasBeenReviewed"];
            this.parentDocId = _data["parentDocId"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
        }
    }

    static fromJS(data: any): ReviewDocView {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewDocView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewSetId"] = this.reviewSetId;
        data["docId"] = this.docId;
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["emailFamilyId"] = this.emailFamilyId;
        data["status"] = this.status;
        data["reviewOrder"] = this.reviewOrder;
        data["documentTitle"] = this.documentTitle;
        data["emailParentId"] = this.emailParentId;
        data["emailTypeId"] = this.emailTypeId;
        data["hasChildren"] = this.hasChildren;
        data["hasBeenReviewed"] = this.hasBeenReviewed;
        data["parentDocId"] = this.parentDocId;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        return data;
    }
}

export interface IReviewDocView {
    reviewSetId?: string;
    docId?: string;
    caseId?: string;
    userId?: string | undefined;
    emailFamilyId?: string;
    status?: number;
    reviewOrder?: number;
    documentTitle?: string | undefined;
    emailParentId?: string;
    emailTypeId?: string;
    hasChildren?: boolean;
    hasBeenReviewed?: boolean;
    parentDocId?: string;
    validationErrors?: DocumentReviewValidationRuleType[] | undefined;
}

export enum ReviewOrder {
    _0 = 0,
    _1 = 1,
}

export class ReviewSet implements IReviewSet {
    reviewSetId?: string;
    title?: string | undefined;
    caseId?: string;
    lifecycle?: number;
    status?: ReviewSetStatus;
    reviewOrder?: ReviewOrder;
    totalDocuments?: number;
    remainingDocuments?: number;
    reviewedDocuments?: number;
    documentsInReview?: number;
    reviewDocs?: ReviewDoc[] | undefined;

    constructor(data?: IReviewSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewSetId = _data["reviewSetId"];
            this.title = _data["title"];
            this.caseId = _data["caseId"];
            this.lifecycle = _data["lifecycle"];
            this.status = _data["status"];
            this.reviewOrder = _data["reviewOrder"];
            this.totalDocuments = _data["totalDocuments"];
            this.remainingDocuments = _data["remainingDocuments"];
            this.reviewedDocuments = _data["reviewedDocuments"];
            this.documentsInReview = _data["documentsInReview"];
            if (Array.isArray(_data["reviewDocs"])) {
                this.reviewDocs = [] as any;
                for (let item of _data["reviewDocs"])
                    this.reviewDocs!.push(ReviewDoc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReviewSet {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewSetId"] = this.reviewSetId;
        data["title"] = this.title;
        data["caseId"] = this.caseId;
        data["lifecycle"] = this.lifecycle;
        data["status"] = this.status;
        data["reviewOrder"] = this.reviewOrder;
        data["totalDocuments"] = this.totalDocuments;
        data["remainingDocuments"] = this.remainingDocuments;
        data["reviewedDocuments"] = this.reviewedDocuments;
        data["documentsInReview"] = this.documentsInReview;
        if (Array.isArray(this.reviewDocs)) {
            data["reviewDocs"] = [];
            for (let item of this.reviewDocs)
                data["reviewDocs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReviewSet {
    reviewSetId?: string;
    title?: string | undefined;
    caseId?: string;
    lifecycle?: number;
    status?: ReviewSetStatus;
    reviewOrder?: ReviewOrder;
    totalDocuments?: number;
    remainingDocuments?: number;
    reviewedDocuments?: number;
    documentsInReview?: number;
    reviewDocs?: ReviewDoc[] | undefined;
}

export class ReviewSetReportRequest implements IReviewSetReportRequest {
    unit?: number;
    dateUnit?: number;
    filter?: string;

    constructor(data?: IReviewSetReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"];
            this.dateUnit = _data["dateUnit"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ReviewSetReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSetReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["dateUnit"] = this.dateUnit;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IReviewSetReportRequest {
    unit?: number;
    dateUnit?: number;
    filter?: string;
}

export class ReviewSetState implements IReviewSetState {
    reviewSets?: ReviewSetView[] | undefined;
    caseReviewSetCount?: number;
    totalDocCount?: number;

    constructor(data?: IReviewSetState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reviewSets"])) {
                this.reviewSets = [] as any;
                for (let item of _data["reviewSets"])
                    this.reviewSets!.push(ReviewSetView.fromJS(item));
            }
            this.caseReviewSetCount = _data["caseReviewSetCount"];
            this.totalDocCount = _data["totalDocCount"];
        }
    }

    static fromJS(data: any): ReviewSetState {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSetState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reviewSets)) {
            data["reviewSets"] = [];
            for (let item of this.reviewSets)
                data["reviewSets"].push(item.toJSON());
        }
        data["caseReviewSetCount"] = this.caseReviewSetCount;
        data["totalDocCount"] = this.totalDocCount;
        return data;
    }
}

export interface IReviewSetState {
    reviewSets?: ReviewSetView[] | undefined;
    caseReviewSetCount?: number;
    totalDocCount?: number;
}

export enum ReviewSetStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ReviewSetView implements IReviewSetView {
    reviewSetId?: string;
    title?: string | undefined;
    caseId?: string;
    lifecycle?: number;
    status?: ReviewSetStatus;
    reviewOrder?: ReviewOrder;
    totalDocuments?: number;
    remainingDocuments?: number;
    reviewedDocuments?: number;
    documentsInReview?: number;

    constructor(data?: IReviewSetView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewSetId = _data["reviewSetId"];
            this.title = _data["title"];
            this.caseId = _data["caseId"];
            this.lifecycle = _data["lifecycle"];
            this.status = _data["status"];
            this.reviewOrder = _data["reviewOrder"];
            this.totalDocuments = _data["totalDocuments"];
            this.remainingDocuments = _data["remainingDocuments"];
            this.reviewedDocuments = _data["reviewedDocuments"];
            this.documentsInReview = _data["documentsInReview"];
        }
    }

    static fromJS(data: any): ReviewSetView {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSetView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewSetId"] = this.reviewSetId;
        data["title"] = this.title;
        data["caseId"] = this.caseId;
        data["lifecycle"] = this.lifecycle;
        data["status"] = this.status;
        data["reviewOrder"] = this.reviewOrder;
        data["totalDocuments"] = this.totalDocuments;
        data["remainingDocuments"] = this.remainingDocuments;
        data["reviewedDocuments"] = this.reviewedDocuments;
        data["documentsInReview"] = this.documentsInReview;
        return data;
    }
}

export interface IReviewSetView {
    reviewSetId?: string;
    title?: string | undefined;
    caseId?: string;
    lifecycle?: number;
    status?: ReviewSetStatus;
    reviewOrder?: ReviewOrder;
    totalDocuments?: number;
    remainingDocuments?: number;
    reviewedDocuments?: number;
    documentsInReview?: number;
}

export class Role implements IRole {
    id?: string;
    name?: string | undefined;
    users?: User[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRole {
    id?: string;
    name?: string | undefined;
    users?: User[] | undefined;
}

export enum RunStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value?: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value?: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeTypeHandle {
    value?: IntPtr;
}

export class S3CreateUploadInstructionsCommand implements IS3CreateUploadInstructionsCommand {
    requests?: S3PutUrlRequest[] | undefined;

    constructor(data?: IS3CreateUploadInstructionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(S3PutUrlRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): S3CreateUploadInstructionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new S3CreateUploadInstructionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IS3CreateUploadInstructionsCommand {
    requests?: S3PutUrlRequest[] | undefined;
}

export class S3PutUrlRequest implements IS3PutUrlRequest {
    fileSize?: number;
    contentType?: string | undefined;
    sourceFilePath?: string | undefined;
    sourceFileName?: string | undefined;
    ttl?: Date;
    s3Key?: string | undefined;
    bucketName?: string | undefined;

    constructor(data?: IS3PutUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileSize = _data["fileSize"];
            this.contentType = _data["contentType"];
            this.sourceFilePath = _data["sourceFilePath"];
            this.sourceFileName = _data["sourceFileName"];
            this.ttl = _data["ttl"] ? new Date(_data["ttl"].toString()) : <any>undefined;
            this.s3Key = _data["s3Key"];
            this.bucketName = _data["bucketName"];
        }
    }

    static fromJS(data: any): S3PutUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new S3PutUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSize"] = this.fileSize;
        data["contentType"] = this.contentType;
        data["sourceFilePath"] = this.sourceFilePath;
        data["sourceFileName"] = this.sourceFileName;
        data["ttl"] = this.ttl ? this.ttl.toISOString() : <any>undefined;
        data["s3Key"] = this.s3Key;
        data["bucketName"] = this.bucketName;
        return data;
    }
}

export interface IS3PutUrlRequest {
    fileSize?: number;
    contentType?: string | undefined;
    sourceFilePath?: string | undefined;
    sourceFileName?: string | undefined;
    ttl?: Date;
    s3Key?: string | undefined;
    bucketName?: string | undefined;
}

export class SavedSearches implements ISavedSearches {
    searchId?: string;
    createdById?: string;
    caseId?: string;
    title?: string | undefined;
    searchString?: string | undefined;
    readonly conceptSearch?: boolean;
    readonly fuzzySearch?: boolean;
    readonly stemmingSearch?: boolean;
    readonly phonicSearch?: boolean;
    readonly searchType?: string | undefined;
    isPinned?: boolean;
    isShared?: boolean;
    dateTimeCreated?: Date | undefined;
    lifeCycle?: number;

    constructor(data?: ISavedSearches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchId = _data["searchId"];
            this.createdById = _data["createdById"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.searchString = _data["searchString"];
            (<any>this).conceptSearch = _data["conceptSearch"];
            (<any>this).fuzzySearch = _data["fuzzySearch"];
            (<any>this).stemmingSearch = _data["stemmingSearch"];
            (<any>this).phonicSearch = _data["phonicSearch"];
            (<any>this).searchType = _data["searchType"];
            this.isPinned = _data["isPinned"];
            this.isShared = _data["isShared"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.lifeCycle = _data["lifeCycle"];
        }
    }

    static fromJS(data: any): SavedSearches {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchId"] = this.searchId;
        data["createdById"] = this.createdById;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["searchString"] = this.searchString;
        data["conceptSearch"] = this.conceptSearch;
        data["fuzzySearch"] = this.fuzzySearch;
        data["stemmingSearch"] = this.stemmingSearch;
        data["phonicSearch"] = this.phonicSearch;
        data["searchType"] = this.searchType;
        data["isPinned"] = this.isPinned;
        data["isShared"] = this.isShared;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["lifeCycle"] = this.lifeCycle;
        return data;
    }
}

export interface ISavedSearches {
    searchId?: string;
    createdById?: string;
    caseId?: string;
    title?: string | undefined;
    searchString?: string | undefined;
    conceptSearch?: boolean;
    fuzzySearch?: boolean;
    stemmingSearch?: boolean;
    phonicSearch?: boolean;
    searchType?: string | undefined;
    isPinned?: boolean;
    isShared?: boolean;
    dateTimeCreated?: Date | undefined;
    lifeCycle?: number;
}

export class SavedSort implements ISavedSort {
    sortId?: string;
    caseId?: string;
    createdByUserId?: string;
    createdDateTime?: Date;
    displayTitle?: string | undefined;
    sortDetails?: string | undefined;

    constructor(data?: ISavedSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortId = _data["sortId"];
            this.caseId = _data["caseId"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.displayTitle = _data["displayTitle"];
            this.sortDetails = _data["sortDetails"];
        }
    }

    static fromJS(data: any): SavedSort {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortId"] = this.sortId;
        data["caseId"] = this.caseId;
        data["createdByUserId"] = this.createdByUserId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["displayTitle"] = this.displayTitle;
        data["sortDetails"] = this.sortDetails;
        return data;
    }
}

export interface ISavedSort {
    sortId?: string;
    caseId?: string;
    createdByUserId?: string;
    createdDateTime?: Date;
    displayTitle?: string | undefined;
    sortDetails?: string | undefined;
}

export class SavedSortView implements ISavedSortView {
    sortId?: string;
    caseId?: string;
    createdByUserId?: string;
    createdDateTime?: Date;
    displayTitle?: string | undefined;
    sortDetails?: MultiSort;

    constructor(data?: ISavedSortView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortId = _data["sortId"];
            this.caseId = _data["caseId"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.displayTitle = _data["displayTitle"];
            this.sortDetails = _data["sortDetails"] ? MultiSort.fromJS(_data["sortDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SavedSortView {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSortView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortId"] = this.sortId;
        data["caseId"] = this.caseId;
        data["createdByUserId"] = this.createdByUserId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["displayTitle"] = this.displayTitle;
        data["sortDetails"] = this.sortDetails ? this.sortDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISavedSortView {
    sortId?: string;
    caseId?: string;
    createdByUserId?: string;
    createdDateTime?: Date;
    displayTitle?: string | undefined;
    sortDetails?: MultiSort;
}

export enum SchemaSerializationMode {
    _1 = 1,
    _2 = 2,
}

export class SearchMetadata implements ISearchMetadata {
    score?: number;
    synopsis?: string | undefined;

    constructor(data?: ISearchMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.synopsis = _data["synopsis"];
        }
    }

    static fromJS(data: any): SearchMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["synopsis"] = this.synopsis;
        return data;
    }
}

export interface ISearchMetadata {
    score?: number;
    synopsis?: string | undefined;
}

export class SearchParameter implements ISearchParameter {
    searchString?: string | undefined;
    readonly conceptSearch?: boolean;
    readonly fuzzySearch?: boolean;
    readonly stemmingSearch?: boolean;
    readonly phonicSearch?: boolean;
    readonly searchType?: string | undefined;
    engineType?: string | undefined;

    constructor(data?: ISearchParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            (<any>this).conceptSearch = _data["conceptSearch"];
            (<any>this).fuzzySearch = _data["fuzzySearch"];
            (<any>this).stemmingSearch = _data["stemmingSearch"];
            (<any>this).phonicSearch = _data["phonicSearch"];
            (<any>this).searchType = _data["searchType"];
            this.engineType = _data["engineType"];
        }
    }

    static fromJS(data: any): SearchParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["conceptSearch"] = this.conceptSearch;
        data["fuzzySearch"] = this.fuzzySearch;
        data["stemmingSearch"] = this.stemmingSearch;
        data["phonicSearch"] = this.phonicSearch;
        data["searchType"] = this.searchType;
        data["engineType"] = this.engineType;
        return data;
    }
}

export interface ISearchParameter {
    searchString?: string | undefined;
    conceptSearch?: boolean;
    fuzzySearch?: boolean;
    stemmingSearch?: boolean;
    phonicSearch?: boolean;
    searchType?: string | undefined;
    engineType?: string | undefined;
}

export class SearchReport implements ISearchReport {
    searchReportId?: string;
    caseId?: string;
    title?: string | undefined;
    createdById?: string;
    dateTimeCreated?: Date;
    dateTimeRun?: Date;
    runStatus?: SearchReportStatus;
    filterId?: string | undefined;
    _searchParameterJson?: string | undefined;
    searchParameter?: SearchParameter;
    case?: Case;
    searchReportQueries?: SearchReportQuery[] | undefined;

    constructor(data?: ISearchReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchReportId = _data["searchReportId"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeRun = _data["dateTimeRun"] ? new Date(_data["dateTimeRun"].toString()) : <any>undefined;
            this.runStatus = _data["runStatus"];
            this.filterId = _data["filterId"];
            this._searchParameterJson = _data["_searchParameterJson"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            if (Array.isArray(_data["searchReportQueries"])) {
                this.searchReportQueries = [] as any;
                for (let item of _data["searchReportQueries"])
                    this.searchReportQueries!.push(SearchReportQuery.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchReport {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchReportId"] = this.searchReportId;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeRun"] = this.dateTimeRun ? this.dateTimeRun.toISOString() : <any>undefined;
        data["runStatus"] = this.runStatus;
        data["filterId"] = this.filterId;
        data["_searchParameterJson"] = this._searchParameterJson;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        if (Array.isArray(this.searchReportQueries)) {
            data["searchReportQueries"] = [];
            for (let item of this.searchReportQueries)
                data["searchReportQueries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchReport {
    searchReportId?: string;
    caseId?: string;
    title?: string | undefined;
    createdById?: string;
    dateTimeCreated?: Date;
    dateTimeRun?: Date;
    runStatus?: SearchReportStatus;
    filterId?: string | undefined;
    _searchParameterJson?: string | undefined;
    searchParameter?: SearchParameter;
    case?: Case;
    searchReportQueries?: SearchReportQuery[] | undefined;
}

export class SearchReportIdStatus implements ISearchReportIdStatus {
    searchReportId?: string;
    runStatus?: SearchReportStatus;

    constructor(data?: ISearchReportIdStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchReportId = _data["searchReportId"];
            this.runStatus = _data["runStatus"];
        }
    }

    static fromJS(data: any): SearchReportIdStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportIdStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchReportId"] = this.searchReportId;
        data["runStatus"] = this.runStatus;
        return data;
    }
}

export interface ISearchReportIdStatus {
    searchReportId?: string;
    runStatus?: SearchReportStatus;
}

export class SearchReportQuery implements ISearchReportQuery {
    searchReportQueryId?: string;
    searchReportId?: string;
    query?: string | undefined;
    hitCount?: number;
    expandedHitCount?: number;
    uniqueHitCount?: number;
    valid?: boolean;
    searchReport?: SearchReport;

    constructor(data?: ISearchReportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchReportQueryId = _data["searchReportQueryId"];
            this.searchReportId = _data["searchReportId"];
            this.query = _data["query"];
            this.hitCount = _data["hitCount"];
            this.expandedHitCount = _data["expandedHitCount"];
            this.uniqueHitCount = _data["uniqueHitCount"];
            this.valid = _data["valid"];
            this.searchReport = _data["searchReport"] ? SearchReport.fromJS(_data["searchReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchReportQueryId"] = this.searchReportQueryId;
        data["searchReportId"] = this.searchReportId;
        data["query"] = this.query;
        data["hitCount"] = this.hitCount;
        data["expandedHitCount"] = this.expandedHitCount;
        data["uniqueHitCount"] = this.uniqueHitCount;
        data["valid"] = this.valid;
        data["searchReport"] = this.searchReport ? this.searchReport.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchReportQuery {
    searchReportQueryId?: string;
    searchReportId?: string;
    query?: string | undefined;
    hitCount?: number;
    expandedHitCount?: number;
    uniqueHitCount?: number;
    valid?: boolean;
    searchReport?: SearchReport;
}

export class SearchReportQueryBatch implements ISearchReportQueryBatch {
    queries?: SearchReportQuery[] | undefined;

    constructor(data?: ISearchReportQueryBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queries"])) {
                this.queries = [] as any;
                for (let item of _data["queries"])
                    this.queries!.push(SearchReportQuery.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchReportQueryBatch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportQueryBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queries)) {
            data["queries"] = [];
            for (let item of this.queries)
                data["queries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchReportQueryBatch {
    queries?: SearchReportQuery[] | undefined;
}

export class SearchReportQueryViewModel implements ISearchReportQueryViewModel {
    searchReportQueryId?: string;
    searchReportId?: string;
    query?: string | undefined;
    hitCount?: number;
    expandedHitCount?: number;
    uniqueHitCount?: number;
    valid?: boolean;

    constructor(data?: ISearchReportQueryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchReportQueryId = _data["searchReportQueryId"];
            this.searchReportId = _data["searchReportId"];
            this.query = _data["query"];
            this.hitCount = _data["hitCount"];
            this.expandedHitCount = _data["expandedHitCount"];
            this.uniqueHitCount = _data["uniqueHitCount"];
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): SearchReportQueryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportQueryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchReportQueryId"] = this.searchReportQueryId;
        data["searchReportId"] = this.searchReportId;
        data["query"] = this.query;
        data["hitCount"] = this.hitCount;
        data["expandedHitCount"] = this.expandedHitCount;
        data["uniqueHitCount"] = this.uniqueHitCount;
        data["valid"] = this.valid;
        return data;
    }
}

export interface ISearchReportQueryViewModel {
    searchReportQueryId?: string;
    searchReportId?: string;
    query?: string | undefined;
    hitCount?: number;
    expandedHitCount?: number;
    uniqueHitCount?: number;
    valid?: boolean;
}

export enum SearchReportStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SearchReportViewModel implements ISearchReportViewModel {
    searchReportId?: string;
    caseId?: string;
    title?: string | undefined;
    createdById?: string;
    dateTimeCreated?: Date;
    dateTimeRun?: Date;
    runStatus?: SearchReportStatus;
    filterId?: string | undefined;
    searchParameter?: SearchParameter;
    searchReportQueries?: SearchReportQueryViewModel[] | undefined;

    constructor(data?: ISearchReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchReportId = _data["searchReportId"];
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeRun = _data["dateTimeRun"] ? new Date(_data["dateTimeRun"].toString()) : <any>undefined;
            this.runStatus = _data["runStatus"];
            this.filterId = _data["filterId"];
            this.searchParameter = _data["searchParameter"] ? SearchParameter.fromJS(_data["searchParameter"]) : <any>undefined;
            if (Array.isArray(_data["searchReportQueries"])) {
                this.searchReportQueries = [] as any;
                for (let item of _data["searchReportQueries"])
                    this.searchReportQueries!.push(SearchReportQueryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchReportId"] = this.searchReportId;
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeRun"] = this.dateTimeRun ? this.dateTimeRun.toISOString() : <any>undefined;
        data["runStatus"] = this.runStatus;
        data["filterId"] = this.filterId;
        data["searchParameter"] = this.searchParameter ? this.searchParameter.toJSON() : <any>undefined;
        if (Array.isArray(this.searchReportQueries)) {
            data["searchReportQueries"] = [];
            for (let item of this.searchReportQueries)
                data["searchReportQueries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchReportViewModel {
    searchReportId?: string;
    caseId?: string;
    title?: string | undefined;
    createdById?: string;
    dateTimeCreated?: Date;
    dateTimeRun?: Date;
    runStatus?: SearchReportStatus;
    filterId?: string | undefined;
    searchParameter?: SearchParameter;
    searchReportQueries?: SearchReportQueryViewModel[] | undefined;
}

export enum SecurityRuleSet {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum SerializationFormat {
    _0 = 0,
    _1 = 1,
}

export class ServerConfig implements IServerConfig {
    configId?: string;
    name?: string | undefined;
    value?: string | undefined;
    rank?: number;

    constructor(data?: IServerConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configId = _data["configId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): ServerConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ServerConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configId"] = this.configId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["rank"] = this.rank;
        return data;
    }
}

export interface IServerConfig {
    configId?: string;
    name?: string | undefined;
    value?: string | undefined;
    rank?: number;
}

export class ServiceIdentifier implements IServiceIdentifier {
    serviceName?: string | undefined;
    clusterName?: string | undefined;

    constructor(data?: IServiceIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.clusterName = _data["clusterName"];
        }
    }

    static fromJS(data: any): ServiceIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["clusterName"] = this.clusterName;
        return data;
    }
}

export interface IServiceIdentifier {
    serviceName?: string | undefined;
    clusterName?: string | undefined;
}

export class ShardViewModel implements IShardViewModel {
    shard?: number;
    isPrimary?: boolean;
    bytesSize?: number;

    constructor(data?: IShardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shard = _data["shard"];
            this.isPrimary = _data["isPrimary"];
            this.bytesSize = _data["bytesSize"];
        }
    }

    static fromJS(data: any): ShardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shard"] = this.shard;
        data["isPrimary"] = this.isPrimary;
        data["bytesSize"] = this.bytesSize;
        return data;
    }
}

export interface IShardViewModel {
    shard?: number;
    isPrimary?: boolean;
    bytesSize?: number;
}

export class SharedExport implements ISharedExport {
    id?: string;
    caseId?: string;
    exportId?: string;
    exportType?: string | undefined;
    createdBy?: string;
    createdAt?: Date;
    passwordHash?: string | undefined;
    expires?: Date | undefined;
    lifeCycle?: number;

    constructor(data?: ISharedExport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.exportId = _data["exportId"];
            this.exportType = _data["exportType"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.passwordHash = _data["passwordHash"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.lifeCycle = _data["lifeCycle"];
        }
    }

    static fromJS(data: any): SharedExport {
        data = typeof data === 'object' ? data : {};
        let result = new SharedExport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["exportId"] = this.exportId;
        data["exportType"] = this.exportType;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["passwordHash"] = this.passwordHash;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["lifeCycle"] = this.lifeCycle;
        return data;
    }
}

export interface ISharedExport {
    id?: string;
    caseId?: string;
    exportId?: string;
    exportType?: string | undefined;
    createdBy?: string;
    createdAt?: Date;
    passwordHash?: string | undefined;
    expires?: Date | undefined;
    lifeCycle?: number;
}

export class SharedExportRequestVerificationCodeRequest implements ISharedExportRequestVerificationCodeRequest {
    caseId?: string;
    productionJobId?: string;
    email?: string | undefined;

    constructor(data?: ISharedExportRequestVerificationCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.productionJobId = _data["productionJobId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SharedExportRequestVerificationCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SharedExportRequestVerificationCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["productionJobId"] = this.productionJobId;
        data["email"] = this.email;
        return data;
    }
}

export interface ISharedExportRequestVerificationCodeRequest {
    caseId?: string;
    productionJobId?: string;
    email?: string | undefined;
}

export class SharedExportVerifyCodeRequest implements ISharedExportVerifyCodeRequest {
    productionJobId?: string;
    caseId?: string;
    email?: string | undefined;
    verificationCode?: string | undefined;

    constructor(data?: ISharedExportVerifyCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionJobId = _data["productionJobId"];
            this.caseId = _data["caseId"];
            this.email = _data["email"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): SharedExportVerifyCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SharedExportVerifyCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionJobId"] = this.productionJobId;
        data["caseId"] = this.caseId;
        data["email"] = this.email;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface ISharedExportVerifyCodeRequest {
    productionJobId?: string;
    caseId?: string;
    email?: string | undefined;
    verificationCode?: string | undefined;
}

export class SharedProductionAccessRequest implements ISharedProductionAccessRequest {
    productionJobId?: string;
    sharedProductionJobId?: string;
    password?: string | undefined;
    emailAddress?: string | undefined;
    userId?: string;
    part?: string | undefined;

    constructor(data?: ISharedProductionAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionJobId = _data["productionJobId"];
            this.sharedProductionJobId = _data["sharedProductionJobId"];
            this.password = _data["password"];
            this.emailAddress = _data["emailAddress"];
            this.userId = _data["userId"];
            this.part = _data["part"];
        }
    }

    static fromJS(data: any): SharedProductionAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SharedProductionAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionJobId"] = this.productionJobId;
        data["sharedProductionJobId"] = this.sharedProductionJobId;
        data["password"] = this.password;
        data["emailAddress"] = this.emailAddress;
        data["userId"] = this.userId;
        data["part"] = this.part;
        return data;
    }
}

export interface ISharedProductionAccessRequest {
    productionJobId?: string;
    sharedProductionJobId?: string;
    password?: string | undefined;
    emailAddress?: string | undefined;
    userId?: string;
    part?: string | undefined;
}

export class Shortcut implements IShortcut {
    altKey?: boolean;
    ctrlKey?: boolean;
    shiftKey?: boolean;
    metaKey?: boolean;
    code?: string | undefined;

    constructor(data?: IShortcut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.altKey = _data["altKey"];
            this.ctrlKey = _data["ctrlKey"];
            this.shiftKey = _data["shiftKey"];
            this.metaKey = _data["metaKey"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Shortcut {
        data = typeof data === 'object' ? data : {};
        let result = new Shortcut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["altKey"] = this.altKey;
        data["ctrlKey"] = this.ctrlKey;
        data["shiftKey"] = this.shiftKey;
        data["metaKey"] = this.metaKey;
        data["code"] = this.code;
        return data;
    }
}

export interface IShortcut {
    altKey?: boolean;
    ctrlKey?: boolean;
    shiftKey?: boolean;
    metaKey?: boolean;
    code?: string | undefined;
}

export class SmartFeaturePromptContinueRequest implements ISmartFeaturePromptContinueRequest {
    aiMetadataId?: string;
    isRetry?: boolean;

    constructor(data?: ISmartFeaturePromptContinueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aiMetadataId = _data["aiMetadataId"];
            this.isRetry = _data["isRetry"];
        }
    }

    static fromJS(data: any): SmartFeaturePromptContinueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SmartFeaturePromptContinueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aiMetadataId"] = this.aiMetadataId;
        data["isRetry"] = this.isRetry;
        return data;
    }
}

export interface ISmartFeaturePromptContinueRequest {
    aiMetadataId?: string;
    isRetry?: boolean;
}

export class SmartFeaturePromptRequest implements ISmartFeaturePromptRequest {
    externalAppId?: string;
    aiModel?: string | undefined;
    docIds?: string[] | undefined;
    promptId?: string;

    constructor(data?: ISmartFeaturePromptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalAppId = _data["externalAppId"];
            this.aiModel = _data["aiModel"];
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.promptId = _data["promptId"];
        }
    }

    static fromJS(data: any): SmartFeaturePromptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SmartFeaturePromptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalAppId"] = this.externalAppId;
        data["aiModel"] = this.aiModel;
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["promptId"] = this.promptId;
        return data;
    }
}

export interface ISmartFeaturePromptRequest {
    externalAppId?: string;
    aiModel?: string | undefined;
    docIds?: string[] | undefined;
    promptId?: string;
}

export class SmartFeatureRequest implements ISmartFeatureRequest {
    externalAppId?: string;
    prompt?: string | undefined;

    constructor(data?: ISmartFeatureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalAppId = _data["externalAppId"];
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): SmartFeatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SmartFeatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalAppId"] = this.externalAppId;
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface ISmartFeatureRequest {
    externalAppId?: string;
    prompt?: string | undefined;
}

export class SmartFeatureSummaryRequest implements ISmartFeatureSummaryRequest {
    externalAppId?: string;
    aiModel?: string | undefined;
    promptId?: string;
    docId?: string;
    reviewSetId?: string;
    reviewOrder?: number;

    constructor(data?: ISmartFeatureSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalAppId = _data["externalAppId"];
            this.aiModel = _data["aiModel"];
            this.promptId = _data["promptId"];
            this.docId = _data["docId"];
            this.reviewSetId = _data["reviewSetId"];
            this.reviewOrder = _data["reviewOrder"];
        }
    }

    static fromJS(data: any): SmartFeatureSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SmartFeatureSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalAppId"] = this.externalAppId;
        data["aiModel"] = this.aiModel;
        data["promptId"] = this.promptId;
        data["docId"] = this.docId;
        data["reviewSetId"] = this.reviewSetId;
        data["reviewOrder"] = this.reviewOrder;
        return data;
    }
}

export interface ISmartFeatureSummaryRequest {
    externalAppId?: string;
    aiModel?: string | undefined;
    promptId?: string;
    docId?: string;
    reviewSetId?: string;
    reviewOrder?: number;
}

export class Sort implements ISort {
    fieldId?: string | undefined;
    direction?: SortDirection;

    constructor(data?: ISort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): Sort {
        data = typeof data === 'object' ? data : {};
        let result = new Sort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["direction"] = this.direction;
        return data;
    }
}

export interface ISort {
    fieldId?: string | undefined;
    direction?: SortDirection;
}

export enum SortDirection {
    _0 = 0,
    _1 = 1,
}

export class SortVersion implements ISortVersion {
    fullVersion?: number;
    sortId?: string;

    constructor(data?: ISortVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullVersion = _data["fullVersion"];
            this.sortId = _data["sortId"];
        }
    }

    static fromJS(data: any): SortVersion {
        data = typeof data === 'object' ? data : {};
        let result = new SortVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullVersion"] = this.fullVersion;
        data["sortId"] = this.sortId;
        return data;
    }
}

export interface ISortVersion {
    fullVersion?: number;
    sortId?: string;
}

export class SplitDocument implements ISplitDocument {
    id?: string;
    title?: string | undefined;
    emailType?: LexbeEmailType;

    constructor(data?: ISplitDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.emailType = _data["emailType"] ? LexbeEmailType.fromJS(_data["emailType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SplitDocument {
        data = typeof data === 'object' ? data : {};
        let result = new SplitDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["emailType"] = this.emailType ? this.emailType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISplitDocument {
    id?: string;
    title?: string | undefined;
    emailType?: LexbeEmailType;
}

export class SplitDocumentState implements ISplitDocumentState {
    children?: SplitDocument[] | undefined;
    self?: SplitDocument;
    parent?: SplitDocument;

    constructor(data?: ISplitDocumentState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(SplitDocument.fromJS(item));
            }
            this.self = _data["self"] ? SplitDocument.fromJS(_data["self"]) : <any>undefined;
            this.parent = _data["parent"] ? SplitDocument.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SplitDocumentState {
        data = typeof data === 'object' ? data : {};
        let result = new SplitDocumentState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["self"] = this.self ? this.self.toJSON() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISplitDocumentState {
    children?: SplitDocument[] | undefined;
    self?: SplitDocument;
    parent?: SplitDocument;
}

export class SplitReviewSetRequest implements ISplitReviewSetRequest {
    reviewSetId?: string;
    numOfBatches?: number;

    constructor(data?: ISplitReviewSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewSetId = _data["reviewSetId"];
            this.numOfBatches = _data["numOfBatches"];
        }
    }

    static fromJS(data: any): SplitReviewSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SplitReviewSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewSetId"] = this.reviewSetId;
        data["numOfBatches"] = this.numOfBatches;
        return data;
    }
}

export interface ISplitReviewSetRequest {
    reviewSetId?: string;
    numOfBatches?: number;
}

export class StepActionRequest implements IStepActionRequest {
    stepActionType?: StepActionType;
    stepId?: string;

    constructor(data?: IStepActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepActionType = _data["stepActionType"];
            this.stepId = _data["stepId"];
        }
    }

    static fromJS(data: any): StepActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StepActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepActionType"] = this.stepActionType;
        data["stepId"] = this.stepId;
        return data;
    }
}

export interface IStepActionRequest {
    stepActionType?: StepActionType;
    stepId?: string;
}

export enum StepActionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class StepRequest implements IStepRequest {
    stepFunctionType?: ProcessingStepFunctionType;
    stepParams?: { [key: string]: any; } | undefined;

    constructor(data?: IStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepFunctionType = _data["stepFunctionType"];
            if (_data["stepParams"]) {
                this.stepParams = {} as any;
                for (let key in _data["stepParams"]) {
                    if (_data["stepParams"].hasOwnProperty(key))
                        (<any>this.stepParams)![key] = _data["stepParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): StepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepFunctionType"] = this.stepFunctionType;
        if (this.stepParams) {
            data["stepParams"] = {};
            for (let key in this.stepParams) {
                if (this.stepParams.hasOwnProperty(key))
                    (<any>data["stepParams"])[key] = (<any>this.stepParams)[key];
            }
        }
        return data;
    }
}

export interface IStepRequest {
    stepFunctionType?: ProcessingStepFunctionType;
    stepParams?: { [key: string]: any; } | undefined;
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId?: any | undefined;
    value?: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }
}

export interface IStructLayoutAttribute {
    typeId?: any | undefined;
    value?: LayoutKind;
}

export class TabState implements ITabState {
    userId?: string;
    tabId?: string;
    tabIndex?: number;

    constructor(data?: ITabState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tabId = _data["tabId"];
            this.tabIndex = _data["tabIndex"];
        }
    }

    static fromJS(data: any): TabState {
        data = typeof data === 'object' ? data : {};
        let result = new TabState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tabId"] = this.tabId;
        data["tabIndex"] = this.tabIndex;
        return data;
    }
}

export interface ITabState {
    userId?: string;
    tabId?: string;
    tabIndex?: number;
}

export class TelemetryEvent implements ITelemetryEvent {
    name?: string | undefined;
    context?: { [key: string]: any; } | undefined;
    type?: TelemetryEventType;

    constructor(data?: ITelemetryEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key];
                }
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TelemetryEvent {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        data["type"] = this.type;
        return data;
    }
}

export interface ITelemetryEvent {
    name?: string | undefined;
    context?: { [key: string]: any; } | undefined;
    type?: TelemetryEventType;
}

export enum TelemetryEventType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class TextInfo implements ITextInfo {
    readonly ansiCodePage?: number;
    readonly oemCodePage?: number;
    readonly macCodePage?: number;
    readonly ebcdicCodePage?: number;
    readonly lcid?: number;
    readonly cultureName?: string | undefined;
    readonly isReadOnly?: boolean;
    listSeparator?: string | undefined;
    readonly isRightToLeft?: boolean;

    constructor(data?: ITextInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ansiCodePage = _data["ansiCodePage"];
            (<any>this).oemCodePage = _data["oemCodePage"];
            (<any>this).macCodePage = _data["macCodePage"];
            (<any>this).ebcdicCodePage = _data["ebcdicCodePage"];
            (<any>this).lcid = _data["lcid"];
            (<any>this).cultureName = _data["cultureName"];
            (<any>this).isReadOnly = _data["isReadOnly"];
            this.listSeparator = _data["listSeparator"];
            (<any>this).isRightToLeft = _data["isRightToLeft"];
        }
    }

    static fromJS(data: any): TextInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TextInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ansiCodePage"] = this.ansiCodePage;
        data["oemCodePage"] = this.oemCodePage;
        data["macCodePage"] = this.macCodePage;
        data["ebcdicCodePage"] = this.ebcdicCodePage;
        data["lcid"] = this.lcid;
        data["cultureName"] = this.cultureName;
        data["isReadOnly"] = this.isReadOnly;
        data["listSeparator"] = this.listSeparator;
        data["isRightToLeft"] = this.isRightToLeft;
        return data;
    }
}

export interface ITextInfo {
    ansiCodePage?: number;
    oemCodePage?: number;
    macCodePage?: number;
    ebcdicCodePage?: number;
    lcid?: number;
    cultureName?: string | undefined;
    isReadOnly?: boolean;
    listSeparator?: string | undefined;
    isRightToLeft?: boolean;
}

export class Type implements IType {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly isFunctionPointer?: boolean;
    readonly isUnmanagedFunctionPointer?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).isFunctionPointer = _data["isFunctionPointer"];
            (<any>this).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IType {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    isFunctionPointer?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
}

export enum TypeAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _24 = 24,
    _32 = 32,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _65536 = 65536,
    _131072 = 131072,
    _196608 = 196608,
    _262144 = 262144,
    _264192 = 264192,
    _1048576 = 1048576,
    _12582912 = 12582912,
}

export class TypeInfo implements ITypeInfo {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly isFunctionPointer?: boolean;
    readonly isUnmanagedFunctionPointer?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;
    readonly genericTypeParameters?: Type[] | undefined;
    readonly declaredConstructors?: ConstructorInfo[] | undefined;
    readonly declaredEvents?: EventInfo[] | undefined;
    readonly declaredFields?: FieldInfo[] | undefined;
    readonly declaredMembers?: MemberInfo[] | undefined;
    readonly declaredMethods?: MethodInfo[] | undefined;
    readonly declaredNestedTypes?: TypeInfo[] | undefined;
    readonly declaredProperties?: PropertyInfo[] | undefined;
    readonly implementedInterfaces?: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).isFunctionPointer = _data["isFunctionPointer"];
            (<any>this).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (<any>this).genericTypeParameters!.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (<any>this).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (<any>this).declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (<any>this).declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (<any>this).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (<any>this).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (<any>this).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (<any>this).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (<any>this).implementedInterfaces!.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeInfo {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    isFunctionPointer?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
    genericTypeParameters?: Type[] | undefined;
    declaredConstructors?: ConstructorInfo[] | undefined;
    declaredEvents?: EventInfo[] | undefined;
    declaredFields?: FieldInfo[] | undefined;
    declaredMembers?: MemberInfo[] | undefined;
    declaredMethods?: MethodInfo[] | undefined;
    declaredNestedTypes?: TypeInfo[] | undefined;
    declaredProperties?: PropertyInfo[] | undefined;
    implementedInterfaces?: Type[] | undefined;
}

export class UpdateCloudFrontRequest implements IUpdateCloudFrontRequest {
    distributionId?: string | undefined;
    originId?: string | undefined;
    releasePath?: string | undefined;

    constructor(data?: IUpdateCloudFrontRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distributionId = _data["distributionId"];
            this.originId = _data["originId"];
            this.releasePath = _data["releasePath"];
        }
    }

    static fromJS(data: any): UpdateCloudFrontRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCloudFrontRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distributionId"] = this.distributionId;
        data["originId"] = this.originId;
        data["releasePath"] = this.releasePath;
        return data;
    }
}

export interface IUpdateCloudFrontRequest {
    distributionId?: string | undefined;
    originId?: string | undefined;
    releasePath?: string | undefined;
}

export class UploadBatch implements IUploadBatch {
    uploadBatchId?: string;
    uploadBatchTypeId?: string;
    uploadBatchSource?: UploadBatchSource;
    batchTitle?: string | undefined;
    batchComments?: string | undefined;
    caseId?: string;
    userId?: string;
    custodianId?: string;
    isOcrOnServer?: boolean;
    isUploadToAmazonS3?: boolean;
    docSource?: string | undefined;
    utcOffset?: number;
    uploadBatchDate?: Date;
    isCreateFolders?: boolean;
    lifeCycle?: number;
    validationStatus?: UploadBatchValidationStatus;
    docCount?: number;
    case?: Case;
    custodian?: Custodian;
    user?: User;
    metadata?: DatMapMetadata;

    constructor(data?: IUploadBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadBatchId = _data["uploadBatchId"];
            this.uploadBatchTypeId = _data["uploadBatchTypeId"];
            this.uploadBatchSource = _data["uploadBatchSource"];
            this.batchTitle = _data["batchTitle"];
            this.batchComments = _data["batchComments"];
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.custodianId = _data["custodianId"];
            this.isOcrOnServer = _data["isOcrOnServer"];
            this.isUploadToAmazonS3 = _data["isUploadToAmazonS3"];
            this.docSource = _data["docSource"];
            this.utcOffset = _data["utcOffset"];
            this.uploadBatchDate = _data["uploadBatchDate"] ? new Date(_data["uploadBatchDate"].toString()) : <any>undefined;
            this.isCreateFolders = _data["isCreateFolders"];
            this.lifeCycle = _data["lifeCycle"];
            this.validationStatus = _data["validationStatus"];
            this.docCount = _data["docCount"];
            this.case = _data["case"] ? Case.fromJS(_data["case"]) : <any>undefined;
            this.custodian = _data["custodian"] ? Custodian.fromJS(_data["custodian"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.metadata = _data["metadata"] ? DatMapMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadBatch {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadBatchId"] = this.uploadBatchId;
        data["uploadBatchTypeId"] = this.uploadBatchTypeId;
        data["uploadBatchSource"] = this.uploadBatchSource;
        data["batchTitle"] = this.batchTitle;
        data["batchComments"] = this.batchComments;
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["custodianId"] = this.custodianId;
        data["isOcrOnServer"] = this.isOcrOnServer;
        data["isUploadToAmazonS3"] = this.isUploadToAmazonS3;
        data["docSource"] = this.docSource;
        data["utcOffset"] = this.utcOffset;
        data["uploadBatchDate"] = this.uploadBatchDate ? this.uploadBatchDate.toISOString() : <any>undefined;
        data["isCreateFolders"] = this.isCreateFolders;
        data["lifeCycle"] = this.lifeCycle;
        data["validationStatus"] = this.validationStatus;
        data["docCount"] = this.docCount;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        data["custodian"] = this.custodian ? this.custodian.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadBatch {
    uploadBatchId?: string;
    uploadBatchTypeId?: string;
    uploadBatchSource?: UploadBatchSource;
    batchTitle?: string | undefined;
    batchComments?: string | undefined;
    caseId?: string;
    userId?: string;
    custodianId?: string;
    isOcrOnServer?: boolean;
    isUploadToAmazonS3?: boolean;
    docSource?: string | undefined;
    utcOffset?: number;
    uploadBatchDate?: Date;
    isCreateFolders?: boolean;
    lifeCycle?: number;
    validationStatus?: UploadBatchValidationStatus;
    docCount?: number;
    case?: Case;
    custodian?: Custodian;
    user?: User;
    metadata?: DatMapMetadata;
}

export class UploadBatchModel implements IUploadBatchModel {
    id?: string;

    constructor(data?: IUploadBatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UploadBatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUploadBatchModel {
    id?: string;
}

export enum UploadBatchSource {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UploadBatchState implements IUploadBatchState {
    uploadBatches?: UploadBatchViewModel[] | undefined;
    caseUploadBatchCount?: number;
    totalDocCount?: number;

    constructor(data?: IUploadBatchState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uploadBatches"])) {
                this.uploadBatches = [] as any;
                for (let item of _data["uploadBatches"])
                    this.uploadBatches!.push(UploadBatchViewModel.fromJS(item));
            }
            this.caseUploadBatchCount = _data["caseUploadBatchCount"];
            this.totalDocCount = _data["totalDocCount"];
        }
    }

    static fromJS(data: any): UploadBatchState {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBatchState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uploadBatches)) {
            data["uploadBatches"] = [];
            for (let item of this.uploadBatches)
                data["uploadBatches"].push(item.toJSON());
        }
        data["caseUploadBatchCount"] = this.caseUploadBatchCount;
        data["totalDocCount"] = this.totalDocCount;
        return data;
    }
}

export interface IUploadBatchState {
    uploadBatches?: UploadBatchViewModel[] | undefined;
    caseUploadBatchCount?: number;
    totalDocCount?: number;
}

export enum UploadBatchValidationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class UploadBatchViewModel implements IUploadBatchViewModel {
    uploadBatchId?: string;
    uploadBatchTypeId?: string;
    batchTitle?: string | undefined;
    batchComments?: string | undefined;
    caseId?: string;
    userId?: string;
    custodianId?: string;
    isOcrOnServer?: boolean;
    isUploadToAmazonS3?: boolean;
    docSource?: string | undefined;
    utcOffset?: number;
    uploadBatchDate?: Date;
    isCreateFolders?: boolean;
    lifeCycle?: number;
    validationStatus?: UploadBatchValidationStatus;
    docCount?: number;
    custodian?: Custodian;
    user?: User;

    constructor(data?: IUploadBatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadBatchId = _data["uploadBatchId"];
            this.uploadBatchTypeId = _data["uploadBatchTypeId"];
            this.batchTitle = _data["batchTitle"];
            this.batchComments = _data["batchComments"];
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.custodianId = _data["custodianId"];
            this.isOcrOnServer = _data["isOcrOnServer"];
            this.isUploadToAmazonS3 = _data["isUploadToAmazonS3"];
            this.docSource = _data["docSource"];
            this.utcOffset = _data["utcOffset"];
            this.uploadBatchDate = _data["uploadBatchDate"] ? new Date(_data["uploadBatchDate"].toString()) : <any>undefined;
            this.isCreateFolders = _data["isCreateFolders"];
            this.lifeCycle = _data["lifeCycle"];
            this.validationStatus = _data["validationStatus"];
            this.docCount = _data["docCount"];
            this.custodian = _data["custodian"] ? Custodian.fromJS(_data["custodian"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadBatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadBatchId"] = this.uploadBatchId;
        data["uploadBatchTypeId"] = this.uploadBatchTypeId;
        data["batchTitle"] = this.batchTitle;
        data["batchComments"] = this.batchComments;
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["custodianId"] = this.custodianId;
        data["isOcrOnServer"] = this.isOcrOnServer;
        data["isUploadToAmazonS3"] = this.isUploadToAmazonS3;
        data["docSource"] = this.docSource;
        data["utcOffset"] = this.utcOffset;
        data["uploadBatchDate"] = this.uploadBatchDate ? this.uploadBatchDate.toISOString() : <any>undefined;
        data["isCreateFolders"] = this.isCreateFolders;
        data["lifeCycle"] = this.lifeCycle;
        data["validationStatus"] = this.validationStatus;
        data["docCount"] = this.docCount;
        data["custodian"] = this.custodian ? this.custodian.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadBatchViewModel {
    uploadBatchId?: string;
    uploadBatchTypeId?: string;
    batchTitle?: string | undefined;
    batchComments?: string | undefined;
    caseId?: string;
    userId?: string;
    custodianId?: string;
    isOcrOnServer?: boolean;
    isUploadToAmazonS3?: boolean;
    docSource?: string | undefined;
    utcOffset?: number;
    uploadBatchDate?: Date;
    isCreateFolders?: boolean;
    lifeCycle?: number;
    validationStatus?: UploadBatchValidationStatus;
    docCount?: number;
    custodian?: Custodian;
    user?: User;
}

export class UploadBatchViewModelPagingResponse implements IUploadBatchViewModelPagingResponse {
    value?: UploadBatchViewModel[] | undefined;
    count?: number | undefined;

    constructor(data?: IUploadBatchViewModelPagingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(UploadBatchViewModel.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): UploadBatchViewModelPagingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBatchViewModelPagingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IUploadBatchViewModelPagingResponse {
    value?: UploadBatchViewModel[] | undefined;
    count?: number | undefined;
}

export class User implements IUser {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    createDate?: Date;
    lastLoginDate?: Date;
    lastActivityDate?: Date;
    roles?: Role[] | undefined;
    accounts?: Account[] | undefined;
    cases?: Case[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : <any>undefined;
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(Account.fromJS(item));
            }
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(Case.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>undefined;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUser {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    createDate?: Date;
    lastLoginDate?: Date;
    lastActivityDate?: Date;
    roles?: Role[] | undefined;
    accounts?: Account[] | undefined;
    cases?: Case[] | undefined;
}

export class UserCasePermission implements IUserCasePermission {
    caseId?: string;
    userId?: string;
    isCurrentCase?: boolean;
    createdById?: string;
    dateTimeCreated?: Date;
    case?: LexbeCaseBrief;

    constructor(data?: IUserCasePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.isCurrentCase = _data["isCurrentCase"];
            this.createdById = _data["createdById"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.case = _data["case"] ? LexbeCaseBrief.fromJS(_data["case"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCasePermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserCasePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["isCurrentCase"] = this.isCurrentCase;
        data["createdById"] = this.createdById;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["case"] = this.case ? this.case.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCasePermission {
    caseId?: string;
    userId?: string;
    isCurrentCase?: boolean;
    createdById?: string;
    dateTimeCreated?: Date;
    case?: LexbeCaseBrief;
}

export class UserConfig implements IUserConfig {
    userId?: string;
    userName?: string | undefined;
    currentCase?: LexbeCase;
    userRoles?: string[] | undefined;

    constructor(data?: IUserConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.currentCase = _data["currentCase"] ? LexbeCase.fromJS(_data["currentCase"]) : <any>undefined;
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserConfig {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["currentCase"] = this.currentCase ? this.currentCase.toJSON() : <any>undefined;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        return data;
    }
}

export interface IUserConfig {
    userId?: string;
    userName?: string | undefined;
    currentCase?: LexbeCase;
    userRoles?: string[] | undefined;
}

export class UserExportCommand implements IUserExportCommand {
    userIds?: string[] | undefined;

    constructor(data?: IUserExportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserExportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserExportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface IUserExportCommand {
    userIds?: string[] | undefined;
}

export class UserPreference implements IUserPreference {
    userId?: string;
    tabId?: string;
    tabIndex?: number;

    constructor(data?: IUserPreference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tabId = _data["tabId"];
            this.tabIndex = _data["tabIndex"];
        }
    }

    static fromJS(data: any): UserPreference {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tabId"] = this.tabId;
        data["tabIndex"] = this.tabIndex;
        return data;
    }
}

export interface IUserPreference {
    userId?: string;
    tabId?: string;
    tabIndex?: number;
}

export enum UserType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ValidateMfaRequest implements IValidateMfaRequest {
    mfa?: string | undefined;
    provider?: string | undefined;

    constructor(data?: IValidateMfaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mfa = _data["mfa"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): ValidateMfaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMfaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mfa"] = this.mfa;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IValidateMfaRequest {
    mfa?: string | undefined;
    provider?: string | undefined;
}

export class WorkflowCancellationRequest implements IWorkflowCancellationRequest {
    workflowName?: string | undefined;
    workflowKey?: string | undefined;

    constructor(data?: IWorkflowCancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowName = _data["workflowName"];
            this.workflowKey = _data["workflowKey"];
        }
    }

    static fromJS(data: any): WorkflowCancellationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowCancellationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowName"] = this.workflowName;
        data["workflowKey"] = this.workflowKey;
        return data;
    }
}

export interface IWorkflowCancellationRequest {
    workflowName?: string | undefined;
    workflowKey?: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}